import {
  toFixedPrice,
  getUrlParameter,
  dateFromNow,
  formatAMPM,
  flatUserAddresses,
  flatTrackingOrders,
  flatMenuItems,
  flatLookupsCities,
  flatLookupsAreas,
  flatLookupsZones,
  flatCityAreas,
  flatAreaZones,
  flatLookupsFeatures,
  flatSizes,
  flatDeliveryCategories,
  flatDineoutMoods,
  flatDineoutCategories,
  navBtnHandler,
  pushGoogleAnalyticsEvent,
  pushAnalyticsEvent,
  flatOrderItems,
  counter,
  URLBuilder,
  isRTL,
  updatePhotosURL,
  getUrlSlash,
  buildFiltersURL,
  getCityAreaFromURL,
  validateRestaurantMinOrderValue,
  pushMixpanelEvent,
  orderingFlag,
  isWithinTimeFrame,
  pageReferToSourceScreen,
  pushAnalyticsVariable,
  addClassToElements,
  removeClassFromElements,
  removeClassFromSelector,
  removeElementByClass,
  closestByClass,
  isLoggedInUser,
  mixPanelIdentifyUser
} from './helpers';
import { FlatExtraCategories } from './models/restaurant.model';
import * as moment from "moment";
import EventBus from './eventBus'
import BasketView from './components/basket-view/basket-template.vue';
import RestaurantReviews from './components/restaurant-reviews/RestaurantReviews.vue';
import AppLogin from './components/login/login.vue';
import GiftingFormCheckout from './components/promo/checkout.vue';
import AppSignup from './components/signup/signup.vue';
import PasswordValidation from './components/signup/password-validation.vue';
import RateComp from './components/common/Rate.vue';
import ChangeEmail from './components/change-email/ChangeEmail.vue'
import ChangePassword from './components/change-password/ChangePassword.vue'
import FormFeedback from './components/common/FormFeedback.vue'
import ProfileReviews from './components/profile-reviews/ProfileReviews.vue'
import AddressBook from './components/address-book/AddressBook.vue';
import ReviewCard from './components/review-card/ReviewCard.vue';
import BasketItems from './components/basket-items/basket-items-template.vue';
import BasketItemModal from './components/basket-items/item-modal-template.vue';
import CancelGroup from './components/error-modals/cancel-group.vue';
import selectedCompany from './components/corborate/selected-company.vue';
import leaveGroup from './components/error-modals/leave-group.vue';
import dishFeedback from './components/dish-feedback/dish-feedback-modal.vue';
import ChoosePayment from './components/common/ChoosePayment.vue';
import DeliveryTimePrompt from './components/common/DeliveryTimePrompt.vue';
import AddCreditCard from './components/common/AddCreditCard.vue';
import CreditCardsList from './components/common/CreditCardsList.vue';
import Topup from './components/common/Topup.vue';
import ConfirmationModal from './components/common/ConfirmationModal.vue';
import creditCardVerification from './components/error-modals/verify-credit-card.vue';
import bulkRemoveItems from './components/error-modals/bulk-remove-items.vue';
import ReadMore from 'vue-read-more';
import peopleView from './components/group-view/people-view.vue';
import ReviewStepOne from './components/restaurant-reviews/ReviewStepOne.vue';
import feedBackConfirmation from './components/dish-feedback/feed-back-confirmation.vue'
import myOrdersController from './components/my-orders/my-orders-controller.vue';
import orderDetails from './components/my-orders/order-details.vue';
import orderShare from './components/order-share/order-share.vue';
import resumeOrder from './components/my-orders/resume-order-modal.vue';
import GroupView from './components/group-view/group-template.vue';
import orderReceipt from './components/my-orders/order-receipt.vue';
import currentOrderDetails from './components/my-orders/current-order-details.vue';
import orderMap from './components/my-orders/order-map.vue';
import promoMessage from './components/promo/promo-message.vue'
import StarRating from "vue-star-rating";
import vSelect from 'vue-select'
import trackingBanner from './components/my-orders/tracking-banner.vue';
import AlertModal from './components/error-modals/alert-no-action.vue';
import reOrderModal from './components/modals/reorder-modal.vue';
import dishTinder from './components/dish-tinder/dish-tinder.vue';
import announcemnts from './components/announcements/index.vue';
import dynamicSections from './components/dynamic-section/sections-wrapper.vue';
import RestaurantStatus from './components/restaurant-status/restaurant-status.vue';
import tripWizard from './components/trip-tracking/trip-wizard.vue';
import landingInstallBanner from './components/landing-banner/landing-banner.vue';
import vueNotVisible from 'vue-not-visible'
import axios from 'axios';
import VueLazyload from 'vue-lazyload';
import VueMeta from 'vue-meta'
import RestaurantMenus from './components/restaurant-menus/restaurant-menus.vue';
import RestaurantScripts from './components/restaurant-scripts/RestaurantScripts.vue';
import locationDisclaimer from './components/common/LocationDisclaimer.vue';

import * as _ from 'lodash';
import { Notyf } from 'notyf';

import VueGlide from 'vue-glide-js'

// import {Glider} from 'glider-js';
// import jwt_decode from 'jwt-decode'

const Glider = window['Glider']
const notyf = new Notyf({
  ripple: true,
  duration: 5000, dismissible: true, position: {
    x: 'right', y: 'top'
  }
});
import {
  Vue,
  VeeValidate,
  servicesURL,
  cookies,
  egypt,
  lang,
  photosUrlEnum,
  websitePages,
  filters,
  googleAnalyticsEvents,
  analyticsEvents,
  interComeId,
  apiPrefix,
  headers,
  LocalStorageKeys,
  SourceScreens,
} from './constants/constants';
import { store } from './store/store';
import { serverData } from './data-from-server';
import validationDictionary from './validation-dictionary';
import { staticContent } from './localisation/detect-lang';
import { BasketLoadersEnum, genericErrorsEnum } from './models/basket.model';
import { isRestaurantOpened } from '../../modules/helper';
import Sticky from 'vue-sticky-directive'
import VueObserveVisibility from 'vue-observe-visibility';

// Import the functions you need from the SDKs you need
import { getAnalytics , setUserProperties} from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

import {fetchAndActivate} from "firebase/remote-config";
import {
  firebaseApp,
  getRemoteConfigAsString,
  getRemoteConfigValue,
  remoteConfig,
  ensureRemoteConfigInitialize,
  getRemoteConfigAsBoolean,
  InstallSectionType,
  KEYS
} from "./firebase";
import { analyticsUserProps, pushGoogleAnalytics4Event } from './lib/google-analytics';
import { GA4Events } from './lib/google-analytics/config';


function scripts() {
  const $body = document.body;
  // window["mixpanel"].set_config({persistence: "localStorage"})

  // const gtag = window['gtag'];

  const lightbox = window['lightbox'];
  const navigator = window['navigator']

  var windowWidth = document.documentElement.clientWidth;
  removeElementByClass('remove-after-load')
  let filterAjaxCall = null;
  // let groupOrderingTourCount=5;  // how many time should I repeat group ordering tour
  // let groupOrderingTourPeriod=3; // after how many days should I repeat group ordering tour

  const staticPages = ['/about-us', '/terms', '/privacy', '/driver-privacy', '/careers', '/settings', '/404', '/myorders'];

  const cityAreaUUIDsFromURL = getCityAreaFromURL(window.location.pathname, serverData.lookups);
  var map;
  var autocomplete
  //var infoWindow;
  //var geocoder;
  let formattedAddress = null;
  const data = {
    tinderDishes: false,
    dishGameState: '/dishGame',
    tinderEntryPoint: true,
    options: [
      'foo',
      'bar',
      'baz'
    ],
    moment: moment,
    deliveryDishesViewCount: 7,
    groupPageGroupUUID: null,
    isGroupOrderPage: false,
    groupLangUrl: null,
    groupPageAreaUUID: null,
    basketLoadersEnum: BasketLoadersEnum,
    urlAreaUUID: serverData.urlAreaUUID,
    URLBuilder,
    isRTL,
    staticContent,
    genericErrorsEnum,
    photosUrlEnum: photosUrlEnum,
    xTracking: {
      page: serverData.xTracking ? [serverData.xTracking] : null,
      autocomplete: null
    },
    mixpanelEvents: {
      viewRestaurant: {
        event: 'Screen: View Restaurant',
        properties: (
          restaurantName,
          sourceScreen,
          paymentFlag,
          orderingFlag,
          promoFlag,
          area,
          areaEnabledFlag
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "SourceScreen": sourceScreen,
            "Payment Flag": paymentFlag,
            "Ordering Flag": orderingFlag,
            "Promo Flag": promoFlag,
            "Area": area,
            "Area Enabled Flag": areaEnabledFlag
          }
        }
      },
      restaurantTextMenu: {
        event: 'Screen: Restaurant Text Menu',
        isPushed: false,
        properties: (
          restaurantName,
          area
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "Area": area
          }
        }
      },
      callRestaurant: {
        event: 'Action: Call Restaurant',
        properties: (
          restaurantName,
          area,
          areaEnabledFlag
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "Area": area,
            "Area Enabled Flag": areaEnabledFlag
          }
        }
      },
      clickRestaurant: {
        event: 'Action: Clicked on Restaurant',
        properties: (
          restaurantName,
          area,
          position,
          sourceScreen
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "Area": area,
            "Position": position,
            "SourceScreen": sourceScreen
          }
        }
      },
      openItemDetails: {
        event: 'Action: Open Item Details',
        properties: (
          restaurantName,
          area,
          restaurantOrderingFlag
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "Restaurant Enabled Flag": restaurantOrderingFlag,
            "Area": area,
          }
        }
      },
      addItemToBasket: {
        event: 'Action: Add Item to Basket',
        properties: (
          restaurantName,
          isGuest
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "Guest Flag": isGuest,

          }
        }
      },
      addItemToBasketSuccess: {
        event: 'Action: Add Item to Basket - Success',
        properties: (
          restaurantName,
          area,
          numberOfItemsAdded,
          zonePromptFlag,
          basketType,
          userType
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "Area": area,
            "No. of items added": numberOfItemsAdded,
            "Zone Prompt Flag": zonePromptFlag,
            "Basket Type": basketType,
            "User Type": userType
          }
        }
      },
      firstItemPrompt: {
        event: 'Add First Item Prompt',
        properties: (
          restaurantName
        ) => {
          return {
            "Restaurant Name": restaurantName
          }
        }
      },
      mainCheckoutScreen: {
        event: 'Screen: Main Checkout Screen',
        properties: (
          restaurantName,
          area,
          basketType,
          hasServiceFees,
          serviceFees
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "Area": area,
            "Basket Type": basketType,
            "With Service Fees": hasServiceFees,
            "Service Fees": serviceFees
          }
        }
      },
      addAddress: {
        event: 'Screen: Add Address',
        properties: (
          sourceScreen
        ) => {
          return {
            "SourceScreen": sourceScreen
          }
        }
      },
      redeemPromo: {
        event: 'Action: Redeem Promo',
        properties: (
          promoName
        ) => {
          return {
            "Promo Name": promoName
          }
        }
      },
      phoneVerification: {
        event: 'Screen: Phone Verification',
        properties: (
          userNumber
        ) => {
          return {
            "User Number": userNumber
          }
        }
      },
      placeOrder: {
        event: 'Action: Place Order - Success',
        properties: (
          restaurantName,
          paymentType,
          promoName,
          newOrReturning,
          orderValue,
          addressArea,
          promoValue,
          promoDiscount,
          isFirstOrder,
          basketType,
          isFleet,
          deliveryFees,
          checkoutEDT,
          hasServiceFees,
          serviceFees
        ) => {
          return {
            "Restaurant Name": restaurantName,
            "Payment Type": paymentType,
            "Promo Name": promoName,
            "Order Value": orderValue,
            "Address Area": addressArea,
            "Promo Value": promoValue,
            "Promo Discount": promoDiscount,
            "First Order": isFirstOrder,
            "Basket Type": basketType,
            "Fleet Flag":isFleet,
            "Delivery Fees": deliveryFees,
            "EDT": checkoutEDT,
            "With Service Fees": hasServiceFees,
            "Service Fees": serviceFees,
          }
        }
      },
      orderRejected: {
        event: 'Action: Order Rejected',
        properties: (
          rejectionReason
        ) => {
          return {
            "Rejection Reason": rejectionReason
          }
        }
      },
      closeZonePrompt: {
        event: 'Action: Close Zone Prompt',
        properties: (
          RestaurantName
        ) => {
          return {
            key: 'Restaurant Name',
            value: RestaurantName
          }
        }
      },
      discoveryDelivery: {
        event: 'Screen: Discovery_Delivery',
        properties: (
          area,
          newOrReturning,
          areaEnabledFlag
        ) => {
          return {
            "Area": area,
            "New/Returning User": newOrReturning,
            "Area Enabled Flag": areaEnabledFlag
          }
        }
      },
      dishDiscovery: {
        event: 'Screen: Dish Discovery',
        properties: (
          dishTag,
          area
        ) => {
          return {
            "Dish tag": dishTag,
            "Area": area
          }
        }
      },
      searchScreen: {
        event: 'Search Screen',
        properties: (
          keyword
        ) => {
          return {
            "Keyword": keyword
          }
        }
      },
      onlineOrderingToggle: {
        event: 'Action: Online Ordering Toggle',
        properties: (
          area
        ) => {
          return {
            "Area": area
          }
        }
      },
      loginFacebook: {
        event: 'Login with Facebook',
        properties: (
          area
        ) => {
          return {
            "Area": area
          }
        }
      },
      loginEmail: {
        event: 'Login with Email',
        properties: (
          email
        ) => {
          return {
            "Email": email
          }
        }
      },
      delivery: {
        event: 'Action: Click on Delivery in Homepage'
      },
      dineout: {
        event: 'Action: Click on Dineout in Homepage'
      },
      loginScreen: {
        event: 'Screen: Login Screen',
        properties: (
          area
        ) => {
          return {
            "Area": area
          }
        }
      },
      viewPeopleView: {
        event: 'Action: View People View',
        properties: (
          sourceScreen
        ) => {
          return {
            "SourceScreen": sourceScreen
          }
        }
      },
      startGroup: {
        event: 'Action: Start Group',
        properties: (
          startPoint,
          restName
        ) => {
          return {
            "Start Point": startPoint,
            "Restaurant Name": restName,
          }
        }
      },
      convertToGroup: {
        event: 'Action: Convert Basket to Group',
        properties: (
          restName
        ) => {
          return {
            "Restaurant Name": restName,
          }
        }
      },
      leaveGroup: {
        event: 'Action: Leave Group',
        properties: (
          restName
        ) => {
          return {
            "Restaurant Name": restName,
          }
        }
      },
      cancelGroup: {
        event: 'Action: Cancel Group',
        properties: (
          restName
        ) => {
          return {
            "Restaurant Name": restName,
          }
        }
      },
      shareGroup: {
        event: 'Action: Share Group',
        properties: (
          userType,
          restName
        ) => {
          return {
            "User Type": userType,
            "Restaurant Name": restName
          }
        }
      },
      createBasket: {
        event: 'Action: Create Basket',
        properties: (
          restName
        ) => {
          return {
            "Restaurant Name": restName
          }
        }
      },
      joinGroup: {
        event: 'Action: Join Group',
        properties: (
          userType
        ) => {
          return {
            "Join Type": userType
          }
        }
      },
      loadFeed:{
        event : "Load Feed",
        properties :(restaurantsCount , hasFilters, area, zone, lat, long)=>{
          return{
            "restaurant count" : restaurantsCount,
            "filters applied" :hasFilters,
            "Area" : area,
            "Zone" : zone,
            "lat":lat,
            "lon" : long
          }
        }
      },
      clickOnDeliveryInfo: {
        event: 'Action: Click on info delivery'
      },
      clickOnServiceInfo: {
        event: 'Action: Click on info service'
      },
    },
    googleAnalyticsEvents: googleAnalyticsEvents,
    analyticsEvents: analyticsEvents,
    myordersPage: { 
      currentOrders: null,
      previousOrders: null,
      flatOrders: null,
      selectedCurrentOrder: null,
      selectedPreviousOrder: null,
      cancelOrder: {
        reasons: [
          'CANCELED_ORDER_DELAYED',
          'CANCELED_CHANGED_MY_MIND',
          'CANCELED_FOUND_BETTER_OFFER',
          'CANCELED_CHANGED_MY_ADDRESS',
          'CANCELED_OTHER'
        ],
        formattedReasons: {
          CANCELED_ORDER_DELAYED: staticContent.restaurant.myOrders.cancelModal.CANCELED_ORDER_DELAYED,
          CANCELED_CHANGED_MY_MIND: staticContent.restaurant.myOrders.cancelModal.CANCELED_CHANGED_MY_MIND,
          CANCELED_FOUND_BETTER_OFFER: staticContent.restaurant.myOrders.cancelModal.CANCELED_FOUND_BETTER_OFFER,
          CANCELED_CHANGED_MY_ADDRESS: staticContent.restaurant.myOrders.cancelModal.CANCELED_CHANGED_MY_ADDRESS,
          CANCELED_OTHER: staticContent.restaurant.myOrders.cancelModal.CANCELED_OTHER
        },
        selectedReason: null,
        comment: '',
        selectedOrderToCancel: null
      }
    },
    search: {
      restaurantsData: null,
      searchResponse: null,

      page: 1,
      pageSize: 12,
      input: window.location.pathname.split('/search-')[1] && decodeURI(window.location.pathname.split('/search-')[1].replace(/\-/g, ' '))
    },
    topRestaurantsPage: {
      pageName: 'topRestaurantsPage',
      restaurants: null,
      restaurantsData: null,
      page: 1,
      pageSize: 12,
    },
    hiddenGemsPage: {
      pageName: 'hiddenGemsPage',
      restaurants: null,
      restaurantsData: null,
      page: 1,
      pageSize: 12,
    },
    myOrdersGroupUsers: null,

    newRestaurantsPage: {
      pageName: 'newRestaurantsPage',
      restaurants: null,
      restaurantsData: null,
      page: 1,
      pageSize: 12,
    },
    moodRestaurantsPage: {
      pageName: 'moodRestaurantsPage',
      restaurants: null,
      restaurantsData: null,
      page: 1,
      pageSize: 12,
      mood: getUrlParameter('mood') || null,
      allMoods: !getUrlParameter('mood') || null
    },
    categoryRestaurantsPage: {
      pageName: 'categoryRestaurantsPage',
      restaurants: null,
      restaurantsData: null,
      page: 1,
      pageSize: 12,
      category: getUrlParameter('category') || null,
      allCategories: !getUrlParameter('category')
    },
    categoryRestaurants: {
      data: [],
      count: 0,
    },
    deliveryCategories: null,
    offersRestaurants: {
      data: [],
      count: 0,
    },
    cvmRestaurants: {
      data: [],
      count: 0,
    },
    cvmPromoData: {
      name: null,
      message: null,
      flat: null,
      discount: null
    },
    selectedDish: {
      dishName: null,
      dishUUID: null
    },
    dineoutPage: {
      restaurants: null,
      restaurantsData: null,
      categories: null,
      flattenCategories: null,
      flatMoods: null,
      flatCategories: null,
      currentPageMethod: null,
      sortingOptions: [
        {
          name: staticContent.filters.popular,
          value: 'POPULAR'
        },
        {
          name: staticContent.filters.latest,
          value: 'LATEST'
        },
        {
          name: staticContent.filters.rating,
          value: 'RATING'
        }
      ],
      searchParams: { // params: area, category, orderingEnabled, onlinePayment, quickDelivery, openNow, compact, sort, page, pageSize,
        general: {

          category: {
            name: '',
            value: null
          },
          mood: {
            name: '',
            value: null
          },

          compact: {
            name: null,
            value: null
          },

          sort: {
            name: null,
            value: 'POPULAR'
          },

        },

        features: {

          feature: {
            name: true,
            value: []
          },

          openNow: {
            name: staticContent.filters.openNow,
            value: null
          }
        },


        page: {
          value: 1
        },
        pageSize: {
          value: 12
        },
        checkoutDone: false
      },
      verifyPhoneModel: {
        selectorID: 'verify-phone-modal',
        disableInput: false,
        selectedAddressUUID: null,
        selectedAddressPhone: null,
        timerEnabled: false,
        timer: 0,
        timerInterval: null,
        showVerifyError: false
      },
      loginForm: {
        email: null,
        password: null,
        errors: null
      },
      signupForm: {
        name: null,
        email: null,
        password: null,
        errors: null
      },

    },
    deliveryPage: {
      searchResponse: null,
      restaurantsData: null,
      categories: null,
      flattenCategories: null,
      reloadingAll: false,
      loading: false,
      sortingOptions: [
        {
          name: staticContent.filters.popular,
          value: 'POPULAR'
        },
        {
          name: staticContent.filters.rating,
          value: 'RATING'
        },
        {
          name: staticContent.filters.deliveryTime,
          value: 'DELIVERY_TIME'
        }
      ],
      searchParams: { // params: area, category, orderingEnabled, onlinePayment, quickDelivery, openNow, compact, sort, page, pageSize,
        general: {
          category: {
            name: '',
            value: getUrlSlash('dish-')
          },
          orderingEnabled: {
            name: staticContent.common.orderOnline,
            value: serverData.onlineOrderingFilterOpen || getUrlSlash(filters.features).includes(filters.orderingEnabled)
          },

          compact: {
            name: null,
            value: null
          },

          sort: {
            name: null,
            value: null
          }

        },

        features: {

          onlinePayment: {
            name: 'Online payment',
            value: null
          },
          quickDelivery: {
            name: 'Quick delivery',
            value: null
          },
          openNow: {
            name: 'Open now',
            value: null
          },
          promoEnabled: {
            name: 'Promo',
            value: null
          },
          hygieneCheck: {
            name: 'Hygiene Check',
            value: null
          }
        },

        page: {
          value: 1
        },
        pageSize: {
          value: 12
        },
      }
    },
    restaurantPage: { // in scripts
      baseURL: '/restaurant/',
      photosTab: {
        style: 'grid',
        communityPhotos: null,
        communityPhotosData: null,
        flattenCommunityPhotos: null,
        selectedPhoto: null,
        serverPhotoDetails: null,
        selectedPhotoDetails: null,
        photoDetailsRequest: null,
        photoCommentsScroll: null,
        photosTabURL: `${serverData.restaurantBaseUrl}/photos`,
        sort: {
          data: [
            {
              key: 'MOST_RECENT',
              label: 'Most Recent',
            },
            {
              key: 'MOST_YUMS',
              label: 'Most Yums'
            }
          ],
          value: 'MOST_RECENT'
        },
        loadMore: true,
        page: 1,
        pageSize: 20
      },
      reviewsTab: {
        selectedReview: serverData.reviewDetails || null
      },
      orderingFlagMessage: null,
      restHeaderObj: null,
      shouldHidePromo : false
    },
    isClosedToday: false,
    isOpenForDelivery: false,
    branachOpenNow: false,  // in scripts
    windowWidth: document.documentElement.clientWidth,
    items: null,
    likedItems: {},
    itemSlider: {
      options: {
        pauseOnFocus: false,
        pauseOnHover: false,
        arrows: false,
        slidesToShow: 1,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
        swipe: false,
      },
      sliderCouter: ''

    },
    restaurantDeliveryData: {
      allDeliveryFee: null,
      deliveryFee: null,
      allDeliveryDuration: null,
      deliveryDuration: null
    },
    branchDeliveryAreaZones: null,
    flattenBranchDeliveryAreaZones: null,
    deliveryAreaZones: null, // in scripts
    flatAreaBranches: null,
    lookups: null,
    flattenDeliveryAreaZones: null,
    flattenDeliveryZones: null,
    flattenBranchZones: null,
    flatCities: null,
    flatAreas: null,
    searchZones: null,
    areaSearchText: null,
    flatZones: null,
    cityAreas: null,
    areaZones: null,
    areasScroll: null,
    zonesScroll: null,
    citiesScroll: null,
    flatFeatures: null,
    sizes: null,
    itemModal: {
      flatExtraCategories: <FlatExtraCategories>{},
      isExCatsValid: true,
      itemSubTotal: 0,
      itemData: null
    },
    orderingEnabled: null,
    deliveryStatus: { // in scripts
      areaUUID: cityAreaUUIDsFromURL.urlAreaUUID || flatLookupsAreas(serverData.lookups.areas)[getCookie(cookies.userArea)] ? getCookie(cookies.userArea) : '' || '',
      isDeliver: null
    },
    areaZoneModal: false,
    basketAddress: '',
    // cityAreaUUIDsFromURL.urlCityUUID ||
    cityAreasSelected: getCookie(cookies.userCity) || '',
    areaZonesSelected: cityAreaUUIDsFromURL.urlAreaUUID || flatLookupsAreas(serverData.lookups.areas)[getCookie(cookies.userArea)] ? getCookie(cookies.userArea) : '' || '',
    zoneSelected: getCookie(cookies.userZone) || '',
    lat: getCookie(cookies.lat) || '',
    long: getCookie(cookies.long) || '',
    searchText: '',
    areasList: [],
    zonesList: [],
    orderStatus: staticContent.orderTracking.orderStatus,
    user: {
      addresses: null,
      sortedAddresses: null,
      flatAddresses: null,
      openAddAddress: false,
      deleteAddressUUID: null,
      currentOrders: null,
      currentOrdersFlat: null,
      lastOrder: null,
      orderTracking: null,
      focusedAddress: null,
      cityUUID: cityAreaUUIDsFromURL.urlCityUUID || getCookie(cookies.userCity) || null,
      areaUUID: cityAreaUUIDsFromURL.urlAreaUUID || flatLookupsAreas(serverData.lookups.areas)[getCookie(cookies.userArea)] ? getCookie(cookies.userArea) : '' || null,
      zoneUUID: flatLookupsZones(serverData.lookups.zones)[getCookie(cookies.userZone)] ? getCookie(cookies.userZone) : null || null,
      location: {
        lat: getCookie(cookies.lat) || null,
        long: getCookie(cookies.long) || null
      },
      company: getCookie('Company') ? JSON.parse(getCookie('Company')) : null
    },
    myOrdersLoadingData: null,
    myOrdersLoadingDataError: false,
    showCallModal: false,
    checkoutCycle: {
      step: 0,
      selectedAddressObj: null,
      flattenOrderItems: null,
      placeOrderError: null,
      confirmationData: {
        orderUUID: null,
        orderShortCode: null,
        itemsCount: null,
        deliveryFee: null,
        subTotal: null,
        tax: null,
        total: null,
        totalBeforeDiscount: null,
        promoDetails: null
      },
      addressForm: {

        fullName: vue && vue.profile && vue.profile.data.profile ? vue.profile.data.profile.name : null,
        phoneNumber: null,
        cityUUID: getCookie(cookies.userCity),
        areaUUID: getCookie(cookies.userArea),
        zoneUUID: getCookie(cookies.userZone),
        city: null,
        area: null,
        zone: null,
        location: null,
        address: null,
        landmark: null,
        buildingNumber: null,
        floorNumber: null,
        apartmentNumber: null,
        isCompany: false,
        companyName: null,
        default: false,
        addressUUID: null,
        pin: null,
        addressTouched: false,
        mapTouched: false,
        addressMapId: 'map1',
        step2Flag: false,
        restPageFlag: false,
        restURL: ''
      },
      checkoutDone: false
    },
    verifyPhoneModel: {
      selectorID: 'verify-phone-modal',
      disableInput: false,
      selectedAddressUUID: null,
      selectedAddressPhone: null,
      timerEnabled: false,
      timer: 0,
      timerInterval: null
    },
    loginForm: {
      email: null,
      password: null,
      errors: null
    },
    signupForm: {
      name: null,
      email: null,
      password: null,
      errors: null
    },
    notificationsComponent: {
      show: false,
      notifications: null,
      newNotificationsData: [],
      notificationsData: [],
      lastUpdate: null,
      page: 1,
      pageSize: 20,
      loadMore: true,
      loading: false
    },
    basketError: {
      basketErrorEnum: {
        "BRANCH_IS_NOT_OPEN": { imgSrc: '/public/img/closed.svg', title: 'BRANCH_CLOSED', description: 'BRANCH_CLOSED_DESC', showModal: true },
        "BRANCH_IS_NOT_DELIVERING": { imgSrc: '/public/img/branch-not-deliver.svg', title: 'SORRY', description: 'BRANCH_NO_DELIVER', showModal: true },
        "BRANCH_DO_NOT_COVER_ZONE": { imgSrc: '/public/img/branch-not-deliver.svg', title: 'SORRY', description: 'BRANCH_NO_COVER', showModal: false },
        "RESTAURANT_DO_NOT_COVER_ZONE": { imgSrc: '/public/img/branch-not-deliver.svg', title: 'SORRY', description: 'RESTAURANT_NO_COVER', showModal: true },
        "BELOW_MINIMUM_ORDER_VALUE": { imgSrc: '/public/img/min-order-val.svg', title: null, description: `ORDER_BELOW_MINIMUM`, showModal: false },
        "BRANCH_UNAVAILABLE": { imgSrc: '/public/img/closed.svg', title: 'SORRY', description: `BRANCH_UNAVAILABLE_DESC`, showModal: false },
        "RESTAURANT_UNAVAILABLE": { imgSrc: '/public/img/closed.svg', title: 'SORRY', description: `RESTAURANT_UNAVAILABLE_DESC`, showModal: false }
      },
      basketErrorMsg: { imgSrc: "/public/img/min-order-val.svg", title: null, description: null, showModal: false }
    },
    basketHasError: false,
    restaurantTabs: ['scanned-menu', 'info', 'branches', 'photos', 'reviews'],
    itemsErrors: [],
    addItemIndex: 0,
    isGroupBasket: false,
    isMemberInGroup: false,
    groupLoading: false,
    groupURL: null,
    userName: null,
    isGuest: true,
    joinGuestPayload: {},
    groupSummaryInterval: null,
    compactBasketInterval: null,
    showTryAgainBtn: true,
    tryIndex: 0,
    showInternetRetryBtn: true,
    mapUpdated: false,
    pinFlag: null,
    updatePromocodeFlag: false,
    formType: 'add',
    showEditModal: false,
    location: {
      lat: '',
      long: ''
    },
    createBasketOpen: false,
    showRetryLoading: false,
    alertClosed: {
      redirect: false,
      URL: null
    },
    cancelCurrentOrder: false,
    detectLocationPermissionError: false,
    locationDetailsFoundError: false,
    isZoneLikePolyZone: true,
    showTemplate: true,
    isChatInitiated: false,
    polygonCoords: [],
    addressPolygonZone: null,
    shouldIStick: false,
    shouldIstickToBottom: false,
    detectingLocation: false,
    // the follwing property is to bind on an element any class we want
    // use bindConditionalClasses.push('unique-identifier') and condition on it using v-bind:class or :class
    // the condition should search for identifier index and bind based on the return.
    // make sure to push or splice according to your logic
    bindConditionalClasses: [
      'profile-section-reviews-tab-btn',
      'checkout-people-view-people-view',
      'login-form-login-btn',
      'basket-login-form-basket-login-tab-btn',
      'guest-login-form-basket-login-tab-btn',
      'settings-tabs-nav-change-email-btn',
      'orders-people-item-CURRENT-iditemmenuCURRENT',
      'orders-people-item-PREVIOUS-iditemmenuPREVIOUS',
      'myorderCurrent-collapse-0-id',
      'myorderprev-collapse-0-id',
      'basket-collapse-0-id',
      'checkout-collapse-0-id',
      'menu-tab-activated',
      'rest-menu-0'
    ],
    resumeOrder: {
      uuid: '',
      ref: {},
      data: {},
      reason: '',
      cancelLoading: false
    },
    nearbyCompanies: [],
    placeAutocomplete: '',
    zoneBounds: [],
    companyModalInitiated: false,
    companyPrompt: true,
    companyErrorMsg: false,
    companyModalLoading: false,
    companyModalError: false,
    firstHygeine: '',
    showLimitedTracking:false,
    isOnlineOrdering : false,
    remoteConfigKeys: { ...KEYS },
    isRemoteConfigFetched: false,
  };


const analytics = getAnalytics(firebaseApp);

  data.deliveryPage.searchParams.general.sort.value = data.deliveryPage.sortingOptions[0].value;
  const Anno = window['Anno'];
  var GrouopBasketAnno;
  var gliderArr = []
  var offersGlider;
  if (serverData.lookups) {

    data.searchZones = serverData.lookups.zones.map(item => {
      var zoneArea = serverData.lookups.areas.filter(area => area.uuid == item.ref.areaUUID)[0];

      item['area'] = zoneArea.data.name;

      var zoneCity = serverData.lookups.cities.filter(city => city.uuid == zoneArea.ref.cityUUID)[0]
      item['city'] = zoneCity.data.name;
      item['cityUuid'] = zoneCity.uuid;

      item['name'] = item.data.name + ", " + item.area + ", " + item.city

      return item
    })

    data.lookups = serverData.lookups;
    data.flatCities = flatLookupsCities(serverData.lookups.cities);
    data.flatAreas = flatLookupsAreas(serverData.lookups.areas);
    data.flatZones = flatLookupsZones(serverData.lookups.zones);
    data.cityAreas = flatCityAreas(serverData.lookups.areas);
    data.areaZones = flatAreaZones(serverData.lookups.zones);
    data.flatFeatures = flatLookupsFeatures(serverData.lookups.features);

    if (window.location.hash.indexOf('#login-tab') != -1 || window.location.hash.indexOf('#signup-tab') != -1) {
      setTimeout(() => {
        if (!(vue.profile && vue.profile.data.profile)) {
          $body.classList.add('modal-open');
          vue.bindConditionalClasses.push('login-signup-modal');
          var btn =  (window.location.hash.indexOf('#signup-tab') != -1) ? 'signup-btn' : 'login-btn'
          vue.tabsHandler('login-form', btn);
        }
      }, 1000);
    }

    window['gtag']('set', 'user_properties', {
      Area: data.flatAreas[getCookie(cookies.userArea)] ? data.flatAreas[getCookie(cookies.userArea)].name : 'none',
    });
    if (data.flatAreas[getCookie(cookies.userArea)] && data.flatZones[getCookie(cookies.userZone)]) {
      (
        getCookie(cookies.userArea) &&
        data.flattenDeliveryAreaZones &&
        data.flattenDeliveryAreaZones[getCookie(cookies.userArea)]
      ) && (data.zonesList = data.flattenDeliveryAreaZones[getCookie(cookies.userArea)].zones);
    }

    else if (!data.flatAreas[getCookie(cookies.userArea)]) {
      var pages = ['/delivery', '/dineout', '/offers'];

      const isPage = pages.filter(p => window.location.href.indexOf(p) > -1).length;
      if (isPage) {
        setTimeout(() => {
          $body.classList.add('modal-open');
          vue.bindConditionalClasses.push('add-city-area-modal');
          this.pushViewLocationPromptEvent();
        }, 1000);

      }
      if (window.location.href.indexOf('settings') > -1) {
        setTimeout(() => {
          if (!(vue.profile && vue.profile.data.profile)) {
            $body.classList.add('modal-open');
            this.bindConditionalClasses.push('login-signup-modal');

          }

        }, 1000);
      }
    }
    if (data.cityAreasSelected) {
      data.areasList = data.cityAreas[data.cityAreasSelected];
      data.zonesList = data.areaZones[data.areaZonesSelected];

    }
    if (getCookie(cookies.userCity)) {
      data.areasList = data.cityAreas[getCookie(cookies.userCity)];
    }

  }

  if (serverData.restaurantHeader) {
    store.dispatch('GET_BASKET_STATE');
    data.orderingEnabled = serverData.restaurantHeader.branchOrderingEnabled;

    data.restaurantPage.restHeaderObj = serverData.restaurantHeader;

    const userArea = flatLookupsAreas(serverData.lookups.areas)[getCookie(cookies.userArea)] ? getCookie(cookies.userArea) : '';
    const userZone = flatLookupsZones(serverData.lookups.zones)[getCookie(cookies.userZone)] ? getCookie(cookies.userZone) : '';

    if (userArea) {

      data.deliveryStatus.areaUUID = userArea;
      data.deliveryStatus.isDeliver = serverData.restaurantHeader.branchDeliversToLocation
    }

    data.restaurantDeliveryData.allDeliveryFee = store.state.restaurantDeliveryData.allDeliveryFee
    data.restaurantDeliveryData.allDeliveryDuration = store.state.restaurantDeliveryData.allDeliveryDuration
    const minDeliveryFee = Math.min.apply(null, data.restaurantDeliveryData.allDeliveryFee);
    const maxDeliveryFee = Math.max.apply(null, data.restaurantDeliveryData.allDeliveryFee);
    if (maxDeliveryFee) data.restaurantDeliveryData.deliveryFee = minDeliveryFee + (minDeliveryFee < maxDeliveryFee ? ' - ' + maxDeliveryFee : '');
    
    const minDeliveryDuration = Math.min.apply(null, data.restaurantDeliveryData.allDeliveryDuration);
    const maxDeliveryDuration = Math.max.apply(null, data.restaurantDeliveryData.allDeliveryDuration);
    if (maxDeliveryDuration) data.restaurantDeliveryData.deliveryDuration = minDeliveryDuration + (minDeliveryDuration < maxDeliveryDuration ? ' - ' + maxDeliveryDuration : '');
    
    data.branachOpenNow = serverData.restaurantHeader.openNow && !serverData.restaurantHeader.busy

    data.isClosedToday = !serverData.restaurantHeader.openNow;
    data.isOpenForDelivery = serverData.restaurantHeader.openNow && serverData.restaurantHeader.onlineOrdering;

    data.restaurantPage.orderingFlagMessage = orderingFlag(
      staticContent,
      data.restaurantPage.restHeaderObj.restaurantOrderingEnabled, //restaurant is delivery
      data.restaurantPage.restHeaderObj.branchDeliversToLocation, // branch is deliver to  user branchDeliversToLocation
      data.restaurantPage.restHeaderObj.onlineOrdering, // restaurant branch is deliver branchDeliversToLocation
      data.restaurantPage.restHeaderObj.branchOrderingEnabled, // restaurant branch is deliver branchDeliversToLocation
      data.flatAreas[data.deliveryStatus.areaUUID] && data.flatAreas[data.deliveryStatus.areaUUID].orderingEnabled,
      data.restaurantPage.restHeaderObj.openNow,
      data.flatAreas[data.deliveryStatus.areaUUID] && data.flatAreas[data.deliveryStatus.areaUUID].name
    )
    
  }


  if (serverData.openedGiftForm) {
    store.commit('setPromoOpenedForm', serverData.openedGiftForm);
    store.commit('setShowGiftForm', true);
  }

  if (serverData.deliveryRestaurants) {
    const params = new URLSearchParams(window.location.search);
    const openNow = params.get('openNow');
    data.deliveryPage.searchParams.features.openNow.value = openNow ? openNow : false;
    data.deliveryPage.searchResponse = serverData.deliveryRestaurants;
    data.deliveryPage.restaurantsData = serverData.deliveryRestaurants.data;

  }

  if (serverData.deliveryLookups) {

    data.deliveryPage.categories = serverData.deliveryLookups;
    data.deliveryPage.flattenCategories = flatDeliveryCategories(serverData.deliveryLookups);
  }
  if (serverData.searchResults) {

    data.search.searchResponse = serverData.searchResults;
    data.search.restaurantsData = serverData.searchResults.results;

  }
  if (serverData.dineoutRestaurants) {

    data.dineoutPage.restaurants = serverData.dineoutRestaurants;
    data.dineoutPage.restaurantsData = serverData.dineoutRestaurants.data;
    data.dineoutPage.currentPageMethod = serverData.dineoutPageMethod || 'getRestaurants';

  }
  if (serverData.dineoutMoods) {
    data.dineoutPage.flatMoods = flatDineoutMoods(serverData.dineoutMoods);
    if (getUrlSlash('mood-') && data.dineoutPage.flatMoods[getUrlSlash('mood-')]) {

      data.dineoutPage.searchParams.general.mood.name = data.dineoutPage.flatMoods[getUrlSlash('mood-')].name;
      data.dineoutPage.searchParams.general.mood.value = data.dineoutPage.flatMoods[getUrlSlash('mood-')].uuid;
    } else {
      data.dineoutPage.searchParams.general.mood.name = '';
      data.dineoutPage.searchParams.general.mood.value = null;
    }

  }
  if (serverData.dineoutCategories) {

    data.dineoutPage.flatCategories = flatDineoutCategories(serverData.dineoutCategories);

    if (getUrlSlash('dish-') && data.dineoutPage.flatCategories[getUrlSlash('dish-')]) {

      data.dineoutPage.searchParams.general.category.name = data.dineoutPage.flatCategories[getUrlSlash('dish-')].name;
      data.dineoutPage.searchParams.general.category.value = data.dineoutPage.flatCategories[getUrlSlash('dish-')].uuid;
    } else {
      data.dineoutPage.searchParams.general.category.name = '';
      data.dineoutPage.searchParams.general.category.value = null;
    }
  }

  if (serverData.hiddenRestaurants) {

    data.hiddenGemsPage.restaurants = serverData.hiddenRestaurants;
    data.hiddenGemsPage.restaurantsData = serverData.hiddenRestaurants.data;

  }

  if (serverData.newRestaurants) {

    data.newRestaurantsPage.restaurants = serverData.newRestaurants;
    data.newRestaurantsPage.restaurantsData = serverData.newRestaurants.data;

  }
  if (serverData.moodRestaurants) {

    data.moodRestaurantsPage.restaurants = serverData.moodRestaurants;
    data.moodRestaurantsPage.restaurantsData = serverData.moodRestaurants.data;

  }
  if (serverData.categoryRestaurants) {

    data.categoryRestaurantsPage.restaurants = serverData.categoryRestaurants;
    data.categoryRestaurantsPage.restaurantsData = serverData.categoryRestaurants.data;

  }
  if (serverData.offersRestaurants) {

    data.offersRestaurants = serverData.offersRestaurants;

  }
  if (serverData.cvmRestaurants) {
    data.cvmRestaurants = serverData.cvmRestaurants;
  }

  if (serverData.cvmPromoData) {
    data.cvmPromoData = serverData.cvmPromoData;
  }

  if (serverData.deliveryCategories) {

    data.deliveryCategories = serverData.deliveryCategories;

  }
  if (serverData.selectedDish) {

    data.selectedDish = serverData.selectedDish;

  }
  if (serverData.categoryRestaurants) {

    data.categoryRestaurants = serverData.categoryRestaurants;

  }


  if (serverData.previousOrders) {
    data.myordersPage.previousOrders = serverData.previousOrders;
  }

  if (serverData.currentOrders) {
    data.myordersPage.currentOrders = serverData.currentOrders;

  }
  if (serverData.communityPhotos) {
    data.restaurantPage.photosTab.communityPhotos = serverData.communityPhotos;
    data.restaurantPage.photosTab.communityPhotosData = serverData.communityPhotos.data;
    data.restaurantPage.photosTab.flattenCommunityPhotos = flatCommunityPhotos(serverData.communityPhotos.data);
  }


  const components = {
    BasketView,
    AppHeader: document.getElementsByTagName('app-header').length ? undefined : undefined,
    AppLogin,
    AppSignup,
    PasswordValidation,
    'restaurant-reviews': RestaurantReviews,
    'rate-comp': RateComp,
    'change-email': ChangeEmail,
    'change-Password': ChangePassword,
    'form-feedback': FormFeedback,
    'profile-reviews': ProfileReviews,
    'address-book': AddressBook,
    'choose-payment': ChoosePayment,
    'add-credit-card': AddCreditCard,
    'credit-cards-list': CreditCardsList,
    'top-up': Topup,
    'confirmation-modal': ConfirmationModal,
    'gifting-form-checkout': GiftingFormCheckout,
    'delivery-time-prompt': DeliveryTimePrompt,
    ReviewCard,
    trackingBanner: trackingBanner,
    peopleView,
    ReviewStepOne,
    myOrdersController,
    orderDetails,
    orderShare,
    BasketItems,
    BasketItemModal,
    CancelGroup,
    selectedCompany,
    leaveGroup,
    reOrderModal,
    dishFeedback,
    dishTinder,
    announcemnts,
    dynamicSections,
    creditCardVerification,
    bulkRemoveItems,
    orderReceipt,
    GroupView,
    currentOrderDetails,
    orderMap,
    promoMessage,
    locationDisclaimer,
    "trip-wizard": tripWizard,
    'alert-modal': AlertModal,
    'resume-order-modal': resumeOrder,
   
    feedBackConfirmation,
    StarRating,
    RestaurantStatus,
    'restaurant-scripts': RestaurantScripts,
    'restaurant-menus': RestaurantMenus,
    'landing-install-banner': landingInstallBanner
  }
  Vue.use(VueObserveVisibility);
  Vue.use(VeeValidate, {
    locale: getCookie(cookies.lang) || 'EN',
    dictionary: validationDictionary
  });
  Vue.use(vueNotVisible);
  // Vue.use(GSignInButton);
  Vue.use(ReadMore);
  Vue.use(VueGlide)

  Vue.use(VueLazyload, {
    adapter: {
      loaded({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
        el.parentElement.classList.add('image-loaded');
      },
      loading({ bindType, el, naturalHeight, naturalWidth, $parent, src, loading, error, Init }) {
        el.parentElement.classList.add('image-loading');
      },
    }
  });
  Vue.use(VueMeta, {

  });
  Vue.component('v-select', vSelect);
  var vueScriptThis
  var vue = new Vue({
    el: '#app',
    directives: { Sticky },
    // Start SmartBanner configuration
     metaInfo() {
       const title = this.getAppIncentiveText(KEYS.Install_Incentives.Smart_Banner, KEYS.Install_Incentives.Title);
       const body = this.getAppIncentiveText(KEYS.Install_Incentives.Smart_Banner, KEYS.Install_Incentives.Body);
       let metaData = [{ name: "smartbanner:title", content: title }, { name: "smartbanner:author", content: body }, { name: "smartbanner:button", content: staticContent.smartBanner.install }];
   
       if (data.isRemoteConfigFetched) {
         if(getRemoteConfigAsBoolean(KEYS.Install_Incentives.Show_New_Smart_Banner)){
           metaData = [
             ...metaData,
             { name: "smartbanner:custom-design-modifier", content: this.isMobile ? "primary" : "primary-desktop" },
             { name: "smartbanner:include-user-agent-regex", content: ".*" }
           ]
         }
        }
        
        return { 
          meta: [
            ...metaData,
          ] 
        };
     },
    data() {
      return data;
    },
    store,

    computed: {
      selectedTrip() {
        return this.$store.state.selectedTrip;
      },
      menus() {
        return this.$store.state.branchMenus;
      },
      commonTagUUID() {
        return this.$store.state.commonTagUUID
      },
      currentURL() {
        return window.location.href;
      },
      isOfferApplied() {
        return (this.promoRequest.code && this.promoRequest.code == this.restaurantPage.restHeaderObj.offer.code) ||
          (this.basket.ref.promo && this.restaurantPage.restHeaderObj.offer.code == this.basket.ref.promo.code) ? true : false

      },
      relatedRestaurants() {
        return this.$store.state.relatedRestaurants
      },
      isMobile() {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
          return true
        }
        else {
          return false
        }
      },
      selectedOrderState() {
        return this.$store.state.selectedOrder.data.orderStateEnum
      },
     
      restaurantBranches() {
        return data.flatAreaBranches
      },
      restaurantUUID() {
        return serverData.restaurantUUID
      },
      moods() {
        return data.dineoutPage.flatMoods
      },
      isThereMyOrdersData() {
        return (this.$store.state.previousOrders.data.length == 0 && this.$store.state.currentOrders.data.length == 0)

      },
      previousOrdersLoader() {
        return this.$store.state.previousOrdersLoader;
      },
      currentOrdersLoader() {
        return this.$store.state.currentOrdersLoader;
      },
      getCurrentOrders() {
        return this.$store.state.currentOrders.data;
      },
      getPreviousOrders() {
        return this.$store.state.previousOrders.data;
      },

      branchWorkingDays() {
        // will be handled in branch tab
        return []
        // serverData.restaurant.currentBranch && ([...serverData.restaurant.currentBranch.data.dailyWorkingHours].sort((a: WorkingDay, b: WorkingDay) => {
        //   let dayA = OrderWeekDay[a.weekDay.toUpperCase()];
        //   let dayB = OrderWeekDay[b.weekDay.toUpperCase()];
        //   return (dayA > dayB ? 1 : ((dayB > dayA) ? -1 : 0));
        // }).reduce((days: Array<WorkingDay[]>, currentDay: WorkingDay) => {
        //   var workingHours: WorkingHours = {
        //     start: null,
        //     end: null
        //   }
        //   if (!currentDay.closed && currentDay.workingHours.start) {

        //     workingHours.start = moment(currentDay.workingHours.start, 'HH:mm').format("h:mm A");
        //     workingHours.end = moment(currentDay.workingHours.end, 'HH:mm').format("h:mm A");

        //   }

        //   if (days.length) {
        //     days[days.length - 1][0].workingHours.start == workingHours.start
        //       ? days[days.length - 1].push(Object.assign({}, currentDay, { workingHours: workingHours }))
        //       : days.push([Object.assign({}, currentDay, { workingHours: workingHours })])
        //   } else {
        //     days[0] = [Object.assign({}, currentDay, { workingHours: workingHours })];
        //   }

        //   return days;

        // }, []))
      },
     
      getLocationDetailsFoundError() {
        return this.locationDetailsFoundError ? true : false;
      },
      getPinFlag() {
        return this.pinFlag == 'notUpdated' ? true : false;
      },
      getIsZoneLikePolyZone() {
        return this.isZoneLikePolyZone;
      },
      getMyOrdersLoadingData() {
        return this.myOrdersLoadingData;
      },
      getMyOrdersLoadingDataError() {
        return this.myOrdersLoadingDataError;
      },
      getMyOrdersGroupUsers() {
        return this.myOrdersGroupUsers;
      },
      showGiftForm() {
        return this.$store.getters.getShowGiftForm
      },
      alert() {
        return this.$store.getters.getAlert;
      },
      tastyOffers() {
        return this.$store.getters.getTastyOffers;
      },
      refreshConfigurations() {
        return this.$store.getters.getRefreshConfigurations;
      },
      basketItemsCount() {
        return this.$store.state.basketCompact.data.itemCount;
      },

      basketisGroup() {
        return this.$store.state.basketCompact.data.isGroup;
      },
      isGroupAdmin() {
        return (this.profile && this.profile.uuid) == this.groupBasket.ref.adminUserUUID
      },
      isGroupMember() {
        return this.$store.state.isGroupMember;
      },
      basketCompact() {
        return this.$store.state.basketCompact;
      },
      basketCompactLoading() {
        return this.$store.state.basketCompact.loading;
      },
      isGroupLocked() {
        return this.basketCompact.data.isLocked;
      },
      pageReferrer() {
        if ('referrer' in document) {

          return document.referrer;
        } else {
          return null;
        }
      },
     
      profile() {
        const profile = this.$store.getters.getProfileData;
        const isUser =isLoggedInUser();
        const segmentsSetup = localStorage.getItem(LocalStorageKeys.Segments_Setup) || ""

        if(isUser && !segmentsSetup ){
          profile.data.segments && 
          setUserProperties(analytics , {...profile.data.segments});
          this.setMixpanelSegemntsProps(profile.uuid,profile.data.segments);
        }
       
        return this.$store.getters.getProfileData;
      },
      promoBanner() {
        return this.$store.state.promoBanner;
      },
      cart() {
        return this.$store.getters.getCart
      },
      basket() {
        return this.$store.state.basket
      },
      lockHasError() {
        return this.$store.state.lockBasketHasError
      },
      checkoutLoadingData() {
        return this.$store.getters.getcheckoutLoadingData

      },
      checkoutLoadingDataError() {
        return this.$store.getters.getcheckoutLoadingDataError

      },
      groupBasket() {
        return this.$store.getters.getGroupBasket
      },
      groupBasketAdminUUID() {
        return this.$store.state.groupBasket.ref.adminUserUUID
      },
      creditCards() {
        return this.$store.state.creditCards
      },
      promoRequest() {
        return this.$store.state.promoRequest
      },
      getBasketItemsCount() {
        return this.$store.getters.getBasketItemsCount
      },
      checkout() {
        return this.$store.state.basket.checkout;
      },
      promoForm() {
        return this.$store.state.promoForm;
      },
      showCheckoutModal() {
        return this.$store.state.basket.checkout.showCheckoutModal;
      },
      basketUserAddresses() {
        return this.$store.state.basketUserAddresses
      },
      autocomplete() {
        return this.$store.getters.getAutocomplete
      },
      isOrderDelivered() {
        let returnValue = vue.user.currentOrders && vue.user.currentOrders.data.length && (this.$store.state.selectedOrder.data.orderStateEnum && this.$store.state.selectedOrder.data.orderStateEnum == 'OUT_FOR_DELIVERY') && vue.expectOrderDelivered(this.$store.state.selectedOrder.data.outForDeliveryTime, vue.user.currentOrders.data[0].data.estimatedDeliveryTime)
        return returnValue;
      },
      isLastOrderDelivered() {
        let returnValue = this.user.lastOrder && this.user.lastOrder.data.orderStateEnum == 'OUT_FOR_DELIVERY' && vue.expectOrderDelivered(this.user.lastOrder.data.outForDeliveryTime, this.user.lastOrder.data.estimatedDeliveryTime)
        return returnValue;
      },
      isMyOrderDelivered() {

        let returnValue = (this.$store.state.currentOrders && this.$store.state.selectedOrder.data.orderStateEnum && this.$store.state.selectedOrder.data.orderStateEnum == 'OUT_FOR_DELIVERY') && this.expectOrderDelivered(this.$store.state.selectedOrder.data.outForDeliveryTime, this.$store.state.selectedOrder.data.estimatedDeliveryTime)
        return returnValue;
      },
      currentLanguage() {
        return getCookie(cookies.lang)
      },
      hasBasketInRestaurant() {
        return this.basketCompact.ref.restaurantUUID == serverData.restaurantUUID
      },
      isRestaurantWithinDeliveryHours() {
        return serverData.restaurantHeader.openNow && !serverData.restaurantHeader.busy
      },
      cityAreaUUIDsFromURL() {
        return getCityAreaFromURL(window.location.pathname, serverData.lookups);
      },
      isRamadan() {
        if (this.basket.ref.branch.ramadanSettings) {
          return true;
        }
        else {
          return false
        }
      },
      isRamadanOnly() {

        return this.basket.ref.branch.ramadanSettings && this.basket.ref.branch.ramadanSettings.orderIftarEnabled && !this.basket.ref.branch.ramadanSettings.orderNowEnabled

      },
      isRestaurantInRamadan() {
        if (data.restaurantPage.restHeaderObj.ramadanSettings) {
          return true;
        }
        else {
          return false
        }
      },
    },
    watch: {
      menus(newMenus, oldMenus) {  
        this.items = flatMenuItems(newMenus);
        menuCatsScrollHandler();
      },
      commonTagUUID(newTag, oldTag) {
        if (newTag && (!this.restaurantPage.restHeaderObj.branchOrderingEnabled || !this.restaurantPage.restHeaderObj.onlineOrdering)) {
          const relatedArea = this.userArea ? this.userArea : this.restaurantPage.restHeaderObj.area.uuid;
          const relatedRestaurantParams = `area=${relatedArea}&category=${newTag}&restaurant=${serverData.restaurantUUID}${this.user.zoneUUID ? '&zone=' + this.user.zoneUUID : ''}&pageSize=6`
          store.dispatch('GET_RELATED_RESTAURANTS', relatedRestaurantParams)
            .then(() => {
              relatedRestaurantsSlider();
            })
        }
      },
      isOnlineOrdering(){
        this.pushMixpanelEvent(
          this.mixpanelEvents.loadFeed.event, 
          this.mixpanelEvents.loadFeed.properties(
            this.deliveryPage.searchResponse.count,
            this.deliveryPage.searchParams.general.orderingEnabled.value ? "Yes" : "No",
            this.flatAreas[this.deliveryStatus.areaUUID] ? this.flatAreas[this.deliveryStatus.areaUUID].name : "N/A",
            this.flatZones[this.zoneSelected] ?  this.flatZones[this.zoneSelected].name : "N/A",
            this.user.location.lat,
            this.user.location.long,
          )
        ); 
      },
      profile(newProf, oldProf) {
        // set google analytics user properties
        analyticsUserProps(this.profile);
      }
    },
    components,
    created() {
      this.$store.commit('updateSelectedOrder', serverData.order);
      this.$store.commit('updateSelectedOrderType', 'PREVIOUS')
      this.$store.commit('updateMyOrdersPageLoader', false);
      this.$store.commit('updateMyOrdersPageError', false);
      serverData.trip && this.$store.commit('updateSelectedTrip', serverData.trip);

    },
    mounted() {
      vueScriptThis = this;

      this.isGuest && this.$store.dispatch('getUserProfileData', false);

      EventBus.$on('destroyOffersSlider', () => destroyOffersSlider());
      EventBus.$on('checkoutGoToStep1', this.checkoutGoToStep1);
      EventBus.$on('stopTracking', this.stopTracking);
      EventBus.$on('getBasketAddressSuccess', (response) => this.getBasketAddressSuccess(response))
      EventBus.$on('getNotificationData', this.getNotificationData);
      EventBus.$on('showAreaZone', this.showAreaZoneModal)
      EventBus.$on('handleReorderFromShare', this.handleReorderFromShare)
      EventBus.$on('basketErrors', this.basketErrors)
      EventBus.$on('emptyBasketErrors', this.emptyBasketErrors)
      EventBus.$on('noErrersOnBasket', this.noErrersOnBasket)
      EventBus.$on('handleGroupNoLongerActive', this.handleGroupNoLongerActive)
      EventBus.$on('handleLogOut', this.handleLogOut)
      EventBus.$on('handleGroupLocked', this.handleGroupLocked)
      EventBus.$on('changeGroupVisibility', (param) => this.changeGroupVisibility(param))
      EventBus.$on('handleGroupError', (err) => this.handleGroupError(err))
      this.$store.dispatch('GET_SETTINGS');
      EventBus.$on('addItemSuccess', (param) => this.addItemSuccess(param))
      EventBus.$on('placeOrderSuccess', this.placeOrderSuccess)
      EventBus.$on('updateDeliveryTimeFromDetails', this.updateDeliveryTimeFromDetails)
      EventBus.$on('closeChat', this.closeChat)
      EventBus.$on('modalToggler', ([modal, method]) => this.modalToggler(modal, method))
      EventBus.$on('disablePlaceorderButton', this.disablePlaceorderButton);
      EventBus.$on('editAddressData', ([uuid, mapId]) => this.editAddressData(uuid, mapId));
      EventBus.$on('openNotyf', ([type, message]) => this.openNotyf(type, message));

      //fetch and activate remote config
      this.fetchAndActivetRemoteConfig();

      if (data.zonesList && data.zonesList.length > 0 && !data.zonesList.find(item => item.uuid == getCookie(cookies.userZone))) {
        var pages = ['/delivery', '/dineout'];
        const isPage = pages.filter(p => window.location.href.indexOf(p) > -1).length;
        if (isPage || serverData.restaurantHeader) {
          this.storeLocationData(data.zonesList[0].uuid)
        }

      }

      if (this.profile && this.profile.data.profile) {
        this.getNotificationData()
        this.initNotificationScrollEvent();
      }

      if (window.location.href.indexOf('/delivery') > 0) {
        if (!window.location.href.includes(this.dishGameState)) {
          if (serverData.onlineOrderingFilterOpen && !window.location.href.includes('features-order-online')) {
            history.pushState(null, null, window.location.href + '/features-order-online');
          }
        }
        else {
          this.tinderDishes = true
        }

        this.isOnlineOrdering = this.deliveryPage.searchParams.general.orderingEnabled.value;

        if (this.user.areaUUID) {
          this.$store.dispatch('GET_TASTY_OFFERS', { zone: this.user.zoneUUID, area: this.user.areaUUID, companyId: this.user.company ? this.user.company.place_id : null }).then(() => {

            if (this.tastyOffers.data.length > 0) {
              this.$nextTick(offersSlider)
              pushAnalyticsEvent(
                analyticsEvents.discovery.categories.delivery,
                analyticsEvents.discovery.events.tastyOffers,
                analyticsEvents.discovery.labels.companyOffers(0),
                this.tastyOffers.data.length
              )

            }
          })
          if (window.location.href.indexOf('/offers') == -1) {
            pushGoogleAnalytics4Event(this.profile, GA4Events.view.delivery, {
              "Area_Name": this.flatAreas[this.deliveryStatus.areaUUID].name,
            });
          }
        }

      }
      if (window.location.href.indexOf('/dineout') > 0 && this.user.areaUUID) {
        pushGoogleAnalytics4Event(this.profile, GA4Events.view.dineOut);
      }
      if (window.location.href.indexOf('/offers') > 0 && this.user.areaUUID) {
        pushGoogleAnalytics4Event(this.profile, GA4Events.view.offers);
      }
      if (window.location.pathname === '/') {
        pushGoogleAnalytics4Event(this.profile, GA4Events.view.landing);
      }
      if (window.location.href.indexOf('/search') > 0) {
        this.pushMixpanelEvent(
          this.mixpanelEvents.searchScreen.event,
          this.mixpanelEvents.searchScreen.properties(
            window.location.href.split('/search-')[1] ? window.location.href.split('/search-')[1] : 'N/A'
          ));
      }
      // checkWindowForMenuCats();
      this.$nextTick(function () {

        restaurantCardImagesSlider();
        autoWidthSlider();

        window.addEventListener('resize', this.getWindowWidth);

        //Init
        this.getWindowWidth();


      })

      // show first order promo banner after 3 seconds
      setTimeout(() => {
        this.bindConditionalClasses.push('first-order-row')
      }, 500);

      this.profile && this.profile.data.hasDraft && (
        this.$store.dispatch('GET_USER_BASKET_COMPACT')
          .then(() => {
            (this.basketCompact.uuid) ?

              addClassToElements('smartbanner', 'hidden')
              :
              removeClassFromElements('smartbanner', 'hidden')


            if (serverData.restaurantHeader && this.windowWidth > 1024 && (this.basketCompact.uuid)) {
              this.basketisGroup ? this.changeGroupVisibility(true) : this.changeBasketVisibility(true);
            }

            if (this.basketCompact.data.isGroup && this.basketCompact.ref.restaurantUUID == serverData.restaurantUUID)
              this.compactBasketInterval =
                setInterval(function refreshCompact() {
                  if (!vue.showCheckoutModal) {
                    vue.$store.dispatch('GET_USER_BASKET_COMPACT', vue.basketCompact.uuid);
                  }
                  return refreshCompact;
                }(), this.refreshConfigurations.basketCompactInterval * 1000)
          }));

          this.hideRestaurantPromo();
          ensureRemoteConfigInitialize().then(() => {
            if (getRemoteConfigAsBoolean(KEYS.Limited_Tracking_Label) ) {
              data.showLimitedTracking = true;
            }
            data.isRemoteConfigFetched = true;
          });
          
          this.initFreshChat();

      /**************** initialize google one tap sign in ***************/
      // window.onload = function () {
      //   google.accounts.id.initialize({
      //     client_id: '1061131187298-dsfhiv7ku3s1homb3hchjjtqncre9nb1.apps.googleusercontent.com',
      //     'data-auto_select': true,
      //     callback: (response) => {
      //       console.log('response===', response);
      //       this.onOneTapSignedIn(response);
      //     }
      //   });
      //   google.accounts.id.prompt((notification) => {
      //     console.log('notification', notification);
      //   });
      // };
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth);
    },
    updated() {
      (this.basketCompact.uuid)
        ?
        addClassToElements('smartbanner', 'hidden')
        :
        removeClassFromElements('smartbanner', 'hidden')
    },
    methods: {
      setMixpanelSegemntsProps(userId,userSegments){
        mixPanelIdentifyUser(userId);
        //to make sure that the last activated fire base remote config is fetched.
        ensureRemoteConfigInitialize().then((res) => {
          const mixpanelIncludedConfig = getRemoteConfigAsString("Mixpanel_Included_Values");
          if (!mixpanelIncludedConfig) {
            return;
          }
          const values = mixpanelIncludedConfig.split(",");
          let eventProps = {};
          let propsNames = [];
          values.forEach((configName) => {
            const configValue = getRemoteConfigAsString(configName);
            if (configValue) {
              eventProps[configName] = configValue;
              propsNames.push(configName);
            }
          });
          const segmentsKeys = userSegments ? Object.keys(userSegments) : [];
          propsNames.push(...segmentsKeys);

          window["mixpanel"].register({ ...eventProps, ...userSegments });
          localStorage.setItem(LocalStorageKeys.Segments_Setup, "true");

        });
      },
      unRegisterMixpanelSegemntsProps(){ 
        localStorage.removeItem(LocalStorageKeys.Segments_Setup);
        // to unregister super properties on log out
        window["mixpanel"].reset();
        
      },
      fetchAndActivetRemoteConfig() {
        return fetchAndActivate(remoteConfig)
          .then((activate) => {
            // ...
            activate ? console.log('the fetched call was activated.') : console.log('we’re using the already fetched configuration.')
          })
          .catch((err) => {
            // ...
            console.log('catch fetchAndActivate', err)
          });
      },
      getRemoteConfigByKey(key: string) {
        let value = getRemoteConfigValue(key)['_value']
        return value
      },
      getRemoteBooleanConfig(key: string) {
        let value = this.getRemoteConfigByKey(key);
        return value.toLowerCase() === "true" ? true : false;
      },
      // to get a remote config key that has type string | number | boolean
      getTextFromRemoteConfig(name){
        let lang = this.currentLanguage;
        lang = '_'+lang.toUpperCase();
        let text = this.getRemoteConfigByKey(name + lang);
        return text;
      },
      // to get a remote config that has type obj
      getCallPromptText(name, type, key){
        let obj = this.getRemoteConfigByKey(name);
        obj = JSON.parse(obj);
        let lang = this.currentLanguage;
        lang = '_' + lang.toUpperCase();
        key = key + lang;
        let text = type ? obj[type][key] : obj[key];
        return text
      },
      getAppIncentiveText(section:InstallSectionType, key:'title'|'body'){
        const value = JSON.parse(getRemoteConfigAsString(KEYS.Install_Incentives.Key));
        const lang = "_" + this.currentLanguage.toUpperCase();
        let sectionValue = value[section];

        if (!sectionValue || !sectionValue[key + lang]) {
          const defaultValues = JSON.parse(remoteConfig.defaultConfig[
            KEYS.Install_Incentives.Key
          ] as string);
          sectionValue = defaultValues[section];
        }

        return sectionValue[key + lang];
      },
      handleGliderScroll(glider) {
        let index;
        if (isRTL) {
          glider.scrollItem(0, false)
          index = this.deliveryPage.categories.findIndex(item => getUrlSlash('dish-').replaceAll('-', ' ') == item.tag.data.name)
          index = this.deliveryPage.categories.length - 1 - index
        }
        else {
          glider.scrollItem(this.deliveryPage.categories.length - 1, false)
          index = this.deliveryPage.categories.findIndex(item => getUrlSlash('dish-').toLowerCase() == item.tag.data.name.toLowerCase())
        }
        glider.scrollItem(index, false)
      },
      toggleDeliveryDishesViewCount() {
        this.deliveryDishesViewCount = this.deliveryDishesViewCount == 7 ? this.deliveryPage.categories.length : 7
      },
      isWithinTimeFrame(openingTime: string, closingTime: string) {
        let openDateObject = moment(openingTime, "HH:mm:ss");
        let closeDateObject = closingTime < openingTime ? moment(closingTime, "HH:mm:ss").add(1, "days") : moment(closingTime, "HH:mm:ss")

        return moment().isBetween(openDateObject, closeDateObject, undefined, '[]')
      },

      updatePayment(method, carduuid = null) {
        carduuid ? this.$store.commit("updateBasketPaymentCard", carduuid) : this.$store.commit("updateBasketPaymentMethod", method)

        if (navigator.onLine) {
          this.$store.dispatch("UPDATE_BASKET_PAYMENT_METHOD", { method: method, carduuid: carduuid }).catch(() => {
            this.$root.handleGenericErrors(genericErrorsEnum.generic);
          });
        } else {
          this.$root.handleGenericErrors(genericErrorsEnum.internet);
        }
      },
      updatePromoPayment(method, carduuid = null) {
        carduuid && this.$store.commit("updateGiftingPaymentCard", carduuid);
      },
      applyWallet(e) {
        this.$store.commit("updatePaidWithWallet", e.target.checked);
        this.basketCompact.uuid && this.$store.dispatch('APPLY_WALLET_TO_BASKET', e.target.checked);
      },
      applyPromo(promoCode) {
        this.promoRequest.code = promoCode;
        this.$store.commit("updatePromoCode", promoCode);
        this.basketCompact.uuid && this.$store.dispatch('ADD_PROMO_TO_BASKET');
        this.pushApplyPromoEvent('Restaurant Header');
      },

      hideRestaurantPromo(){
        const { restaurantPage, search } = data;
        // removing saved value if user returns any page other that seacrh results page
        if (!restaurantPage.restHeaderObj && !search.restaurantsData) {
          localStorage.removeItem(LocalStorageKeys.Restaurant_Source_Screen);
          return;
        }
        const sourceScreen = localStorage.getItem(LocalStorageKeys.Restaurant_Source_Screen);
        const isSearchScreen = sourceScreen === SourceScreens.Autocomplete || sourceScreen === SourceScreens.SearchPage;
        ensureRemoteConfigInitialize().then(() => {
          if (getRemoteConfigAsBoolean(KEYS.Search_Hide_Promo) && isSearchScreen) {
            restaurantPage.shouldHidePromo = true;
          }
        });
      },
      
      tabsHandler(parentId, targetId) {
        this.bindConditionalClasses.forEach((element) => {
          if (element.startsWith(parentId)) {
            let modalIdIndex = this.bindConditionalClasses.indexOf(element);
            modalIdIndex != -1 && this.bindConditionalClasses.splice(modalIdIndex, 1);
          }
        })
        this.bindConditionalClasses.push(parentId + '-' + targetId);
      },
      collapseHandler(target) {
        let modalIdIndex = this.bindConditionalClasses.indexOf(target);
        modalIdIndex != -1 ? this.bindConditionalClasses.splice(modalIdIndex, 1) : this.bindConditionalClasses.push(target)
      },

      MyOrdersPageInit() {
        this.$store.state.currentOrders.data = [];
        this.$store.state.previousOrders.data = [];
        this.cancelCurrentOrder = false
        this.$store.commit("updateMyOrdersPageLoader", true)
        this.$store.dispatch("GET_MY_ORDERS", [1, 10, "CURRENT"]).then(() => {
          if (this.$store.state.currentOrders.data.length > 0) {
            this.$store
              .dispatch("GET_SPECIFIC_ORDER", [
                getUrlParameter('orderID') ? getUrlParameter('orderID') : this.$store.state.currentOrders.data[0].uuid,
                getUrlParameter('orderID') &&
                  !(this.$store.state.currentOrders.data.some(order => { return order.uuid == getUrlParameter('orderID') }))
                  ?
                  'PREVIOUS' : 'CURRENT'
              ])
              .then(() => {
                if (getUrlParameter('orderID')) {
                  document.getElementById('orders-controller').classList.add('my-orders-mobile')
                  document.getElementById('orders-details').classList.remove('my-orders-mobile')
                }
                this.$root.selectOrder(
                  getUrlParameter('orderID') && !(this.$store.state.currentOrders.data.some(order => { return order.uuid == getUrlParameter('orderID') })) ?
                    'PREVIOUS' : 'CURRENT',
                  getUrlParameter('orderID') ? getUrlParameter('orderID') : this.$store.state.currentOrders.data[0].uuid
                );
                this.$store.commit("updateMyOrdersPageLoader", false)

              }).catch((err) => {
                if (err.response.status == 404) {
                  this.$store
                    .dispatch("GET_SPECIFIC_ORDER", [
                      this.$store.state.currentOrders.data[0].uuid,
                      "CURRENT"
                    ])
                    .then(() => {
                      this.$root.selectOrder(
                        "CURRENT",
                        this.$store.state.currentOrders.data[0].uuid
                      );
                      this.$store.commit("updateMyOrdersPageLoader", false)

                    });
                }
              });
          }
          this.$store.dispatch("GET_MY_ORDERS", [1, 10, "PREVIOUS"]).then(() => {
            if (
              this.$store.state.currentOrders.data.length <= 0 &&
              this.$store.state.previousOrders.data.length > 0
            ) {
              this.$store.dispatch("GET_SPECIFIC_ORDER", [
                getUrlParameter('orderID') ? getUrlParameter('orderID') : this.$store.state.previousOrders.data[0].uuid,
                "PREVIOUS"
              ]).catch((err) => {
                if (err.response.status == 404) {
                  this.$store.dispatch("GET_SPECIFIC_ORDER", [
                    this.$store.state.previousOrders.data[0].uuid,
                    "PREVIOUS"
                  ])
                }
              });
            }
            else if (
              this.$store.state.currentOrders.data.length == 0 &&
              this.$store.state.previousOrders.data.length == 0
            ) {
              document.getElementById("orders-controller").style.display = "none"
              document.getElementById("orders-details").style.display = "none"
            }
          });
        });
      },

      redirectToRestaurant() {
        let url = this.$store.getters.getBasket.ref ?
          URLBuilder.restaurantURL(
            this.$store.getters.getBasket.ref.restaurant ? this.$store.getters.getBasket.ref.restaurant.name : '',
            this.$store.getters.getBasket.ref.restaurant ? this.$store.getters.getBasket.ref.restaurant.shortCode : '',
            this.userCityName ? this.userCityName : 'cairo', '',
            isRTL ? 'AR' : 'EN',
            this.$store.getters.getBasket.ref.branch ? ('-' + this.$store.getters.getBasket.ref.branch.shortCode) : '')
          : '#'
        window.location.href = url
      },
      handleReOrder(uuid) {
        this.$store.state.userBasketStateRequest.restaurantUUID = this.$store.state.selectedOrder.ref.restaurantUUID
        this.$store.dispatch('GET_BASKET_STATE').then(res => {

          if (!this.profile.data.profile) {
            this.modalToggler('re-order-modal', 'show')
          }
          else if (!this.user.zoneUUID) {
            $body.classList.add('modal-open');
            this.bindConditionalClasses.push('add-city-area-modal');
          }
          else {
            if (res.state == 'NO_BASKET') {
              this.$store.dispatch("RE_ORDER", uuid).then(e => {
                this.redirectToRestaurant();

              })
            }
            else if (res.state == 'MEMBER_IN_THIS_GROUP' || res.state == 'MEMBER_IN_ANOTHER_GROUP') {
              this.$store.commit("updateReOrderFromMyOrderPage", true)
              this.$root.modalToggler('leave-another-group-modal', 'show')
            }
            else if (res.state == 'HAS_BASKET_IN_THIS_RESTAURANT' || res.state == 'HAS_BASKET_IN_ANOTHER_RESTAURANT') {
              this.$store.commit("updateReOrderFromMyOrderPage", true)
              this.$root.modalToggler('discard-basket-modal', 'show')
            }
          }

        });
      },
      handleNewUserLocation(res, shouldReload = true, shouldRemoveCompany = true) {

        let reload = shouldReload && (!this.deliveryStatus.areaUUID || this.deliveryStatus.areaUUID !== res.locationInfo.area.uuid);

        if (res.locationInfo.area && res.locationInfo.zone) {
          this.setUserLatCookie(res.position.coords.latitude)
          this.setUserLongCookie(res.position.coords.longitude)
          this.setUserAreaCookie(res.locationInfo.area.uuid, shouldRemoveCompany)
          this.setUserZoneCookie(res.locationInfo.zone.uuid, shouldRemoveCompany);
        }
        else {
          reload = false;
        }
        if (reload) {
          var url = window.location.pathname.split('/')
          if ((url.indexOf(this.flatAreas[res.locationInfo.area.uuid].name) < 0)) {
            if (url.indexOf('delivery') < 0 && url.indexOf('dineout') < 0) {
              this.deliveryStatusDetectLocationHandler(res.locationInfo.area.uuid,
                URLBuilder.restaurantURL(this.restaurantPage.restHeaderObj.name,
                  this.restaurantPage.restHeaderObj.restaurantShortCode,
                  this.flatCities[res.locationInfo.city.uuid].name,
                  '', lang, ''));
            }
            else {
              window.location.href = this.updateAreaInURLDiscovery(res.locationInfo.area.uuid, res.locationInfo.city.uuid);

            }
          }
        }
        else {
          if (res.locationInfo.zone) {
            this.hideCityAreaModal();
          }
          else {
            this.cityAreasSelected = res.locationInfo.city.uuid;
            this.allAreaZonesChangeHandler(res.locationInfo.area.uuid);

          }
        }
      },
      geolocation() {
        return new Promise((resolve, reject) => {
          this.newGetCurrentLocation().then(res => {
            this.handleNewUserLocation(res)
            

            resolve(res);
          }).catch(() => {
            reject();
          })
        });
        
      },
    

   
      convertArrayToPolygonObj(Coords, zoneUUID, setLocationCenter, shouldDrawPolygon) {
        this.polygonCoords = [];
        var bounds = new google.maps.LatLngBounds();
        var i;
        Coords.coordinates[0].map(coord => {
          this.polygonCoords.push({
            lat: coord[1],
            lng: coord[0]
          })
        })
        for (i = 0; i < this.polygonCoords.length; i++) {
          bounds.extend(this.polygonCoords[i]);
        }
        this.flatZones[zoneUUID].centerLocation.lat = bounds.getCenter().lat();
        this.flatZones[zoneUUID].centerLocation.lon = bounds.getCenter().lng();
        setLocationCenter && this.changeMapCenter({ lat: this.flatZones[zoneUUID].centerLocation.lat, lng: this.flatZones[zoneUUID].centerLocation.lon });
      },
      updatePinAddress(mapId) {
        this.detectingLocation = true;
        this.addressMapId = mapId;
        this.newGetCurrentLocation().then((res) => {
          if (res.locationInfo.area && res.locationInfo.zone) {
            this.setUserLatCookie(res.position.coords.latitude)
            this.setUserLongCookie(res.position.coords.longitude)
            this.setUserAreaCookie(res.locationInfo.area.uuid)
            this.setUserZoneCookie(res.locationInfo.zone.uuid);
          }
          this.changeMapCenter({
            lat: res.position.coords.latitude,
            lng: res.position.coords.longitude
          });

          //this.getZonePolygon(this.addressPolygonZone);   
          this.updateUserAddressLocation(res);
          this.detectingLocation = false;
        })
          .catch(() => {
            this.detectingLocation = false;

          });


      },
      newDetectLocation(lat, long) {
        return new Promise((resolve, reject) => {
          axios({
            method: "GET",
            url: servicesURL.locationDetect(lat, long),
            headers
          }).then(
            (res) => {
              resolve(res.data)
            }).catch((res) => {
              reject(res)
            }

            );

        });
      },
      returnCompaniesByLocation(lat, long) {
        let location = new google.maps.LatLng(lat, long)
        // let input = <HTMLInputElement>document.getElementById('autoCompleteCompany');
        let nearbyDiv = <HTMLDivElement>document.getElementById('nearbyContainer')

        /*get nearby*/
        let service = new google.maps.places.PlacesService(nearbyDiv);
        service.nearbySearch({
          location: location,
          rankBy: google.maps.places.RankBy.DISTANCE, type: 'establishment'
        }, this.fillNearby);
      },
      returnCompaniesInZone() {
        let input = <HTMLInputElement>document.getElementById('autoCompleteCompany');

        /*set autocomplete */
        if (!autocomplete) {

          autocomplete = new google.maps.places.Autocomplete(input,
            { types: ['establishment'], strictBounds: true, fields: ['place_id', 'name', 'types', 'geometry'] });
          autocomplete.setComponentRestrictions({ 'country': ['eg'] });
          autocomplete.addListener('place_changed', this.chooseCompanyFromAutoComplete);
        }
        !this.isMobile && (this.companyModalLoading = false)
      },
      chooseCompanyFromAutoComplete() {
        //bakheet handle choose company from auto
        let place = autocomplete.getPlace();

        this.chooseCompany(place)
      },

      chooseCompany(place) {
        //bakheet handle choose company from nearby
        this.newDetectLocation(place.geometry.location.lat(), place.geometry.location.lng()).then(res => {
          if (place.place_id && this.flatAreas[res.area.uuid].companyOffersEnabled) {
            let obj = {
              locationInfo: res,
              position: {
                coords: {
                  latitude: place.geometry.location.lat(),
                  longitude: place.geometry.location.lng(),
                }
              }
            }
            this.handleNewUserLocation(obj, false, false) //sending false to prevent reload and prevent removeCompanycookie

            this.companyErrorMsg = false
            this.placeAutocomplete = ''
            this.modalToggler('company-modal', 'hide');
            let namedDetailed = place.name.split(", ", 1);
            place.name = place.vicinity ? place.name : namedDetailed[0];
            place.vicinity = place.vicinity ? place.vicinity : namedDetailed[1]
            this.user.company = place;
            setCookie('Company', JSON.stringify(place), '/');
            this.deliverySearch();
            this.$store.dispatch('GET_TASTY_OFFERS', { zone: this.user.zoneUUID, area: this.user.areaUUID, companyId: this.user.company ? this.user.company.place_id : null }).then(() => {

              if (this.tastyOffers.data.length > 0) {
                this.$nextTick(offersSlider)
                pushAnalyticsEvent(
                  analyticsEvents.discovery.categories.delivery,
                  analyticsEvents.discovery.events.tastyOffers,
                  analyticsEvents.discovery.labels.companyOffers(0),
                  this.tastyOffers.data.length
                )
              }



            })
            pushAnalyticsEvent(
              analyticsEvents.discovery.categories.delivery,
              analyticsEvents.discovery.events.chooseCompany,
              analyticsEvents.discovery.labels.company(this.user.company.name)
            )


          }
          else {
            this.companyErrorMsg = true
            pushAnalyticsEvent(
              analyticsEvents.discovery.categories.delivery,
              analyticsEvents.discovery.events.chooseCompanyError,
              analyticsEvents.discovery.labels.company(place.name)
            )
          }
        })

      },
      fillNearby(results, status) {
        this.nearbyCompanies.length = 0;
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          Promise.all(results.slice(0, 5).map(i => {
            this.nearbyCompanies.push({ name: i.name, place_id: i.place_id, types: i.types, vicinity: i.vicinity, icon: i.icon, geometry: i.geometry })
          })).then(() => {
            this.companyModalLoading = false;
          })
        }
        else {
          this.companyModalLoading = false;
        }    
},
    
      getZonePolygon(zoneUUID, setLocationCenter=true, shouldDrawPolygon=true) {
        axios({
          method: "GET",
          url: servicesURL.getZonePolygon(zoneUUID),
          headers
        })
          .then(res => {
            this.convertArrayToPolygonObj(JSON.parse(res.data), zoneUUID, setLocationCenter, shouldDrawPolygon)
          })
          .catch(error => {
            console.log("error", error)
          });
      },
      getAreaNameFromURLDiscovery(discoverPage) {
        let urlParams = decodeURI(window.location.href).split('/');
        let areaName = urlParams[urlParams.findIndex(item => item == discoverPage) + 1]
        return areaName && serverData.lookups.areas.some(
          item =>
            URLBuilder.dasher(item.data.name.toLowerCase()) == areaName.toLowerCase()
        ) ?
          areaName : ''
      },
      getCityNameFromURLDiscovery(discoverPage) {
        let urlParams = decodeURI(window.location.href).split('/');
        let cityName = urlParams[urlParams.findIndex(item => item == discoverPage) - 1]
        return cityName && serverData.lookups.cities.some(
          item =>
            URLBuilder.dasher(item.data.name.toLowerCase()) == cityName.toLowerCase()
        ) ?
          cityName : ''
      },
      updateAreaInURLDiscovery(areaUUID, cityUUID) {
        let discoverPage = window.location.pathname.indexOf('/delivery') > 1 ? 'delivery' : 'dineout'
        let newURL = decodeURI(window.location.href)
          .replace(this.getCityNameFromURLDiscovery(discoverPage), URLBuilder.dasher(this.flatCities[cityUUID].name))
          .replace(this.getAreaNameFromURLDiscovery(discoverPage) ? this.getAreaNameFromURLDiscovery(discoverPage) : discoverPage,
            this.getAreaNameFromURLDiscovery(discoverPage) ? URLBuilder.dasher(this.flatAreas[areaUUID].name) : discoverPage + '/' + URLBuilder.dasher(this.flatAreas[areaUUID].name))

        window.history.pushState(
          null,
          null,
          newURL
        );
        return newURL;
      },
      updateDishes() {
        this.deliveryPage.reloadingAll = true;
        axios.get(servicesURL.discovery.delivery.lookups(this.areaZonesSelected), { headers }).then(res => {
          this.deliveryCategories = res.data;
          this.deliveryPage.reloadingAll = false;
        });
      },
      updateDishDetails() {
        this.deliveryPage.reloadingAll = true;
        let searchParams = `?includeDiscount=true&area=${this.areaZonesSelected}&category=${this.selectedDish.dishUUID}${this.deliveryPage.searchParams.general.orderingEnabled.value && this.zoneSelected ? '&zone=' + this.zoneSelected + '&orderingEnabled=' + this.deliveryPage.searchParams.general.orderingEnabled.value : ''}&sort=${this.deliveryPage.sortingOptions[0].value}&page=1&pageSize=12`
        axios.get(servicesURL.discovery.delivery.search(searchParams), { headers }).then(res => {
          destroyRestaurantCardImagesSlider();
          this.categoryRestaurants = res.data;
          if (res.status == 200) {
            setTimeout(() =>
              this.$nextTick(() => {
                restaurantCardImagesSlider()
              })
              , 0);
            this.deliveryPage.reloadingAll = false;
          }
        });
      },
      updateOffers() {
        this.deliveryPage.reloadingAll = true;
        axios.get(servicesURL.discovery.delivery.allOffers(`?includeDiscount=true&area=${this.areaZonesSelected}${this.zoneSelected ? '&zone=' + this.zoneSelected : ''}`), { headers })
          .then(res => {
            destroyRestaurantCardImagesSlider();
            this.offersRestaurants = res.data;
            if (res.status == 200) {
              setTimeout(() =>
                this.$nextTick(() => {
                  restaurantCardImagesSlider()
                })
                , 0);
              this.deliveryPage.reloadingAll = false;
            }
            //  handleLoadMore(res, loadMore, searchParams);

          })
          .catch(error => {
            console.log("error", error);
            this.deliveryPage.reloadingAll = false;
          })
      },
      updatePromoRestaurants(page = 1) {
        this.deliveryPage.reloadingAll = true;
        axios.get(servicesURL.discovery.delivery.cvm(this.cvmPromoData.name, this.areaZonesSelected, this.zoneSelected, page), { headers })
          .then(res => {
            destroyRestaurantCardImagesSlider();
            if (page == 1) {
              this.cvmRestaurants = res.data;
            } else {
              this.cvmRestaurants.data = this.cvmRestaurants.data.concat(res.data.data);
              this.cvmRestaurants.page = page
            }
            setTimeout(() =>
              this.$nextTick(() => {
                restaurantCardImagesSlider()
              })
            , 0);
            this.deliveryPage.reloadingAll = false;

          })
          .catch(error => {
            console.log("error in updatePromoRestaurants", error);
            this.deliveryPage.reloadingAll = false;
          })
      },
      pushZoneClickingEvent(zoneUUID) {
        const selectZone = this.zonesList.filter((zone) => zone.uuid == zoneUUID)[0];
        pushGoogleAnalytics4Event(this.profile, GA4Events.action.clickOnZone, {
          "Zone_UUID": zoneUUID,
          "Zone_Name": selectZone.name
        });
      },
      pushAreaClickingEvent(areaUUID) {
        const area = this.areasList.filter((area) => area.uuid == areaUUID)[0];
        pushGoogleAnalytics4Event(this.profile, GA4Events.action.clickOnArea, {
          "Area_UUID": areaUUID,
          "Area_Name": area.name
        });
      },
      pushViewBasketEvent(basket) {
        pushGoogleAnalytics4Event(this.profile, GA4Events.action.viewBasket, {
          "Restaurant_Name": basket.ref.restaurant.name,
          "Restaurant_UUID": basket.ref.restaurant.uuid
        });
      },
      pushInstallAppEvent(sourceScreen) {
        pushGoogleAnalytics4Event(this.profile, GA4Events.action.installApp, {
          SourceScreen: sourceScreen,
        });
      },
      pushApplyPromoEvent(sourceScreen) {
        pushGoogleAnalytics4Event(this.profile, GA4Events.action.applyPromo, {
          SourceScreen: sourceScreen,
        })
      },
      pushViewLocationPromptEvent() {
        pushGoogleAnalytics4Event(this.profile, GA4Events.view.locationPrompt);
      },
      handleClickCallRestaurant() {
        this.hideFOPModal();
        this.showCallModal && this.showCallPrompt(); 
        const onlineOrderingEnabled =  this.restaurantPage.restHeaderObj.onlineOrdering && this.restaurantPage.restHeaderObj.branchOrderingEnabled
        pushGoogleAnalytics4Event(this.profile, GA4Events.action.callRestaurant, {
          'Restaurant_Name': this.restaurantPage.restHeaderObj.name,
          'Online_Ordering_Enabled': onlineOrderingEnabled,
          'Delivers_To_User': onlineOrderingEnabled && this.restaurantPage.restHeaderObj.branchDeliversToLocation,
        });
      },
      pushCallPromptViewEvent() {
        const onlineOrderingEnabled =  this.restaurantPage.restHeaderObj.onlineOrdering && this.restaurantPage.restHeaderObj.branchOrderingEnabled
        pushGoogleAnalytics4Event(this.profile, GA4Events.action.callPromptOrderOnline, {
          'Restaurant_Name': this.restaurantPage.restHeaderObj.name,
          'Online_Ordering_Enabled': onlineOrderingEnabled,
          'Delivers_To_User': onlineOrderingEnabled && this.restaurantPage.restHeaderObj.branchDeliversToLocation,
        });
      },
      storeLocationData(zone, cityUUID='',addressLocation=null) {
        !addressLocation && this.pushZoneClickingEvent(zone);
        if (window.location.href.indexOf('/orders/') > -1 || (window.location.href.indexOf('/offers') > -1 && window.location.href.indexOf('/delivery') == -1)) {
          this.zoneSelected = zone;
          if(cityUUID != '') {
            this.cityAreasSelected = cityUUID;
          }
          this.areaZonesSelected = this.flatZones[zone] && this.flatZones[zone].areaUUID;
          this.setUserLocationCookies(this.cityAreasSelected, this.areaZonesSelected, zone);
         if(addressLocation){this.setUserLatCookie(addressLocation.lat)
          this.setUserLongCookie(addressLocation.lon)}
          else this.clearLatLongCookie();
          this.hideCityAreaModal()
          this.handleReorderFromShare();
          if (window.location.href.indexOf('/offers') > -1 && window.location.href.indexOf('/delivery') == -1) {
            if (!this.cvmPromoData.name) {
              location.reload();
            } else {
              this.updatePromoRestaurants();
            }
          }
        }
        else {

          let reload = false;
          this.zoneSelected = zone;
          if(cityUUID != '') {
            this.cityAreasSelected = cityUUID;
          }
          this.areaZonesSelected = this.flatZones[zone] && this.flatZones[zone].areaUUID;
          if (serverData.restaurantHeader) {
            this.deliveryStatus.isDeliver = serverData.restaurantHeader.branchDeliversToLocation;
            this.restaurantPage.orderingFlagMessage = orderingFlag(
              staticContent,
              this.restaurantPage.restHeaderObj.restaurantOrderingEnabled,
              this.restaurantPage.restHeaderObj.branchDeliversToLocation,
              this.restaurantPage.restHeaderObj.onlineOrdering,
              this.restaurantPage.restHeaderObj.branchOrderingEnabled,
              this.flatAreas[this.deliveryStatus.areaUUID] && this.flatAreas[this.deliveryStatus.areaUUID].orderingEnabled,
              this.restaurantPage.restHeaderObj.openNow,
              this.flatAreas[this.deliveryStatus.areaUUID] && this.flatAreas[this.deliveryStatus.areaUUID].name
            )
          }
          if (window.location.href.indexOf('/dishes-') <= -1 && window.location.href.indexOf('/offers') <= -1 && (!this.deliveryStatus.areaUUID || this.deliveryStatus.areaUUID !== this.areaZonesSelected)) {
            reload = true;
            this.deliveryStatus.areaUUID = this.areaZonesSelected
          }
          else {
            this.zoneSelected = zone;
            serverData.restaurantHeader && (this.deliveryStatus.isDeliver = !!serverData.restaurantHeader.branchDeliversToLocation);

          }
          this.setUserLocationCookies(this.cityAreasSelected, this.areaZonesSelected, zone);
          if(addressLocation){this.setUserLatCookie(addressLocation.lat)
            this.setUserLongCookie(addressLocation.lon)}
            else this.clearLatLongCookie();
          if (this.restPageFlag) {
            const tabName = data.restaurantTabs.indexOf(window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1)) > -1 ? '/' + window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1) : '';
            const restaurantURL = `${window.location.origin + this.restURL + tabName}?area=${this.areaZonesSelected}`;
            // refresh page with new area
            (!this.isGroupOrderPage && reload) ? (window.location.href = restaurantURL) : this.hideCityAreaModal()

            this.restPageFlag = false;
          }
          else {
            // refresh page with new url
            if (reload) {
              window.location.href = this.updateAreaInURLDiscovery(this.areaZonesSelected, this.cityAreasSelected);
            }
            else {
              this.hideCityAreaModal();
              switch (true) {
                case window.location.href.indexOf('/dishes-all') > -1:
                  this.updateAreaInURLDiscovery(this.areaZonesSelected, this.cityAreasSelected);
                  this.updateDishes();
                  break;
                case (window.location.href.indexOf('/dishes-') > -1 && window.location.href.indexOf('/dishes-all') == -1):
                  this.updateAreaInURLDiscovery(this.areaZonesSelected, this.cityAreasSelected);
                  this.updateDishDetails();
                  break;
                case (window.location.href.indexOf('/offers') > -1 && window.location.href.indexOf('/delivery') == -1):
                  this.updatePromoRestaurants();
                  break;

                case (window.location.href.indexOf('/offers') > -1 && window.location.href.indexOf('/delivery') > -1):
                  this.updateAreaInURLDiscovery(this.areaZonesSelected, this.cityAreasSelected);
                  this.updateOffers();
                  break;

                default:
                  if (!serverData.restaurantHeader) {
                    this.deliveryParamsHandler();
                  }
              }
            }
          }
        }
      },
      storeUserLocation(obj) {
        if (window.location.href.indexOf('/orders/') > -1 || (window.location.href.indexOf('/offers') > -1 && window.location.href.indexOf('/delivery') == -1)) {
          this.cityAreasSelected = obj.cityUuid;
          this.areaZonesSelected = obj.ref.areaUUID;
          this.zoneSelected = obj.uuid;
          this.areaZonesSelected = this.flatZones[obj.uuid] && this.flatZones[obj.uuid].areaUUID;
          this.setUserLocationCookies(this.cityAreasSelected, this.areaZonesSelected, obj.uuid);
          this.clearLatLongCookie();
          this.hideCityAreaModal();
          this.handleReorderFromShare();
          if (window.location.href.indexOf('/offers') > -1 && window.location.href.indexOf('/delivery') == -1) {
            if (!this.cvmPromoData.name) {
              location.reload();
            } else {
              this.updatePromoRestaurants();
            }
          }
        }
        else {
          let reload = false;
          this.cityAreasSelected = obj.cityUuid;
          this.areaZonesSelected = obj.ref.areaUUID;
          this.zoneSelected = obj.uuid;
          if (serverData.restaurantHeader) {
            this.deliveryStatus.isDeliver = serverData.restaurantHeader.branchDeliversToLocation;
            this.restaurantPage.orderingFlagMessage = orderingFlag(
              staticContent,
              this.restaurantPage.restHeaderObj.restaurantOrderingEnabled,
              this.restaurantPage.restHeaderObj.branchDeliversToLocation,
              this.restaurantPage.restHeaderObj.onlineOrdering,
              this.restaurantPage.restHeaderObj.branchOrderingEnabled,
              this.flatAreas[this.deliveryStatus.areaUUID] && this.flatAreas[this.deliveryStatus.areaUUID].orderingEnabled,
              this.restaurantPage.restHeaderObj.openNow,
              this.flatAreas[this.deliveryStatus.areaUUID] && this.flatAreas[this.deliveryStatus.areaUUID].name
            )
          }
          if (window.location.href.indexOf('/dishes-') <= -1 && window.location.href.indexOf('/offers') <= -1 && (!this.deliveryStatus.areaUUID || this.deliveryStatus.areaUUID !== this.areaZonesSelected)) {
            reload = true;
            this.deliveryStatus.areaUUID = this.areaZonesSelected
          }
          this.setUserLocationCookies(this.cityAreasSelected, this.areaZonesSelected, obj.uuid);
          this.clearLatLongCookie();
          if (this.restPageFlag) {
            const tabName = data.restaurantTabs.indexOf(window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1)) > -1 ? '/' + window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1) : '';
            const restaurantURL = `${window.location.origin + this.restURL + tabName}?area=${obj.ref.areaUUID}`;
            // refresh page with new area
            !this.isGroupOrderPage && reload ? (window.location.href = restaurantURL) : this.hideCityAreaModal()
            this.restPageFlag = false;
          }
          else {
            // refresh page with new url
            if (reload) {
              window.location.href = this.updateAreaInURLDiscovery(this.areaZonesSelected, this.cityAreasSelected);
            } else {
              this.hideCityAreaModal();
              switch (true) {
                case window.location.href.indexOf('/dishes-all') > -1:
                  this.updateAreaInURLDiscovery(this.areaZonesSelected, this.cityAreasSelected);
                  this.updateDishes();
                  break;
                case (window.location.href.indexOf('/dishes-') > -1 && window.location.href.indexOf('/dishes-all') == -1):
                  this.updateAreaInURLDiscovery(this.areaZonesSelected, this.cityAreasSelected);
                  this.updateDishDetails();
                  break;
                case (window.location.href.indexOf('/offers') > -1 && window.location.href.indexOf('/delivery') == -1):
                  this.updatePromoRestaurants();
                  break;

                case (window.location.href.indexOf('/offers') > -1 && window.location.href.indexOf('/delivery') > -1):
                  this.updateAreaInURLDiscovery(this.areaZonesSelected, this.cityAreasSelected);
                  this.updateOffers();
                  break;
                default:
                  this.deliveryParamsHandler();
              }
            }
          }
        }

      },
      clearLatLongCookie() {
        setCookie(cookies.lat, '', '/', '');

        setCookie(cookies.long, '', '/', '');
      },
      clearSearch() {
        this.searchText = '';
      },
      setIsGroupOrderPage(value) {
        this.isGroupOrderPage = value;
      },
      setGroupLangUrl(value) {
        this.groupLangUrl = value;
      },
      setPhotoDetails(photoDetails){
        this.restaurantPage.photosTab.serverPhotoDetails = photoDetails
      },
      setGroupPageData(groupUUID, areaUUID){
        this.groupPageGroupUUID = groupUUID;
        this.groupPageAreaUUID = areaUUID;
      },
      confirmCancelOrder() {
        this.cancelCurrentOrder = true;
      },
      newGetCurrentLocation() {
        return new Promise((resolve, reject) => {
          if (navigator.geolocation && this.isMobile) {
            navigator.geolocation.getCurrentPosition(
              (pos) => {
                let locationInfo;
                this.detectLocationPermissionError = false
                this.newDetectLocation(pos.coords.latitude, pos.coords.longitude)
                  .then((res) => {
                    locationInfo = res;
                    this.locationDetailsFoundError = (res.city && res.area && res.zone) ? false : true
                    resolve({ locationInfo: locationInfo, position: pos })
                  }).catch(() => {
                    this.locationDetailsFoundError = true;
                    reject();
                  })
              },
              () => {
                this.detectLocationPermissionError = true;
                reject();
              }
            )
          }
          else {
            this.detectLocationPermissionError = true;
            reject();
          }
        });

      },
      updateUserAddressLocation(data) {
        this.checkoutCycle.addressForm.city = data.locationInfo.city ? data.locationInfo.city.data.name : staticContent.restaurant.addressForm.outOfCoverage
        this.checkoutCycle.addressForm.area = data.locationInfo.area ? data.locationInfo.area.data.name : staticContent.restaurant.addressForm.outOfCoverage
        this.checkoutCycle.addressForm.zone = data.locationInfo.zone ? data.locationInfo.zone.data.name : staticContent.restaurant.addressForm.outOfCoverage

        this.checkoutCycle.addressForm.cityUUID = data.locationInfo.city ? data.locationInfo.city.uuid : null;
        this.checkoutCycle.addressForm.areaUUID = data.locationInfo.area ? data.locationInfo.area.uuid : null;
        this.checkoutCycle.addressForm.zoneUUID = data.locationInfo.zone ? data.locationInfo.zone.uuid : null;
        (this.addressPolygonZone && this.addressPolygonZone !== this.checkoutCycle.addressForm.zoneUUID) ? (this.isZoneLikePolyZone = false) : this.isZoneLikePolyZone = true;
        
        if (this.checkoutCycle.addressForm.location) {
          this.checkoutCycle.addressForm.location.lat = data.position.coords.latitude;
          this.checkoutCycle.addressForm.location.lon = data.position.coords.longitude;
        }
        else {
          this.checkoutCycle.addressForm.location = { 'lat': data.position.coords.latitude, 'lon': data.position.coords.latitude };
        }
      },


      initCompanyModalWithLocation() {
        return new Promise((resolve, reject) => {
          this.newGetCurrentLocation().then((res) => {
            if (res.locationInfo.area && res.locationInfo.zone) {
              // found area && zone
              // if(this.nearbyCompanies.length <= 0)
              if ((this.flatAreas[res.locationInfo.area.uuid].companyOffersEnabled && this.nearbyCompanies.length <= 0)
                ||
                (this.flatAreas[res.locationInfo.area.uuid].companyOffersEnabled && this.nearbyCompanies.length > 0 && res.locationInfo.area.uuid != this.user.areaUUID)) {
                this.returnCompaniesByLocation(res.position.coords.latitude, res.position.coords.longitude)
                resolve(res);
              }
              else {
                reject();
              }

            }
            else {
              // no area and zone
              reject();

            }



          }).catch(() => {

            reject();
          })
        })
      },
      initCompanyModal() {
        pushAnalyticsEvent(
          analyticsEvents.discovery.categories.delivery,
          analyticsEvents.discovery.events.selectCompany,
          analyticsEvents.discovery.labels.area(this.flatAreas[this.user.areaUUID].name)
        );
        this.companyModalLoading = true;

        if (this.isMobile) {
          this.returnCompaniesInZone();
          this.initCompanyModalWithLocation().then(() => {
            this.companyModalInitiated = true;

          }).catch(() => {
            this.companyModalLoading = false;
          })
        }

        else if (!this.isMobile && !this.companyModalInitiated) {
          this.returnCompaniesInZone();
          this.companyModalInitiated = true;
          this.companyModalLoading = false;

        }
        else {
          this.companyModalLoading = false;
        }
      },
      withInTime(from, to) {
        if (from) {
          let oldFormat = 'HH:mm:ss';
          let newFormat = 'HHmmss';
          let openingTime = moment(from, oldFormat).format(newFormat);
          let closingTime = moment(to, oldFormat).format(newFormat);
          let timeNow = moment().format(newFormat);  // getting current time from user's local device // this was not 
          return openingTime == closingTime || // open 24 hours
            (openingTime < closingTime && openingTime < timeNow && closingTime > timeNow) ||  // both open and close in the same day
            (
              openingTime > closingTime && // open <  midnight close after midnight 10 pm to 2 am
              (
                (openingTime < timeNow && closingTime < timeNow) || // <  midnight part 11 pm
                (openingTime > timeNow && closingTime > timeNow)  // after midnight part 1 am
              )
            );
        }
        else
          return false
      },
      updateDeliveryTimeFromDetails() {
        this.isRamadanOnly && this.basket.data.deliveryTime != 'IFTAR' && this.$store.dispatch('SET_RAMADAN_ORDER_TYPE', 'IFTAR')
      },
      changeDeliveryTime(type) {
        if (!this.isRamadanOnly) {
          if(this.basket.didToggleDeliveryTime) { // push event only if the user used delivery times prompt
            pushGoogleAnalytics4Event(this.$store.state.profile, GA4Events.action.deliveryTime, {
              "User_UUID": this.profile.uuid,
              "Restaurant_UUID": this.basket.ref.restaurant.uuid,
              Choice: type,
            });
          }
          this.$store.dispatch('UPDATE_DELIVERY_PROMPT_TOGGLE', true);
          this.$store.dispatch('SET_RAMADAN_ORDER_TYPE', type);
        }
      },
      showAlert(title, description = null, icon = "/public/img/discard-basket.svg") {
        this.$store.commit('updateAlert', { title: title, description: description, icon: icon });
        this.modalToggler('alert-modal', 'show');
      },
      orderOnlineTogglerChangeHandler() {
        this.deliveryParamsHandler();
        pushGoogleAnalyticsEvent(
          this.googleAnalyticsEvents.delivery.events.online_ordering_toggle.event,
          this.googleAnalyticsEvents.delivery.events.online_ordering_toggle.label,
          this.googleAnalyticsEvents.delivery.category
        )
      },
      showFirstPromoTooltip() {
        this.deliveryPage.searchParams.general.orderingEnabled.value = true;
        this.deliveryPage.searchParams.features.promoEnabled.value = true;
        window.scroll({
          top: 250,
          left: 0,
          behavior: 'smooth'
        });
        this.orderOnlineTogglerChangeHandler();
      },
      updatePhotosURL(url, version, ext = this.photosUrlEnum.ext.JPG) {
        return updatePhotosURL(url, version, ext)
      },
      switchLang() {
        getCookie(cookies.lang) == lang.ar ? setCookie(cookies.lang, lang.en, '/') : setCookie(cookies.lang, lang.ar, '/');
        //window.location.reload();
      },
      changeSeeAgian(e) {
        if (e.target.checked) {
          setCookie(cookies.FOPModal, true, '/', '');
        }
        else {
          setCookie(cookies.FOPModal, false, '/', '');
        }
      },
      showCallPrompt() {
        this.modalToggler('calling-modal', 'show');
        pushAnalyticsEvent(
          analyticsEvents.restaurant.category,
          analyticsEvents.restaurant.events.callModal,
          analyticsEvents.restaurant.labels.enabledState(this.restaurantPage.restHeaderObj.onlineOrdering && this.restaurantPage.restHeaderObj.branchOrderingEnabled)
        )
      },
      hideCallPrompt() {
        this.modalToggler('calling-modal', 'hide');
      },
  
      hideFOPModal() {
        this.modalToggler('before-call-modal', 'hide');
      },
      getOfferStartOrdering(promoCode) {
        this.promoRequest.code = promoCode;
        this.$store.commit("updatePromoCode", promoCode);
        this.pushApplyPromoEvent('Call Prompt');
        if (this.basketCompact.uuid) {
          this.$store.dispatch('ADD_PROMO_TO_BASKET').then(res => {
            this.goToMenu();
          })
            .catch(err => {
              this.modalToggler('before-call-modal', 'hide');
            })
        }
        else {
          this.goToMenu();
        }
      },
      goToMenu() {
        const url = window.location.pathname;
        const tabsElments = ['scanned-menu', 'info', 'branches', 'photos', 'reviews'];
        const lastItem = url.substring(url.lastIndexOf('/') + 1)
        if (tabsElments.indexOf(lastItem) >= 0) {
          const menuUrl = url.replace(lastItem, '');
          window.location.href = menuUrl;
        }
        else {
          this.modalToggler('before-call-modal', 'hide');

          let scrollToElement = document.getElementsByClassName('menu-item-tooltip')[0];
          scrollToElement && scrollToElement.classList.add('show');
          if ((scrollToElement as HTMLElement).offsetHeight > 0) {
            if (document.getElementById('dimmer')) {
              document.getElementById('dimmer').classList.remove('display-none')
              document.getElementById('dimmer').classList.add('hygiene-dimmer');
            }

            scrollToElement.scrollIntoView({ block: "center", behavior: 'smooth' });
          }
          else {
            window.scroll({
              top: 500,
              left: 0,
              behavior: 'smooth'
            });
          }

        }
      },
      hideMenuItemTooltip() {
        document.getElementsByClassName('menu-item-tooltip')[0].classList.remove('show');
        if (document.getElementById('dimmer')) {
          document.getElementById('dimmer').classList.remove('display-none')
          document.getElementById('dimmer').classList.remove('hygiene-dimmer');
        }
      },
      getBasketAddressSuccess(response) {
        this.user.addresses = response.applicable.concat(response.notApplicable);
        this.user.sortedAddresses = this.sortUserAddresses(this.user.addresses);
        this.user.flatAddresses = flatUserAddresses(this.user.addresses);
        this.user.focusedAddress == this.user.sortedAddresses && this.focusOnAddress(this.user.sortedAddresses[0].uuid);
        this.user.addresses.length <= 0 ? this.updateAddressFormVisibility(true, 'add', 'map2') : this.updateAddressFormVisibility(false, '', 'map2');
        this.emptyAddressForm();
      },
      callRestaurant(branchUUID: string, number = null, shouldModalOpen = false) {
        if (number) {
          if (shouldModalOpen) {
            // this condition will be true if user click on +1more if restaurant has more than one numbers
            if (number == 'more') {
              $('#before-call-modal').find('.call-anyway').removeAttr('href');
              this.showCallModal = true;

            } else {
              $('#before-call-modal').find('.call-anyway').attr('href', 'tel:' + number);
            }
            this.modalToggler('before-call-modal', 'show');

            pushGoogleAnalytics4Event(this.profile, GA4Events.view.callPrompt, {
              'Restaurant_Name': this.restaurantPage.restHeaderObj.name,
            });
          }
          else {
            window.location.href = 'tel:' + number;
          }
        }
        

        axios({
          method: 'GET',
          url: servicesURL.restaurant.call(branchUUID),
          headers
        })
          .then(res => console.log("res", res))
          .catch(error => console.log("error", error))
      },
      handleReviewModal(state) { // show or hide
        this.modalToggler('single-review-modal', state);
      },
      clearServerPhotoData() {
        if (this.restaurantPage.photosTab.serverPhotoDetails) {
          this.restaurantPage.photosTab.serverPhotoDetails = null
        }
      },
      menuToggler(menuId) {
        this.modalToggler(menuId, 'show');
        let openMenu = this.bindConditionalClasses.findIndex(item => item.includes('rest-menu'));
        openMenu > -1 && this.bindConditionalClasses.splice(openMenu, 1);
      },
      initNotificationScrollEvent() {

        document.addEventListener('scroll', event => {
          let target = <HTMLTextAreaElement>event.target;
          if ((target.classList && target.classList.contains('notifications-component')) || closestByClass(target, 'notifications-component').length) {
            event.stopPropagation();
            const notifyObj = this.notificationsComponent;
            if (
              (target.scrollTop + target.offsetHeight + 10) >= (target.getElementsByClassName('notifications-inner')[0] as HTMLElement).offsetHeight
              && notifyObj.loadMore
              && !notifyObj.loading
            ) {
              this.getNotificationData();
            }
          }
        }, true /*Capture event*/);
      },
      
      setTrackingUUID(e, key, index, page, pageSize, restaurantName, sourceScreen, onlineOrdering,recommended=false) {
        e.preventDefault();

        let indexInPage = null;
        var pageIndex: number;
        if (index != -1) {
          if (pageSize) {
            var pageIndex = Math.floor(index / pageSize);
            indexInPage = index - ((pageIndex) * pageSize);
          } else {
            indexInPage = index;
          }
        }
        const trackingUUID = (key == 'page' && pageIndex >= 0) ? this.xTracking.page && this.xTracking.page[pageIndex] : this.$store.state.xTracking.autocomplete;

        setCookie(cookies.xTracking, JSON.stringify({ uuid: trackingUUID, index: indexInPage, recommended: recommended }), '/', '');
        pushGoogleAnalytics4Event(this.profile, GA4Events.action.clickOnRestaurant, {
          "Restaurant_Name": restaurantName,
          "Online_Ordering_Enabled": onlineOrdering,
          SourceScreen: sourceScreen,
        })
        localStorage.setItem(LocalStorageKeys.Restaurant_Source_Screen, sourceScreen);
        window.location.href = e.target.href;
      },
      communityPhotosSorting() {
        const params = `sort_by=${this.restaurantPage.photosTab.sort.value}&page=1&pageSize=${this.restaurantPage.photosTab.page * this.restaurantPage.photosTab.pageSize}`;

        axios({
          method: "GET",
          url: servicesURL.restaurant.photos(this.restaurantPage.restHeaderObj.restaurantShortCode, params),
          headers
        })
          .then(res => {
            this.restaurantPage.photosTab.communityPhotos = res.data;
            this.restaurantPage.photosTab.communityPhotosData = res.data.data;
            this.restaurantPage.photosTab.flattenCommunityPhotos = flatCommunityPhotos(res.data.data);
            this.bindConditionalClasses.push('load-more-loader');

          })
          .catch(error => {
            console.log("error", error)
          });
      },
      communityPhotosLoadMore(page) {
        let modalIdIndex = this.bindConditionalClasses.indexOf('load-more-loader');
        modalIdIndex != -1 && this.bindConditionalClasses.splice(modalIdIndex, 1);
        this.restaurantPage.photosTab.page = page;
        const params = `sort_by=${this.restaurantPage.photosTab.sort.value}&page=${page}&pageSize=${this.restaurantPage.photosTab.pageSize}`;

        axios({
          method: "GET",
          url: servicesURL.restaurant.photos(this.restaurantPage.restHeaderObj.restaurantShortCode, params),
          headers
        })
          .then(res => {
            this.restaurantPage.photosTab.communityPhotos = res.data;
            this.restaurantPage.photosTab.communityPhotosData = this.restaurantPage.photosTab.communityPhotosData.concat(res.data.data);
            this.restaurantPage.photosTab.flattenCommunityPhotos = Object.assign({}, this.restaurantPage.photosTab.flattenCommunityPhotos, flatCommunityPhotos(res.data.data));
            this.bindConditionalClasses.push('load-more-loader');

          })
          .catch(error => {
            console.log("error", error)
          });
      },
      getPhotoDetails(photoUUID) {
        this.restaurantPage.photosTab.selectedPhotoDetails = null;
        if (this.restaurantPage.photosTab.photoDetailsRequest && this.restaurantPage.photosTab.photoDetailsRequest.readyState != 4) {
          // this.restaurantPage.photosTab.photoDetailsRequest.abort();

        }
        this.restaurantPage.photosTab.photoDetailsRequest = axios({
          method: 'GET',
          url: servicesURL.photos.photo(photoUUID),
          headers
        })
          .then(res => {
            this.restaurantPage.photosTab.selectedPhotoDetails = res.data;
          })
          .catch(error => {
            console.log("error", error)
          })
      },
      photoCardNavigate(action, currentUUID) {
        const photosUUIDs = Object.keys(this.restaurantPage.photosTab.flattenCommunityPhotos);
        const currentIndex = photosUUIDs.indexOf(currentUUID);
        let newPhotoUUID = null;
        if (currentIndex != -1) {

          switch (action) {
            case 'next': {

              if (currentIndex == photosUUIDs.length - 1) {
                var nextIndex = 0;
              } else {
                var nextIndex = currentIndex + 1;
              }

              this.restaurantPage.photosTab.selectedPhoto = this.restaurantPage.photosTab.flattenCommunityPhotos[photosUUIDs[nextIndex]];

              newPhotoUUID = photosUUIDs[nextIndex];
              break;
            };
            case 'prev': {


              if (currentIndex == 0) {
                var prevIndex = photosUUIDs.length - 1;
              } else {
                var prevIndex = currentIndex - 1;
              }

              this.restaurantPage.photosTab.selectedPhoto = this.restaurantPage.photosTab.flattenCommunityPhotos[photosUUIDs[prevIndex]];

              newPhotoUUID = photosUUIDs[prevIndex];
              break;
            };
            default: {
              break;
            }
          }

        }
        if (newPhotoUUID) {
          this.getPhotoDetails(newPhotoUUID);
          window.history.replaceState(null, null, `${this.restaurantPage.photosTab.photosTabURL}/${this.restaurantPage.photosTab.flattenCommunityPhotos[newPhotoUUID].shortCode}`)
        }
      },

      selectCommunityPhoto(photoUUID) {
        this.restaurantPage.photosTab.selectedPhoto = this.restaurantPage.photosTab.flattenCommunityPhotos[photoUUID];
        this.getPhotoDetails(photoUUID);
      },
      photosGridStyle() {
        this.restaurantPage.photosTab.style = 'grid'
      },
      photosCardsStyle() {
        this.restaurantPage.photosTab.style = 'cards'
      },
   

      submitPromoCode() {
        if (navigator.onLine) {
          this.pushMixpanelEvent(
            this.mixpanelEvents.redeemPromo.event,
            this.mixpanelEvents.redeemPromo.properties(
              this.promoRequest.code ? this.promoRequest.code : "N/A"
            )
          )
          this.pushApplyPromoEvent('Checkout Screen');
          this.$store.dispatch("ADD_PROMO_TO_BASKET").then(() => {
            this.basketisGroup &&
              this.$store.dispatch('GET_GROUP_BASKET_SUMMARY', this.basketCompact.uuid)
          })
        }
        else {
          this.handleGenericErrors(genericErrorsEnum.internet);
        }


      },
      userUpdatePromocodeFlag() {
        this.updatePromocodeFlag = true;
      },
      removePromo(){
        if (navigator.onLine) {
          this.$store.dispatch("REMOVE_PROMO_FROM_BASKET").then(() => {
            this.basketisGroup &&
              this.$store.dispatch('GET_GROUP_BASKET_SUMMARY', this.basketCompact.uuid)
          })
        }
        else {
          this.handleGenericErrors(genericErrorsEnum.internet);
        }
      },   
      validateRestaurantMinOrderValue() {
        return validateRestaurantMinOrderValue(this.basket.data.receipt.subTotal, this.basket.data.minimumOrderValue);
      },
   
      pushGoogleAnalyticsEvent(event, event_label, event_category) {
        pushGoogleAnalyticsEvent(event, event_label, event_category)
      },
      pushAnalyticsEvent(event_category, event, event_label = null, event_value = null) {
        pushAnalyticsEvent(event_category, event, event_label, event_value)
      },
      pushMixpanelEvent(event, properties = {}) {
        if (serverData.restaurantHeader) {
          // push mixpanel events if restaurant current branch orderingEnabled
          this.orderingEnabled && pushMixpanelEvent(event, properties)
        }
        else {
          pushMixpanelEvent(event, properties);
        }
      },
      initChat(orderUUID, isInitFromCheckout) {
        let prefix;
        if (apiPrefix.indexOf('dev') > 0) {
          prefix = 'http://crm-dev.elmenus.com:8001'
        }
        else if (apiPrefix.indexOf('test') > 0) {
          prefix = 'http://crm-test.elmenus.com:8001'
        }
        else {
          prefix = 'http://stg01.elmenus.com:8000'
        }
        //intercome built in props
        let Intercom = window['Intercom']
        let intercomSettings = window['intercomSettings']
        // custom user variables

        let name = this.profile.data.profile && (this.profile.data.profile.name.split(' ')[0] + ' ' + (this.profile.data.profile.name.split(' ')[1] ? this.profile.data.profile.name.split(' ')[1] : ''))
        let email = this.profile.data.profile && this.profile.data.email
        //order link and restaurant link if support from checkout or my orders
        let orderLink = orderUUID ? `${prefix}/sls/order/${orderUUID}` : ''
        let Restaurantlink = isInitFromCheckout ? `${prefix}/restaurant/${this.basketCompact.ref.restaurantUUID}` : ''
        let intercomeDirection = isRTL ? 'left' : 'right'
        let intercomeLanguage = isRTL ? 'ar' : 'en'
        // not a guest
        if (this.profile && this.profile.data.profile) {
          // get hashed id
          axios({
            method: 'GET',
            url: servicesURL.chat,
            headers
          })
            .then(res => {
              intercomSettings = {
                app_id: interComeId,
                email: email,
                name: name,
                user_id: this.profile.uuid,
                user_hash: res.data,
                orderLink: orderLink,
                Restaurantlink: Restaurantlink,
                alignment: intercomeDirection,
                language_override: intercomeLanguage
              }
              if (!this.isChatInitiated) {
                Intercom('boot', intercomSettings)
                Intercom('shutdown')
                Intercom('boot', intercomSettings)
              }
              else {
                Intercom('update', intercomSettings)
              }
              this.isChatInitiated = true;
              //show chat if calling support only
              orderUUID && Intercom('show')

            })
            .catch(error => {
              console.log("error", error)
            })
        }
        else {
          // guest user
          intercomSettings = {
            app_id: interComeId,
            alignment: intercomeDirection,
            language_override: intercomeLanguage
          }

          if (!this.isChatInitiated) {
            Intercom('boot', intercomSettings)
            Intercom('shutdown')
            Intercom('boot', intercomSettings)
          }
          else {
            Intercom('update', intercomSettings)
          }
          this.isChatInitiated = true;
        }
      },
      getPrefix() {
        if (window && window.location.host.replace("www.","") !== ("elmenus.com") ) {
          return 'https://fdm-test.elmenus.com';
        }
        
        return 'https://fdm.elmenus.com';
      },
      initFreshChat() {
        const shouldShowFreshChatIcon = sessionStorage.getItem('showFreshChatIcon');
        window["fcWidget"].on("widget:loaded", function(resp) {
          if(shouldShowFreshChatIcon === 'true' && getRemoteConfigAsBoolean(KEYS.Enable_Fresh_Desk)) {
            window["fcWidget"].show();
          } else {
            window["fcWidget"].hide();
          };
        });

        window['fcWidgetMessengerConfig'] = {
          locale: document.documentElement.lang,
          ...(this.profile && {externalId: this.profile.uuid}),
          ...((this.profile && this.profile.data.profile.freshDeskRestoreId) && {restoreId: this.profile.data.profile.freshDeskRestoreId}),
          config: {
            fullscreen: this.isMobile? true : false,
            headerProperty: {
              appName: 'elmenus',
            },
          } 
        };
      },
      initFreshChatWidget(orderUUID, isInitFromCheckout) {
        sessionStorage.setItem('showFreshChatIcon', 'true');
        const FreshChat = window['fcWidget'];
        const prefix = this.getPrefix();
        let chatData = {};

        if(this.profile.data.profile) {
          FreshChat.user.setFirstName(this.profile.data.profile.name);
          FreshChat.user.setEmail(this.profile.data.email);
          chatData = {
            cf_order_link: orderUUID ? `${prefix}/support/order/${orderUUID}` : '',
            cf_source_env: 'Web User Test', //test env
            // cf_source_env: 'Web', //prod env
          }
          FreshChat.user.setProperties(chatData);
        };

        FreshChat.open(); //open widget
        FreshChat.show(); //show chat icon when widget is closed
        
        FreshChat.user.get(function(resp) {
          var status = resp && resp.status;
          if (status !== 200) {
            window['fcWidget'].on("user:created", function(resp) {
              console.info('Freschat User has been created:::', resp);
              var status = resp && resp.status,
              data = resp && resp.data;
              if (status === 200) {
                if (data.restoreId) {
                  //call BE api to add restoreID to save it in DB,
                  axios({
                    method: 'PUT',
                    url: servicesURL.profile.setFreshChatRestoreId,
                    headers,
                    data: {
                      restoreId: data.restoreId
                    }
                  }).then(res => {
                      console.info("Stored restoreId successfully");
                    })
                    .catch(error => {
                      console.error("error", error)
                    });
                };
              };
            });
          };
        });
      },
      openChatWindow(orderUUID, isInitFromCheckout) {
        const shouldShowFreshChat = getRemoteConfigAsBoolean(KEYS.Enable_Fresh_Desk);
        if (shouldShowFreshChat) {
          this.initFreshChatWidget(orderUUID, isInitFromCheckout);
        } else {
          this.initChat(orderUUID, isInitFromCheckout);
        };
      },
      closeChat() {
        let Intercom = window['Intercom']
        Intercom('shutdown')
      },
      disablePlaceorderButton() {
        this.basket.disableSubmit = true

      },
  


      selectOrderToCancel(orderUUID) {
        this.myordersPage.cancelOrder.selectedReason = this.myordersPage.cancelOrder.reasons[0];
        this.myordersPage.cancelOrder.selectedOrderToCancel = orderUUID;
      },

      cancelOrder(orderUUID) {
        axios({
          method: "PUT",
          url: servicesURL.order.cancel(orderUUID),
          headers,
          data: JSON.stringify({
            reason: this.myordersPage.cancelOrder.selectedReason,
            comment: this.myordersPage.cancelOrder.selectedReason == 'CANCELED_OTHER' ? this.myordersPage.cancelOrder.comment : ''
          }),
        })
          .then(res => {
            window['gtag']('event', 'refund', {
              "transaction_id": orderUUID
            })

            this.myordersPage.cancelOrder.selectedOrderToCancel = null;
            this.myordersPage.cancelOrder.comment = '';
            this.modalToggler('cancel-order-modal', 'hide');

            if (res.data.code.toLowerCase() == 'pending') {
              orderUUID == this.resumeOrder.uuid && (this.resumeOrder.cancelLoading = true);
              this.modalToggler('cancel-order-pending-modal', 'show');


            }
            else if (res.data.code.toLowerCase() == 'failed') {
              this.modalToggler('cancel-order-error-modal', 'show');
            }
            else {
              this.modalToggler('cancel-order-pending-modal', 'show');
              this.modalToggler("resume-order-modal", "hide");
              this.myordersPage.cancelOrder.selectedReason = this.myordersPage.cancelOrder.reasons[0];

              this.$store.state.selectedOrder.data && this.$store.state.selectedOrder.data.orderStateEnum == 'CANCELED'
              this.$store.state.lastOrder.data && this.$store.state.lastOrder.data.orderStateEnum == 'CANCELED'


              pushAnalyticsEvent(
                analyticsEvents.myOrders.category,
                analyticsEvents.myOrders.events.cancelOrder
              )
              // window.location.reload();
              this.MyOrdersPageInit();
            }
          })
          .catch(error => {
            this.modalToggler('cancel-order-modal', 'hide');
            this.modalToggler('cancel-order-error-modal', 'show');
          });
      },
      getFlatItemSizes(itemSizes) {
        return itemSizes.reduce((sizes, size) => {
          sizes[size.itemSizeUUID] = Object.assign(
            { sizeUUID: size.sizeUUID },
            { name: size.sizeName },
            { price: size.price },
            {uuid: size.itemSizeUUID},
          );
          return sizes;
        }, {});
      },

      newCalcExtrasTotalPrice(itemExtras) {
        if (!itemExtras) return 0;
        return itemExtras.reduce((exItemsCost, exCat) => exItemsCost + exCat.extraItems.reduce((exCatItemsCost, extraItem) => exCatItemsCost + extraItem.price, 0), 0);
      },

      getOrderItemsCount(orderCategories) {

        return orderCategories.reduce((allCount, category) => allCount + category.items.reduce((count, item) => count + item.quantity, 0), 0);

      },

      dateFromNow(date) {
        return dateFromNow(date)
      },

      formatAMPM(date) {
        return formatAMPM(date);
      },
      closeOrderDetails() {
        this.myordersPage.selectedCurrentOrder = null;
        this.myordersPage.selectedPreviousOrder = null;
        window.history.pushState(
          null,
          null,
          (
            window.location.origin
            + window.location.pathname
          )

        );
      },
      selectOrder(property, orderUUID) {
        // if (property == 'CURRENT') {
        //   this.user.selectedOrderState = null;
        // }
        window.history.pushState(
          null,
          null,
          (
            `${window.location.origin + window.location.pathname}?orderID=${orderUUID}`
          )

        );
      },


      setMyOrdersLoadingData(value) {
        this.myOrdersLoadingData = value;
      },
      setMyOrdersLoadingDataError(value) {
        this.myOrdersLoadingDataError = value;
      },

      itemLikeHandler(liked: boolean, itemUUID: string, initialLikes: number) {
        let flag;
        let addAction = true;
        if (this.likedItems[itemUUID]) {
          this.likedItems[itemUUID] = {
            itemUUID,
            isLikedByUser: !liked,
            likesCount: liked ? initialLikes - 1 : initialLikes + 1,
          };
        } else {
          this.$set(this.likedItems, itemUUID, {
            itemUUID,
            isLikedByUser: !liked,
            likesCount: liked ? initialLikes - 1 : initialLikes + 1,
          });
        }

        let method: string = liked ? 'DELETE' : 'POST';
        this.addLikes(itemUUID, method);
      },
      isItemLiked(itemUUID) {
        return !this.likedItems[itemUUID] ? this.items[itemUUID].isLikedByUser : this.likedItems[itemUUID].isLikedByUser;
      },
      getItemLikes(itemUUID) {
        return !this.likedItems[itemUUID] ? this.items[itemUUID].likesCount : this.likedItems[itemUUID].likesCount;
      },

      addLikes(itemUUID, method) {
        axios({
          method: method,
          url: servicesURL.restaurant.item.like(itemUUID),
          headers
        })
          .then(res => console.log("res", res))
          .catch(error => console.log("error", error));
      },
      toFixedPrice(price) {
        return toFixedPrice(price);
      },
      toFixedPriceFloored(price) {
        return price % 1 != 0 ? this.toFixedPrice(price) : price
      },
      searchLoadmore(q, page, pageSize, city) {
        let modalIdIndex = this.bindConditionalClasses.indexOf('load-more-loader');
        modalIdIndex != -1 && this.bindConditionalClasses.splice(modalIdIndex, 1);

        const params = `query=${q}&page=${page}&pageSize=${pageSize}${city ? ('&cityUUID=' + city) : ''}`;

        axios({
          method: "GET",
          url: servicesURL.restaurant.search(params),
          headers
        })
          .then(res => {
            this.search.searchResponse = res.data;
            this.search.page = page;
            this.xTracking.page = this.xTracking.page ? this.xTracking.page.concat(res.request.getResponseHeader(cookies.xTracking)) : res.request.getResponseHeader(cookies.xTracking);
            this.search.restaurantsData = this.search.restaurantsData.concat(res.data.results);

            // complete

            addClassToElements('loader', 'hide')
            this.$nextTick(() => {
              restaurantCardImagesSlider();
            })
          })
          .catch(error => console.log("error", error))
      },

      searchFormSubmit() {
        pushAnalyticsEvent(
          analyticsEvents.discovery.categories.search,
          analyticsEvents.discovery.events.searchButton,
          analyticsEvents.discovery.labels.keyword(this.search.input)
        )

        if (this.search.input) {
          window.location.href = URLBuilder.search(this.flatCities[this.user.cityUUID].name, this.search.input, getCookie(cookies.lang));
        }
        else {
          window.location.href = URLBuilder.filterDelivery(this.flatCities[this.user.cityUUID].name, "", "", "", isRTL ? "ar" : "", null);
        }
      },



      checkIfHasFilters(filtersObj) {
        for (const key in filtersObj) {

          if (['page', 'pageSize'].indexOf(key) == -1) {

            for (const deepKey in filtersObj[key]) {

              if (deepKey == 'feature') {
                if (filtersObj[key][deepKey].value.length) return true;
              } else {

                if (filtersObj[key][deepKey].value && filtersObj[key][deepKey].name) {

                  return true;

                }

              }

            }

          }

        }
        return false;
      },

      calcActiveFiltersCount(filtersObj) {
        let count = 0;
        for (const key in filtersObj) {

          if (key == 'feature') {
            count += filtersObj[key].value.length;
          } else if (filtersObj[key].value) {
            count++;
          }

        }
        return count;
      },


      dineoutClearFilters(filter, value) {
        const searchParams = this.dineoutPage.searchParams;
        switch (filter) {
          case 'all': {

            searchParams.features.openNow.value = false;
            searchParams.features.feature.value = [];
            searchParams.general.mood.value = false;
            searchParams.general.mood.name = '';
            searchParams.general.category.value = false;
            searchParams.general.category.name = '';

            break;

          }
          case 'feature': {
            const valueIndex = searchParams.features.feature.value.indexOf(value);
            searchParams.features.feature.value.splice(valueIndex, 1);
            break;
          }
          default: {
            const keysArr = filter.split('.');
            keysArr.reduce((params, key) => {

              if (keysArr.indexOf(key) == keysArr.length - 1) (params[key].value = false);

              return params[key];

            }, searchParams)
            break;
          }
        }


        this.dineoutSearch();
      },

      deliveryClearFilters(filter) {
        let searchParams = this.deliveryPage.searchParams;
        switch (filter) {
          case 'all': {

            searchParams.general.orderingEnabled.value = false;
            this.deliveryPage.searchParams.general.category.name = '';
            this.deliveryPage.searchParams.general.category.value = '';
            searchParams.features.onlinePayment.value = false;
            searchParams.features.quickDelivery.value = false;
            searchParams.features.openNow.value = false;
            searchParams.features.promoEnabled.value = false

            break;

          }
          default: {
            const keysArr = filter.split('.');
            keysArr.reduce((params, key) => {

              if (keysArr.indexOf(key) == keysArr.length - 1) (params[key].value = false);

              return params[key];

            }, searchParams)
            break;
          }
        }


        this.deliverySearch();
      },

      dineoutParamsHandler(keys, value) {
        let loadMore = false;
        if (typeof keys !== 'undefined' && typeof value !== 'undefined') {

          if (keys == 'page') {
            this.deliveryPage.loading = true;
            loadMore = true;
          } else {
            this.dineoutPage.searchParams.page.value = 1;
          }

          switch (keys) {
            case 'feature': {
              const valueIndex = this.dineoutPage.searchParams.features.feature.value.indexOf(value);
              valueIndex == -1 ? this.dineoutPage.searchParams.features.feature.value.push(value) : this.dineoutPage.searchParams.features.feature.value.splice(valueIndex, 1);
              break;
            }
            case 'general.mood': {
              this.dineoutPage.searchParams.general.mood.value = value
              this.dineoutPage.searchParams.general.mood.name = this.dineoutPage.flatMoods[value].name
              break;
            }
            case 'general.category': {
              this.dineoutPage.searchParams.general.category.value = value
              this.dineoutPage.searchParams.general.category.name = this.dineoutPage.flatCategories[value].name
              break;
            }
            default: {

              const keysArr = keys.split('.');
              keysArr.reduce((params, key) => {

                if (keysArr.indexOf(key) == keysArr.length - 1) (params[key].value = value);

                return params[key];

              }, this.dineoutPage.searchParams)

              break;
            }
          }

        }



        this.dineoutSearch(loadMore);
      },

      showTinder() {

        this.tinderDishes = true;
        $body.classList.add('modal-open');
        window['gtag']('event', 'Action: Start Dish Game');
        window.history.pushState(
          null,
          null,
          (`${window.location.pathname}${this.dishGameState}`)
        );

      },

      deliveryParamsHandler(keys, value) {
        let loadMore = false;
        if (typeof keys !== 'undefined') {

          if (keys == 'page') {
            let modalIdIndex = this.bindConditionalClasses.indexOf('load-more-loader');
            modalIdIndex != -1 && this.bindConditionalClasses.splice(modalIdIndex, 1);
            loadMore = true;
          }
          else if (keys == 'general.category') {
            this.deliveryPage.searchParams.general.category.name = value;
          }
          else {
            this.deliveryPage.searchParams.page.value = 1;
          }


          const keysArr = keys.split('.');
          keysArr.reduce((params, key) => {

            if (keysArr.indexOf(key) == keysArr.length - 1) (params[key].value = value);

            return params[key];

          }, this.deliveryPage.searchParams)

        } else {
          this.deliveryPage.searchParams.page.value = 1;
        }


        this.deliverySearch(loadMore);
      },

      // params: city, area, lat, lon, openNow, category, feature, compact, page, pageSize, sort, mood, allMoods, allCategories 
      dineoutSearch(loadMore: boolean = false) {
        const searchParams = this.dineoutPage.searchParams;





        document.getElementById('loader-here').classList.remove('hide')


        let params = `area=${this.deliveryStatus.areaUUID}${searchParams.general.category.value ? '&category=' + searchParams.general.category.value : '&allCategories=true'}${searchParams.general.mood.value ? '&mood=' + searchParams.general.mood.value : ''}${searchParams.general.compact.value ? '&compact=' + searchParams.general.compact.value : ''}${searchParams.general.sort.value ? '&sort=' + searchParams.general.sort.value + '&zone=' + this.user.zoneUUID : ''}${searchParams.features.openNow.value ? '&openNow=' + searchParams.features.openNow.value : ''}&page=${searchParams.page.value}&pageSize=${searchParams.pageSize.value}&`;

        params += this.dineoutPage.searchParams.features.feature.value.reduce((featuresParams, feature) => {
          featuresParams += `feature=${feature}&`;
          return featuresParams;
        }, '');

        axios({
          method: "GET",
          url: servicesURL.discovery.dineout[this.dineoutPage.currentPageMethod](params),
          headers
        })
          .then(res => {
            if (loadMore) {
              this.dineoutPage.restaurantsData = this.dineoutPage.restaurantsData.concat(res.data.data);
            } else {
              this.dineoutPage.restaurantsData = res.data.data;
            }
            this.dineoutPage.restaurants = res.data;
            let urlArr = window.location.href.split('/');
            let splicedArr = urlArr.splice(urlArr.indexOf('dineout') + 1);

            let dineoutPage: string = '';
            let isMoodPage: boolean = false;

            let mood_dish_filters_arr = [
              (searchParams.general.mood.value ? `/mood-${URLBuilder.dasher(searchParams.general.mood.name)}` : ''),
              (searchParams.general.category.value ? `/dish-${URLBuilder.dasher(searchParams.general.category.name)}` : '')
            ]
            if (splicedArr[1] && splicedArr[1].includes(websitePages.dineout.newRestaurants)) {
              dineoutPage = websitePages.dineout.newRestaurants
              if (splicedArr[2] && splicedArr[2].includes('mood-')) {
                isMoodPage = true;
              }
            } else if (splicedArr[1] && splicedArr[1].includes(websitePages.dineout.topRestaurants)) {
              dineoutPage = websitePages.dineout.topRestaurants
              if (splicedArr[2] && splicedArr[2].includes('mood-')) {
                isMoodPage = true;
              }
            } else if (splicedArr[1] && splicedArr[1].includes('mood-')) {
              isMoodPage = true;
            }
            let filtersURL =
              `${isMoodPage
                ? mood_dish_filters_arr[0] + mood_dish_filters_arr[1]
                : mood_dish_filters_arr[1] + mood_dish_filters_arr[0]
              }`
              + ``;
            // ${searchParams.general.compact.value ? '&compact='+ searchParams.general.compact.value : ''}
            // ${searchParams.general.sort.value ? '&sort='+ searchParams.general.sort.value : ''}
            // ${searchParams.features.openNow.value ? '&openNow='+ searchParams.features.openNow.value : ''}
            // &page=${searchParams.page.value}
            // &pageSize=${searchParams.pageSize.value}&
            // update url with tag uuid param
            window.history.pushState(
              null,
              null,
              (
                `${urlArr.join('/')}`
                + `/${URLBuilder.dasher(this.flatAreas[this.deliveryStatus.areaUUID].name)}`
                + (dineoutPage ? `/${dineoutPage}` : dineoutPage)
                + `${filtersURL}`

              )

            );

            //complete
            addClassToElements('loader', 'hide')
            this.$nextTick(() => {
              restaurantCardImagesSlider();
            })
          })
          .catch(error => console.log("error", error))
      },
      handleLoadMore(res, loadMore, searchParams) {
        if (loadMore) {
          this.deliveryPage.restaurantsData = this.deliveryPage.restaurantsData.concat(res.data.data);
          this.xTracking.page = this.xTracking.page ? this.xTracking.page.concat(res.request.getResponseHeader(cookies.xTracking)) : res.request.getResponseHeader(cookies.xTracking);

        } else {
          this.deliveryPage.restaurantsData = res.data.data;
          this.xTracking.page = [res.request.getResponseHeader(cookies.xTracking)];
        }
        this.deliveryPage.searchResponse = res.data;
        let filtersURL =
          (`${searchParams.general.category.value ? '/dish-' + URLBuilder.dasher(searchParams.general.category.value) : ''}`)
          + buildFiltersURL(
            `${searchParams.general.orderingEnabled.value ? filters.orderingEnabled : ''}`
          )
          + ``;

        // ${searchParams.general.category.value ? '&category='+ searchParams.general.category.value : ''}
        // ${searchParams.general.orderingEnabled.value ? '&orderingEnabled='+ searchParams.general.orderingEnabled.value : ''}
        // ${searchParams.general.compact.value ? '&compact='+ searchParams.general.compact.value : ''}
        // ${searchParams.general.sort.value ? '&sort='+ searchParams.general.sort.value : ''}
        // ${searchParams.features.onlinePayment.value ? '&onlinePayment='+ searchParams.features.onlinePayment.value : ''}
        // ${searchParams.features.quickDelivery.value ? '&quickDelivery='+ searchParams.features.quickDelivery.value : ''}
        // ${searchParams.features.promoEnabled.value ? '&promoEnabled='+ searchParams.features.promoEnabled.value : ''}
        // ${searchParams.features.openNow.value ? '&openNow='+ searchParams.features.openNow.value : ''}
        // &page=${searchParams.page.value}
        // &pageSize=${searchParams.pageSize.value}
        let url = window.location.href;
        url = url.substring(0, url.indexOf('delivery') + ('delivery').length);
        let urlArr = url.split('/');
        // update url with tag uuid param
        window.history.pushState(
          null,
          null,
          (
            `${urlArr.join('/')}`
            + `/${URLBuilder.dasher(this.flatAreas[this.deliveryStatus.areaUUID].name)}`
            + `${filtersURL}`
          )

        );

        //complete
        if (res.status == 200) {
          setTimeout(() =>
            this.$nextTick(() => {
              restaurantCardImagesSlider()
              tagsSlider()
            })
            , 0);
          this.deliveryPage.reloadingAll = false;
          this.deliveryPage.loading = false;
        }
      },
      // params: area, category, orderingEnabled, onlinePayment, quickDelivery, openNow, compact, sort, page, pageSize,
      deliverySearch(loadMore: boolean = false) {
        const handleLoadMore = this.handleLoadMore;
        const searchParams = this.deliveryPage.searchParams;
        const lat = getCookie("lat");
        const lon = getCookie("long");

        loadMore ? this.deliveryPage.loading = true : this.deliveryPage.reloadingAll = true;

        const params = `${searchParams.general.orderingEnabled.value ? 'zone=' + this.zoneSelected + '&' : ''}area=${this.deliveryStatus.areaUUID}${searchParams.general.category.value ? '&category=' + data.deliveryPage.flattenCategories[URLBuilder.dasher(searchParams.general.category.value)].uuid : ''}${this.user.company ? '&companyId=' + this.user.company.place_id : ''}${searchParams.general.orderingEnabled.value ? '&orderingEnabled=' + searchParams.general.orderingEnabled.value : ''}${searchParams.general.compact.value ? '&compact=' + searchParams.general.compact.value : ''}${searchParams.general.sort.value ? '&sort=' + searchParams.general.sort.value + '&zone=' + this.user.zoneUUID : ''}${searchParams.features.onlinePayment.value ? '&onlinePayment=' + searchParams.features.onlinePayment.value : ''}${searchParams.features.quickDelivery.value ? '&quickDelivery=' + searchParams.features.quickDelivery.value : ''}${searchParams.features.promoEnabled.value ? '&promoEnabled=' + searchParams.features.promoEnabled.value : ''}${searchParams.features.openNow.value ? '&openNow=' + searchParams.features.openNow.value : ''}${searchParams.features.hygieneCheck.value ? '&hygieneCheck=' + searchParams.features.hygieneCheck.value : ''}&page=${searchParams.page.value}&pageSize=${searchParams.pageSize.value}${lat && lon ? '&lat=' + lat + '&lon=' + lon : ''}`;

        /* if (filterAjaxCall && filterAjaxCall.readyState != 4) {
           filterAjaxCall.abort();
           restaurantCardImagesSlider();
         }*/

        axios.get(servicesURL.discovery.delivery.search(params), { headers })
          .then(res => {
            destroyRestaurantCardImagesSlider()
            handleLoadMore(res, loadMore, searchParams);
            if(!loadMore){
              this.isOnlineOrdering = this.deliveryPage.searchParams.general.orderingEnabled.value;
            }
          })
          .catch(error => {
            console.log("error", error)
          })
      },
    
    
      fbLogin(userData, fbStatusResponse) {
        axios({
          method: "POST",
          url: servicesURL.fb.login,
          data: JSON.stringify({
            name: userData.name,
            email: userData.email,
            birthdate: userData.birthday,
            socialId: userData.id,
            socialToken: fbStatusResponse.authResponse.accessToken
          }),
          headers
        })
          .then(res => {
            setCookie(cookies.auth, res.data.accessToken, '/');
            setCookie('webRefreshToken', res.data.refreshToken, '/');
            headers['Authorization'] = "Bearer " + res.data.accessToken
            pushAnalyticsEvent(
              analyticsEvents.loging.category,
              analyticsEvents.loging.events.facebook
            )
            window['gtag']('event', 'login', { method: 'Facebook' });
            let userCreatedDate = new Date(this.profile.data.createdAt);
            let currentDate = new Date();
            window['gtag']('set', 'user_properties', {
              Guest: 'No',
              User_Type: userCreatedDate.getFullYear() >= (currentDate.getFullYear()) && userCreatedDate.getMonth() >= (currentDate.getMonth()) ? "Newly Registered" : "Existing Registered"

            });
            let reorder = document.getElementById("re-order-modal") && document.getElementById("re-order-modal").classList.contains('show')
            this.$store.dispatch('getUserProfileData', [true, reorder]);
            serverData.restaurantHeader && this.$store.dispatch('GET_BASKET_STATE');
            this.getNotificationData();
          })
          .catch(error => {
            console.log("error", error)
          });
      },
      searchAutocomplete(params) {

        /* if (this.autocomplete.ajaxRequest && this.autocomplete.ajaxRequest.readyState != 4) {
           this.autocomplete.ajaxRequest.abort();
         }*/
        localStorage.setItem(LocalStorageKeys.Restaurant_Source_Screen, SourceScreens.SearchPage);
        this.$store.dispatch('requestAutocomplete', params);

      },

      searchInputKeyUpHandler(e) {

        clearTimeout(this.autocomplete.debounce);

        this.autocomplete.debounce = setTimeout(() => {

          const params = `query=${this.search.input}&cityUUID=${this.user.cityUUID}`;
          this.searchAutocomplete(params);

        }, 400);

      },
      toggleBasket() {
        if (this.basketisGroup) {
          this.changeGroupVisibility(!this.groupBasket.visible);
          this.pushViewBasketEvent(this.groupBasket);
        }
        else {
          this.changeBasketVisibility(!this.basket.visible);
          this.pushViewBasketEvent(this.basket);
        }
      },
      changeBasketVisibility(isVisible) {
        this.$store.commit('changeBasketVisibility', isVisible);
        if (this.$store.state.basket.visible && this.basketCompact.uuid) {
          this.$store.dispatch('GET_USER_BASKET_SUMMARY');
        }
      },
      changeGroupVisibility(isVisible) {
        this.$store.commit('changeGroupVisibility', isVisible);
        if (this.groupBasket.visible) {
          this.$store.commit("setBasketLoading", BasketLoadersEnum.getItems);
          this.$nextTick(function () {
            this.groupSummaryInterval =
              setInterval(function refreshGroupSummay() {
                if (!vue.showCheckoutModal) {
                  vue.isGroupOrderPage ?
                    vue.$store.dispatch('GET_GROUP_BASKET_SUMMARY', vue.groupPageGroupUUID) :
                    vue.$store.dispatch('GET_GROUP_BASKET_SUMMARY', vue.basketCompact.uuid)
                }
                return refreshGroupSummay;
              }(), this.refreshConfigurations.basketSummaryInterval * 1000)
          })
        }
        else {
          this.groupSummaryInterval && clearInterval(this.groupSummaryInterval);
        }
      },
      toggleNotifications() {

        this.notificationsComponent.show = !this.notificationsComponent.show;
        if (this.notificationsComponent.show) {
          $body.classList.add('no-scroll')
          document.documentElement.clientWidth <= 1024 && navBtnHandler();
        } else {
          $body.classList.remove('no-scroll')
        }

      },
      hideAutocomplete(e) {
        setTimeout(() => {
          this.$store.dispatch('hideAutocomplete')
        }, 200);
      },
      showAutocomplete() {
        this.$store.commit('showAutocomplete');
      },
      getNotificationData() {
        const notifyObj = this.notificationsComponent;
        this.notificationsComponent.loading = true;
        const params = `${notifyObj.lastUpdate ? 'before=' + (notifyObj.lastUpdate.replace(/\+/g, '%2B')) + '&' : ''}pageSize=${notifyObj.pageSize}`;

        axios({
          method: "GET",
          url: servicesURL.user.notifications(params),
          headers
        })
          .then(res => {
            if (res.data.count) {
              const isFirstTime = !notifyObj.notifications;
              this.notificationsComponent.notifications = res.data;

              isFirstTime && (
                this.notificationsComponent.newNotificationsData = res.data.notifications.reduce((newNotifications, item) => {
                  if (this.isFrom24Hours(item.updatedAt)) return newNotifications.concat(item);
                  return newNotifications;
                }, []),
                this.initNotificationScrollEvent()
              );

              this.notificationsComponent.notificationsData = isFirstTime
                ? res.data.notifications.slice(this.notificationsComponent.newNotificationsData.length)
                : this.notificationsComponent.notificationsData.concat(res.data.notifications);

              this.notificationsComponent.lastUpdate = res.data.notifications[res.data.notifications.length - 1].updatedAt;
              this.notificationsComponent.page++;
            } else {
              notifyObj.loadMore = false;
            }

            this.modalToggler('login-signup-modal', 'hide');

            //complete
            this.notificationsComponent.loading = false;
          })
          .catch(error => {
            console.log("error", error)
            this.modalToggler('login-signup-modal', 'hide');
          });

      },
      getGuestToken(reload) {
        return axios({
          method: "POST",
          url: servicesURL.guest.post,
          headers
        })
          .then(res => {
            setCookie(cookies.auth, res.data.accessToken, '/');
            setCookie(cookies.refreshToken, res.data.refreshToken, '/');
            headers['Authorization'] = "Bearer " + res.data.accessToken;
            reload && window.location.reload();
          })
          .catch(error => {
            console.log('error: ', error);
          });
      },
      logout() {
        let AuthResponse: facebook.AuthResponse = FB.getAuthResponse();
        //this.initGuestChat();
        // window['webengage'].user.logout();
        sessionStorage.setItem('showFreshChatIcon', 'false');
        this.$store.commit("setShowGiftForm", false);
        this.$store.commit('updateUserCreditCards', []);
        this.$store.commit('resetPromoForm');
        if (AuthResponse) { // undefined if not logged in user with facebook
          FB.logout(res => {
            setCookie(cookies.auth, "", "/", "");
            setCookie(cookies.tokenExpiry, "", "/", "");
            setCookie(cookies.refreshToken, "", "/", "");
            this.getGuestToken(false).then(() => {
              this.$store.dispatch('getUserProfileData', false);
              this.$store.commit('emptyBasket');
              this.$store.commit('emptyGroup');
              this.$store.commit('updateBasketState', { state: "NO_BASKET" });
              this.$store.commit("setBasketLoading", null);
              this.$store.dispatch('GET_USER_BASKET_COMPACT', false);
              this.$store.commit("updateLastOrder", {});
              this.removeCompanyCookie();
              window['gtag']('set', 'user_properties', {
                Guest: 'Yes',
                First_Order: 'Yes',
                User_Type: 'Guest'
              });
            })
          });
        } else {
          setCookie(cookies.auth, "", "/", "");
          setCookie(cookies.tokenExpiry, "", "/", "");
          setCookie(cookies.refreshToken, "", "/", "");
          this.getGuestToken(false).then(() => {
            this.$store.dispatch('getUserProfileData', false);
            this.$store.commit('emptyBasket');
            this.$store.commit('emptyGroup');
            this.$store.commit('updateBasketState', { state: "NO_BASKET" });
            this.$store.commit("setBasketLoading", null);
            this.$store.dispatch('GET_USER_BASKET_COMPACT', false);
            this.$store.commit("updateLastOrder", {});
            window['gtag']('set', 'user_properties', {
              Guest: 'Yes',
              First_Order: 'Yes',
              User_Type: 'Guest'
            });
            this.removeCompanyCookie();
          })
        }
        this.unRegisterMixpanelSegemntsProps();

        if (window.location.href.includes('settings') || window.location.href.includes('myorders')) {
          window.location.href = isRTL ? '/ar' : '/';
        }
      },
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth;
      },
      
      itemSizeChangeHandler() {
        this.calcItemSubTotal();
        for (let exCatUUID in this.itemModal.flatExtraCategories) {
          this.itemModal.flatExtraCategories[exCatUUID].selectedItems = [];
        }
        this.$nextTick(() => {
          removeClassFromSelector('#item-view-modal .item-extras', 'hide')

          Array.from(document.getElementById('item-view-modal').querySelectorAll('.extras-list.size-restricted-list')).forEach(el => {
            let parent = closestByClass(el, 'item-extras')[0]
            el.children.length == 0 ? parent.classList.add('hide') : parent.classList.remove('hide');
          })

        });
      },
      itemModalClick(catUUID, uuid, menuAvailableOnTime = true, availableOnTime = true, menuFromTime = '', menuToTime = '', fromTime = '', toTime = '', menuAvailableForOnlineOrering = true) {
        this.$store.state.startGroup = false
        this.pushMixpanelEvent(
          this.mixpanelEvents.openItemDetails.event,
          this.mixpanelEvents.openItemDetails.properties(
            this.restaurantPage.restHeaderObj.name ? this.restaurantPage.restHeaderObj.name : "N/A",
            this.flatAreas[this.deliveryStatus.areaUUID] ? this.flatAreas[this.deliveryStatus.areaUUID].name : "N/A",
            this.orderingEnabled ? 'Yes' : "No"
          )
        );
        window['gtag']('event', 'view_item');
        pushAnalyticsEvent(
          analyticsEvents.restaurant.category,
          analyticsEvents.restaurant.events.open_item_details,
          analyticsEvents.restaurant.labels.enabledState(this.restaurantPage.restHeaderObj.onlineOrdering && this.restaurantPage.restHeaderObj.branchOrderingEnabled)
        );
        this.itemModal.itemData = Object.assign({
          quantity: 1,
          selectedSizeUUID: this.items[uuid].sizes[0].itemSizeUUID,
          comment: '',
          menuAvailableOnTime,
          availableOnTime,
          menuFromTime,
          menuToTime,
          fromTime,
          toTime,
          catUuid: catUUID,
          menuAvailableForOnlineOrering: menuAvailableForOnlineOrering
        }, this.items[uuid]);
        this.itemModal.itemSubTotal = this.getSizePrice(this.itemModal.itemData.selectedSizeUUID) * this.itemModal.itemData.quantity;

        !this.items[uuid].extraCategories.length && (this.itemModal.isExCatsValid = true)
        this.itemModal.flatExtraCategories = this.items[uuid].extraCategories.reduce((exCatsObj, exCat) => {
          exCat.minimumAllowedExtra && (this.itemModal.isExCatsValid = false);
          exCatsObj[exCat.uuid] = {
            sizeRestricted: exCat.sizeRestricted,
            isValid: exCat.minimumAllowedExtra ? false : true,
            minimumAllowedExtra: exCat.minimumAllowedExtra,
            maximumAllowedExtra: exCat.maximumAllowedExtra,
            flatSizes: exCat.items.reduce((itemsObj, item) => {
              itemsObj = Object.assign({}, itemsObj, item.sizes.reduce((sizeObj, size) => {
                sizeObj[size.itemSizeUUID] = Object.assign({}, size, {
                  itemUUID: item.uuid,
                  itemName: item.name,
                  uuid: size.itemSizeUUID,
                  sizeUUID: size.sizeUUID
                });
                return sizeObj;
              }, {}));
              return itemsObj;
            }, {}),
            selectedItems: []
          };
          return exCatsObj;
        }, {});
        this.$nextTick(() => {
          this.itemSizeChangeHandler();
        });
      },
      counter(method, num) {
        return counter(method, num)
      },
      quantityCounter(method) {
        this.itemModal.itemData.quantity = this.counter(method, this.itemModal.itemData.quantity);
      },

      getOrderItemRequest: (payload) => {
        const exCats = payload.itemModal.flatExtraCategories;
        const selectedExCats = [];
        let loopIndex = 0;

        // handling extra categories
        for (const catUUID in payload.itemModal.flatExtraCategories) {
          if (exCats[catUUID].selectedItems && exCats[catUUID].selectedItems.length) {

            selectedExCats.push({
              extraCategoryUUID: catUUID,
              extraItemSizesUUIDs: []
            });
            exCats[catUUID].selectedItems.map(sizeUUID => {

              selectedExCats[loopIndex].extraItemSizesUUIDs.push(sizeUUID);

            });

            loopIndex++;
          }
        }

        return {
          quantity: payload.itemModal.itemData.quantity,
          itemSizeUUID: payload.itemModal.itemData.selectedSizeUUID,
          comment: payload.itemModal.itemData.comment,
          extras: selectedExCats
        };
      },
      genericRetry(error) {
        switch (error.method) {
          case 'add':
            let addActionName = this.basketisGroup ? 'ADD_ITEM_TO_GROUP_BASKET' : 'ADD_ITEM_TO_BASKET';
            let addItemRequest = this.basketisGroup ?
              { OrderItemRequest: this.getOrderItemRequest(error.payload), basketUUID: error.payload.basketUUID }
              : this.getOrderItemRequest(error.payload)
            this.$store.dispatch(addActionName, addItemRequest).then(() => {
              error.state = 'success';
              if (!data.itemsErrors.filter(error => error.state == 'fail').length) {
                this.modalToggler("retry-basket-modal", "hide");
              }
            })

            break;
          case 'edit':
            let editActionName = this.basketisGroup ? 'EDIT_GROUP_BASKET_ITEM' : 'EDIT_BASKET_ITEM';
            this.$store.dispatch(editActionName, error.payload.itemModal.itemData.basketItemUUID).then(() => {
              error.state = 'success';
              if (!data.itemsErrors.filter(error => error.state == 'fail').length) {
                this.modalToggler("retry-basket-modal", "hide");
              }
            });
            break;
          case 'remove':
            let removeActionName = this.basketisGroup ? 'REMOVE_ITEM_FROM_GROUP_BASKET' : 'REMOVE_ITEM_FROM_BASKET';
            this.$store.dispatch(removeActionName, error.payload.basketItemUUID).then(() => {
              error.state = 'success';
              if (!data.itemsErrors.filter(error => error.state == 'fail').length) {
                this.modalToggler("retry-basket-modal", "hide");
              }
            })
            break;
        }
      },
      addItemSuccess(zonePrompt) {
        this.pushMixpanelEvent(
          this.mixpanelEvents.addItemToBasketSuccess.event,
          this.mixpanelEvents.addItemToBasketSuccess.properties(
            this.basket.ref.restaurant.name ? this.basket.ref.restaurant.name : "N/A",
            this.basket.ref.areaUUID ? this.flatAreas[this.basket.ref.areaUUID].name : 'N/A',
            this.basketItemsCount,
            zonePrompt,
            this.basketCompact.data.isGroup ? "Group" : "Individual",
            this.basketCompact.data.isGroup ? (this.isGroupAdmin ? "Admin" : "Member") : "Individual"
          )
        );

      },
      placeOrderSuccess() {
        clearInterval(this.groupSummaryInterval);
        clearInterval(this.compactBasketInterval);

        this.pushMixpanelEvent(
          this.mixpanelEvents.placeOrder.event,
          this.mixpanelEvents.placeOrder.properties(
            this.basket.ref.restaurant.name ? this.basket.ref.restaurant.name : "N/A",
            this.basket.payment.method == this.basket.payment.paymentTypeEnum.CASH_ON_DELIVERY ? "Cash" : "Credit Card",
            this.basket.ref.promo ? this.basket.ref.promo.code : "N/A",
            this.signupForm.newUser ? 'New User' : 'Returning User',
            this.basket.data.receipt.total,
            this.flatAreas[this.basket.ref.address.ref.areaUUID].name ? this.flatAreas[this.basket.ref.address.ref.areaUUID].name : "N/A",
            this.basket.data.receipt.totalBeforeDiscount ? this.basket.data.receipt.totalBeforeDiscount  - this.basket.data.receipt.total  : null,
            this.basket.ref.promo ? this.basket.ref.promo.discount : null,
            this.profile.data.totalOrderCount > 0 ? 'No' : 'Yes',
            this.basketisGroup ? "Group" : "Individual",
            this.$store.state.selectedOrder.data && this.$store.state.selectedOrder.data.fleet,
            this.basket.data.receipt.deliveryFee,
            this.basket.data.deliveryDuration,
            this.basket.data.receipt.deliveryCharges.serviceFees !==0,
            this.basket.data.receipt.deliveryCharges.serviceFees,

          )
        );

      },
      discardItem(error) {
        data.itemsErrors[error.addItemIndex - 1].state = 'discard';
        if (!data.itemsErrors.filter(error => error.state == 'fail').length) {
          this.modalToggler("generic-errors-modal", "hide");
        }
      },
      updateAreaZoneVisibility(visible) {
        this.$store.commit('updateAreaZoneVisibility', visible);
        if (visible) {
          this.pushMixpanelEvent(
            this.mixpanelEvents.firstItemPrompt.event,
            this.mixpanelEvents.firstItemPrompt.properties(
              data.restaurantPage.restHeaderObj.name ? data.restaurantPage.restHeaderObj.name : "N/A"
            )
          );

        }



      },
      showCreateBasketModal() {
        if (!this.basketCompact.uuid && !this.basketisGroup) {
          if (this.profile && this.profile.data.profile) {
            console.log('user zone', serverData.restaurantHeader.branchDeliversToLocation, this.user);
            if (this.user.zoneUUID && serverData.restaurantHeader.branchDeliversToLocation) {
              this.addAreaZone(this.user.areaUUID, this.user.zoneUUID)
            }
            else {
              this.createBasketOpen = true;
              this.modalToggler('create-basket-modal', 'show');
              this.updateAreaZoneVisibility(true);
            }
          }
          else {
            this.createBasketOpen = true;
            this.modalToggler('create-basket-modal', 'show');
          }
        }

        else {

          if (serverData.restaurantUUID == this.basketCompact.ref.restaurantUUID) {
            this.showAreaZoneModal();
          }
          else
            this.basketisGroup ? this.modalToggler("leave-another-group-modal", "show") :
              this.modalToggler("discard-basket-modal", "show");
        }

      },
      showCreateGifting(formName) {
        this.$store.commit('setPromoOpenedForm', formName);
        formName && window.history.pushState(
          null,
          null,
          (
            `${window.location.origin + '/giftmeals/' + formName}`
          )

        );
        document.title = staticContent.gifting.formPageTitle[formName];
        document.querySelector('meta[name="description"]').setAttribute("content", staticContent.gifting.formPageDescription[formName]);
        this.$store.commit('setShowGiftForm', true);


      },

      showAreaZoneModal() {
        if (!this.basketCompact.uuid && !this.basketisGroup) {

          if (this.user.zoneUUID && serverData.restaurantHeader.branchDeliversToLocation) {

            this.addAreaZone(this.user.areaUUID, this.user.zoneUUID)
          }
          else {
            this.$nextTick(() => {
              this.updateAreaZoneVisibility(true);
            });
          }

        }
        else {
          if (serverData.restaurantUUID == this.basketCompact.ref.restaurantUUID) {
            this.modalToggler("create-basket-modal", "hide");
            this.createBasketOpen = false;
            const payload = {
              itemModal: this.itemModal,
            };

            var itemModalData = {};
            itemModalData = Object.assign(itemModalData, this.itemModal);

            if (this.basketisGroup) {
              this.addItemToGroup(payload)
            }
            else {
              if (navigator.onLine) {
                this.$store.commit('addToBasket', payload);
                this.$store.dispatch('ADD_ITEM_TO_BASKET', this.getOrderItemRequest(payload)).then(() => {


                }).catch((err) => {
                  this.handleGenericErrors(genericErrorsEnum.item, 'add', itemModalData);
                })
              }
              else {
                this.handleGenericErrors(genericErrorsEnum.internet, 'add', itemModalData);
              }
            }
          }
          else {
            this.modalToggler("create-basket-modal", "hide");
            this.createBasketOpen = false;
            this.basketisGroup ? this.modalToggler("leave-another-group-modal", "show") :
              this.modalToggler("discard-basket-modal", "show");
          }
        }
      },
      handleReorderFromShare() {
        this.modalToggler('re-order-modal', 'hide')
        this.handleReOrder(this.$store.state.selectedOrder.orderUUID)
      },

      discardBasket() {

        this.modalToggler("discard-basket-modal", "hide");
        if (this.$store.state.reOrderFromMyOrderPage) {
          this.$store.dispatch('REMOVE_ALL_ITEMS_FROM_BASKET').then(e => {
            this.$store.dispatch("RE_ORDER", this.$store.state.selectedOrder.orderUUID).then(e => {
              this.redirectToRestaurant();
            });
            this.$store.commit('updateReOrderFromMyOrderPage', false)
          }).catch((err) => {
            this.handleGenericErrors(
              genericErrorsEnum.generic,
              "remove-all"
            );
          })
        }
        else {
          if (navigator.onLine) {
            this.$store.dispatch('REMOVE_ALL_ITEMS_FROM_BASKET')
              .then(response => {
                if (!this.isGroupOrderPage) {
                  if (this.$store.state.startGroup) {
                    this.startGroupOrdering();
                  }
                  else {
                    this.showCreateBasketModal()
                  }
                }
                else {
                  this.addItemToGroup({ itemModal: this.itemModal })
                }

              })
              .catch((err) => {
                this.handleGenericErrors(
                  genericErrorsEnum.generic,
                  "remove-all"
                );
              })
          }
          else {
            this.handleGenericErrors(
              genericErrorsEnum.internet,
              "remove-all"
            );
          }
        }
      },
      discardGroup() {
        if (this.$store.state.reOrderFromMyOrderPage) {
          this.$store.dispatch('REMOVE_ALL_ITEMS_FROM_BASKET').then(response => {
            this.modalToggler("leave-another-group-modal", "hide");
            clearInterval(this.groupSummaryInterval);
            clearInterval(this.compactBasketInterval);
            this.$store.dispatch("RE_ORDER", this.$store.state.selectedOrder.orderUUID).then(e => {
              this.redirectToRestaurant();

            });
            this.$store.commit('updateReOrderFromMyOrderPage', false)


          }).catch((err) => {
            this.handleGenericErrors(
              genericErrorsEnum.generic,
              "remove-all"
            );
          })
        }
        else {
          if (navigator.onLine) {
            this.pushMixpanelEvent(
              this.mixpanelEvents.cancelGroup.event,
              this.mixpanelEvents.cancelGroup.properties(
                this.groupBasket.ref.restaurant.name ? this.groupBasket.ref.restaurant.name : "N/A",
              ));

            this.$store.dispatch('REMOVE_ALL_ITEMS_FROM_BASKET').then(response => {
              this.modalToggler("leave-another-group-modal", "hide");
              clearInterval(this.groupSummaryInterval);
              clearInterval(this.compactBasketInterval);
              if (!this.isGroupOrderPage) {
                if (this.$store.state.startGroup) {
                  this.startGroupOrdering();
                }
                else {
                  this.showCreateBasketModal()
                }
              }
              else {
                this.addItemToGroup({ itemModal: this.itemModal })
              }


            })
              .catch((err) => {
                this.handleGenericErrors(
                  genericErrorsEnum.generic,
                  "remove-all"
                );
              })
          }
          else {
            this.handleGenericErrors(
              genericErrorsEnum.internet,
              "remove-all"
            );
          }
        }


      },
      leaveGroupBasket() {
        if (this.$store.state.reOrderFromMyOrderPage) {
          console.log('leaveGroupBasket', this.basketCompact.uuid)
          this.$store.dispatch("LEAVE_BASKET", this.basketCompact.uuid).then(() => {
            this.modalToggler("leave-another-group-modal", "hide");
            this.modalToggler("leave-group-modal", "hide");
            clearInterval(this.groupSummaryInterval);
            clearInterval(this.compactBasketInterval);
            this.$store.dispatch("RE_ORDER", this.$store.state.selectedOrder.orderUUID).then(e => {
              this.redirectToRestaurant();

            });
            this.$store.commit('updateReOrderFromMyOrderPage', false)

          }).catch((err) => {

            this.handleGenericErrors(
              genericErrorsEnum.generic,
              "leave",
              {},
              null,
              this.groupBasket.uuid
            );
          })

        }
        else {
          if (navigator.onLine) {
            this.pushMixpanelEvent(
              this.mixpanelEvents.leaveGroup.event,
              this.mixpanelEvents.leaveGroup.properties(
                this.groupBasket.ref.restaurant.name ? this.groupBasket.ref.restaurant.name : "N/A",
              ));

              console.log('navigator.onLine', this.basketCompact.uuid)
            this.$store.dispatch("LEAVE_BASKET", this.basketCompact.uuid).then(() => {
              this.modalToggler("leave-another-group-modal", "hide");
              this.modalToggler("leave-group-modal", "hide");
              clearInterval(this.groupSummaryInterval);
              clearInterval(this.compactBasketInterval);
              // !this.isGroupOrderPage ? this.startGroupOrdering() : this.addItemToGroup({itemModal: this.itemModal});
              if (!this.isGroupOrderPage) {
                if (this.$store.state.startGroup) {
                  this.startGroupOrdering();
                }
                else {
                  this.showCreateBasketModal()
                }
              }
              else {
                this.addItemToGroup({ itemModal: this.itemModal })
              }
            })
              .catch((err) => {

                this.handleGenericErrors(
                  genericErrorsEnum.generic,
                  "leave",
                  {},
                  null,
                  this.groupBasket.uuid
                );
              })
          }
          else {
            this.handleGenericErrors(
              genericErrorsEnum.internet,
              "leave",
              {},
              null,
              this.groupBasket.uuid
            );
          }
        }


      },

     
      getCreateBasketRequest(payload) {

        const exCats = payload.itemModal.flatExtraCategories;
        const selectedExCats = [];
        let createBasketRequest = {};
        let loopIndex = 0;
        // handling extra categories
        for (const catUUID in payload.itemModal.flatExtraCategories) {
          if (exCats[catUUID].selectedItems && exCats[catUUID].selectedItems.length) {

            selectedExCats.push({
              extraCategoryUUID: catUUID,
              extraItemSizesUUIDs: []
            });
            exCats[catUUID].selectedItems.map(sizeUUID => {

              selectedExCats[loopIndex].extraItemSizesUUIDs.push(sizeUUID);
            });

            loopIndex++;
          }
        }

        return {
          branchUUID: serverData.restaurantHeader.branchUUID,
          zoneUUID: payload.zoneUUID,
          restaurantUUID: serverData.restaurantUUID,
          firstItem: {
            quantity: payload.itemModal.itemData.quantity,
            itemSizeUUID: payload.itemModal.itemData.selectedSizeUUID,
            comment: payload.itemModal.itemData.comment,
            extras: selectedExCats
          }

        }
      },
      retryConnection(modalName) {
        this.showRetryLoading = true;
        const error = data.itemsErrors[data.addItemIndex - 1];
        switch (error.method) {
          case 'create':
            this.$store.dispatch('CREATE_BASKET', this.getCreateBasketRequest(error.payload)).then(() => {
              this.pushMixpanelEvent(
                this.mixpanelEvents.createBasket.event,
                this.mixpanelEvents.createBasket.properties(
                  this.basket.ref.restaurant.name ? this.basket.ref.restaurant.name : "N/A",
                )
              );

              error.state = 'success';
              this.showRetryLoading = false;
              this.modalToggler(modalName, "hide");
            }).catch(() => {
              this.showRetryLoading = false;
            })
            break;
          case 'create-group':
            this.$store.dispatch('CREATE_GROUP_BASKET', {
              restaurantUUID: serverData.restaurantUUID,
              branchUUID: serverData.restaurantHeader.branchUUID,
              zoneUUID: error.payload.zoneUUID
            }).then(() => {

              error.state = 'success';
              this.showRetryLoading = false;
              this.modalToggler(modalName, "hide");
            }).catch(() => {
              this.showRetryLoading = false;
            })
            break;
          case 'convert':
            this.pushMixpanelEvent(
              this.mixpanelEvents.convertToGroup.event,
              this.mixpanelEvents.convertToGroup.properties(
                this.basket.ref.restaurant.name ? this.basket.ref.restaurant.name : "N/A",
              ));

            this.$store.dispatch("CONVERT_USER_BASKET_TO_GROUP").then(() => {
              error.state = 'success';
              this.showRetryLoading = false;
              this.modalToggler(modalName, "hide");
              this.groupURL = window.location.origin + (this.$store.state.groupBasket && this.$store.state.groupBasket.data.link);
              this.modalToggler('start-grouping-modal', 'show');
            }).catch(() => {
              this.showRetryLoading = false;
            })
            break;
          case 'add':
            let addActionName = this.basketisGroup ? 'ADD_ITEM_TO_GROUP_BASKET' : 'ADD_ITEM_TO_BASKET';
            let addItemRequest = this.basketisGroup ?
              { OrderItemRequest: this.getOrderItemRequest(error.payload), basketUUID: error.payload.basketUUID }
              : this.getOrderItemRequest(error.payload)
            this.$store.dispatch(addActionName, addItemRequest).then(() => {
              error.state = 'success';
              this.showRetryLoading = false;
              this.modalToggler(modalName, "hide");

            }).catch(() => {
              this.showRetryLoading = false;
            })
            break;
          case 'edit':
            let editActionName = this.basketisGroup ? 'EDIT_GROUP_BASKET_ITEM' : 'EDIT_BASKET_ITEM';
            this.$store.dispatch(editActionName, error.payload.itemModal.itemData.basketItemUUID).then(() => {
              error.state = 'success';
              this.showRetryLoading = false;
              this.modalToggler(modalName, "hide");
            }).catch(() => {
              this.showRetryLoading = false;
            })
            break;
          case 'remove':
            let removeActionName = this.basketisGroup ? 'REMOVE_ITEM_FROM_GROUP_BASKET' : 'REMOVE_ITEM_FROM_BASKET';
            this.$store.dispatch(removeActionName, error.payload.basketItemUUID).then(() => {
              error.state = 'success';
              this.showRetryLoading = false;
              this.modalToggler(modalName, "hide");
            })
            break;
          case 'remove-all':
            this.basketisGroup &&
              this.pushMixpanelEvent(
                this.mixpanelEvents.cancelGroup.event,
                this.mixpanelEvents.cancelGroup.properties(
                  this.groupBasket.ref.restaurant.name ? this.groupBasket.ref.restaurant.name : "N/A",
                ));

            this.$store.dispatch("REMOVE_ALL_ITEMS_FROM_BASKET").then(() => {
              clearInterval(this.groupSummaryInterval);
              clearInterval(this.compactBasketInterval);
              error.state = 'success';
              this.showRetryLoading = false;
              this.$store.commit("updateBasketIsGroup", false);
              this.modalToggler(modalName, "hide");
              this.groupURL = '';
            }).catch(() => {
              this.showRetryLoading = false;
            })
            break;
          case 'leave':
            this.pushMixpanelEvent(
              this.mixpanelEvents.leaveGroup.event,
              this.mixpanelEvents.leaveGroup.properties(
                this.groupBasket.ref.restaurant.name ? this.groupBasket.ref.restaurant.name : "N/A",
              ));

  console.log('case leave', error.payload.basketUUID)
            this.$store.dispatch("LEAVE_BASKET", error.payload.basketUUID).then(() => {
              clearInterval(this.groupSummaryInterval);
              clearInterval(this.compactBasketInterval);
              error.state = 'success';
              this.showRetryLoading = false;
              this.$store.commit("updateBasketIsGroup", false);
              this.modalToggler(modalName, "hide");
              this.groupURL = '';
            }).catch(() => {
              this.showRetryLoading = false;
            })
            break;
        }
      },
      hideCityAreaModal() {
        this.detectLocationPermissionError = false;
        this.locationDetailsFoundError = false;
        this.clearSearch();
        this.modalToggler('add-city-area-modal', 'hide');
      },
      hideCompanyModal() {
        this.placeAutocomplete = ''
        this.modalToggler('company-modal', 'hide');
        this.companyErrorMsg = false;
      },
      hideCreateBasketModal() {
        this.createBasketOpen = false;
        this.modalToggler('create-basket-modal', 'hide');
      },
      hideAreaZoneModal() {

        this.modalToggler('add-area-zone-modal', 'hide');

      },
      setUserCityCookie(cityUUID) {
        if (cityUUID !== getCookie(cookies.userCity)) {
          setCookie(cookies.userCity, cityUUID, '/');
          this.user.cityUUID = cityUUID;
          this.setUserAreaCookie('')
        }
      },
      setUserAreaCookie(areaUUID, companyRemove = true) {
        areaUUID && setCookie(cookies.userCity, this.flatAreas[areaUUID].cityUUID, '/')
        setCookie(cookies.userArea, areaUUID, '/')
        this.user.areaUUID = areaUUID;
        this.deliveryStatus.areaUUID = areaUUID;
        this.areaZonesSelected = areaUUID
        this.setUserZoneCookie('', companyRemove);
      },
      setUserZoneCookie(zoneUUID, companyRemove = true) {
        setCookie(cookies.userZone, zoneUUID, '/');
        this.user.zoneUUID = zoneUUID;
        this.zoneSelected = zoneUUID;
        if (companyRemove) {
          this.removeCompanyCookie();
        }
        this.companyModalInitiated = false;
      },
      removeCompanyCookie() {
        if (getCookie('Company')) {
          setCookie('recentCompany', getCookie('Company'), '/');
          setCookie('Company', '', '/')
          this.user.company = null
          if (window.location.href.indexOf('/delivery') > 0) {
            this.deliverySearch();
            this.$store.dispatch('GET_TASTY_OFFERS', { zone: this.user.zoneUUID, area: this.user.areaUUID, companyId: null }).then(() => {

              if (this.tastyOffers.data.length > 0) {
                this.$nextTick(offersSlider)
                pushAnalyticsEvent(
                  analyticsEvents.discovery.categories.delivery,
                  analyticsEvents.discovery.events.tastyOffers,
                  analyticsEvents.discovery.labels.companyOffers(0),
                  this.tastyOffers.data.length
                )
              }
            })

          }
        }

      },
    
      handleFooterAreaClick(cityUUID, areaUUID, zoneUUID){
        zoneUUID=(zoneUUID==getCookie(cookies.userZone))?zoneUUID:null
        if(areaUUID!=getCookie(cookies.userArea)){
          this.setUserLocationCookies(cityUUID,areaUUID, zoneUUID )
        }

      },
      setUserLocationCookies(cityUUID, areaUUID, zoneUUID) {
        setCookie(cookies.userCity, cityUUID, '/');
        this.user.cityUUID = cityUUID;
        setCookie(cookies.userArea, areaUUID, '/');
        this.user.areaUUID = areaUUID;
        this.deliveryStatus.areaUUID = areaUUID;
        this.areaZonesSelected = areaUUID;

        this.user.zoneUUID = zoneUUID;
        setCookie(cookies.userZone, zoneUUID, '/');
        this.removeCompanyCookie();
        this.companyModalInitiated = false;
      },

      setUserLatCookie(lat) {
        setCookie(cookies.lat, lat, '/');
        this.user.location.lat = lat;
      },
      setUserLongCookie(long) {
        setCookie(cookies.long, long, '/');
        this.user.location.long = long;
      },
      addAreaZone(areaUUID, zoneUUID) {
        let removeCompany = true
        this.user.zoneUUID == zoneUUID ? removeCompany = false : removeCompany = true;
        const isFirstItem = !this.basketCompact.uuid;
        const needReload = this.areaZonesSelected && (serverData.restaurantHeader.area.uuid !== this.areaZonesSelected);
        this.hideCreateBasketModal();
        this.$store.commit("setBasketLoading", BasketLoadersEnum.getItems);
        this.$store.commit('changeBasketVisibility', true);
        this.user.cityUUID = this.flatAreas[areaUUID].cityUUID;
        this.basket.ref.areaUUID = this.user.areaUUID = areaUUID;
        this.basket.ref.zoneUUID = this.user.zoneUUID = zoneUUID;
        this.setUserAreaCookie(areaUUID, removeCompany);
        this.setUserZoneCookie(zoneUUID, removeCompany);
        needReload && window.history.pushState(
          null,
          null,
          (
            `${window.location.origin + window.location.pathname}?area=${areaUUID}`
          )

        );
        if (this.isGroupBasket) {
          const payload = {
            zoneUUID: zoneUUID
          };

          if (navigator.onLine) {
            this.groupLoading = true;
            this.modalToggler('start-grouping-modal', 'show');
            this.$store.commit('createGroupBasket', payload);
            this.$store.dispatch('CREATE_GROUP_BASKET')
              .then(() => {

                this.groupURL = window.location.origin + (this.$store.state.groupBasket && this.$store.state.groupBasket.data.link);
                this.groupLoading = false;
                this.modalToggler('start-grouping-modal', 'show');

              })
              .catch((err) => {
                this.handleGenericErrors(genericErrorsEnum.generic, 'create-group', {}, zoneUUID);

              });

          }
          else {
            this.handleGenericErrors(genericErrorsEnum.internet, 'create-group', {}, zoneUUID);
          }
        }
        else {
          if (isFirstItem) {
            const payload = {
              zoneUUID: zoneUUID,
              itemModal: this.itemModal,
            };

            if (this.isGroupOrderPage) {
              this.$store.dispatch("GET_GROUP_BASKET_SUMMARY", this.groupPageGroupUUID).then(() => {
                const addItemRequest = {
                  userName: '',
                  basketUUID: this.groupBasket.uuid,
                  OrderItemRequest: this.getOrderItemRequest(payload)
                }

                addItemRequest.userName = this.profile.data.profile.name;

                this.$store.dispatch('JOIN_TO_GROUP_BASKET', addItemRequest).then(() => {
                  this.pushMixpanelEvent(
                    this.mixpanelEvents.joinGroup.event,
                    this.mixpanelEvents.joinGroup.properties(
                      "Already Logged in"
                    )
                  );
                  this.changeGroupVisibility(true);
                }).catch((err) => {
                  this.handleGroupError(err.response.data.error, function () {
                    this.handleGenericErrors(genericErrorsEnum.generic, 'join-group', this.joinGuestPayload);
                  })

                })


              });
              this.setUserAreaCookie(this.groupPageAreaUUID);
              if (this.windowWidth > 1024) {
                this.$store.commit('changeGroupVisibility', true);
              }
            }
            else {
              if (navigator.onLine) {

                this.$store.commit('createBasket', payload);

                this.$store.dispatch('CREATE_BASKET').then(() => {
                  this.pushMixpanelEvent(
                    this.mixpanelEvents.createBasket.event,
                    this.mixpanelEvents.createBasket.properties(
                      this.basket.ref.restaurant.name ? this.basket.ref.restaurant.name : "N/A"
                    )
                  );


                });
              }
              else {
                var itemModalData = {};
                itemModalData = Object.assign(itemModalData, this.itemModal);

                this.handleGenericErrors('create', itemModalData, zoneUUID);

              }

              pushGoogleAnalyticsEvent(
                this.googleAnalyticsEvents.restaurant.events.add_zone.event,
                this.googleAnalyticsEvents.restaurant.events.add_zone.label,
                this.googleAnalyticsEvents.restaurant.category
              );
            }

          }
          else {
            this.$store.commit("setBasketLoading", null);

          }
        }

        this.isGroupBasket = false;
        needReload && window.location.reload();
      },
    
    
      goToLogin() {
        this.isGuest = false;
      },
      joinGuest(userName) {
        const addItemRequest = {
          userName: userName,
          basketUUID: this.groupBasket.uuid,
          OrderItemRequest: this.getOrderItemRequest(this.joinGuestPayload)
        }
        this.modalToggler('create-basket-modal', 'hide');

        this.$store.dispatch('JOIN_TO_GROUP_BASKET', addItemRequest).then(() => {
          this.pushMixpanelEvent(
            this.mixpanelEvents.joinGroup.event,
            this.mixpanelEvents.joinGroup.properties(
              "Guest"
            )
          );
          this.changeGroupVisibility(true);
        }).catch((err) => {
          this.handleGroupError(err.response.data.error, function () {
            this.handleGenericErrors(genericErrorsEnum.generic, 'join-group', this.joinGuestPayload);
          })

        })
      },
      startGroupOrdering() {
        serverData.restaurantHeader && this.$store.dispatch('GET_BASKET_STATE').then(() => {
          this.$store.state.startGroup = true;
          GrouopBasketAnno && GrouopBasketAnno.hide();

          switch (this.$store.state.basketState) {
            case "NO_BASKET":
              this.isGroupBasket = true;
              this.showCreateBasketModal();
              break;
            case "HAS_BASKET_IN_THIS_RESTAURANT":
              if (navigator.onLine) {
                this.pushMixpanelEvent(
                  this.mixpanelEvents.convertToGroup.event,
                  this.mixpanelEvents.convertToGroup.properties(
                    this.basket.ref.restaurant.name ? this.basket.ref.restaurant.name : "N/A",
                  ));

                this.$store.dispatch("CONVERT_USER_BASKET_TO_GROUP").then(() => {
                  this.groupURL = window.location.origin + (this.$store.state.groupBasket && this.$store.state.groupBasket.data.link);
                  this.modalToggler('start-grouping-modal', 'show');
                }).catch((err) => {
                  this.handleGenericErrors(genericErrorsEnum.generic, 'convert');
                });
              }
              else {
                this.handleGenericErrors(genericErrorsEnum.internet, 'convert');
              }
              break;
            case "HAS_BASKET_IN_ANOTHER_RESTAURANT":
              this.isGroupBasket = true;
              this.modalToggler("discard-basket-modal", "show");
              break;
            case "MEMBER_IN_ANOTHER_GROUP":
              this.modalToggler('leave-another-group-modal', 'show');
              break;
            case "MEMBER_IN_THIS_GROUP":
              this.modalToggler('start-grouping-modal', 'show');
              break;
          }
        })
      },
      shareGroupLink() {
        this.pushMixpanelEvent(
          this.mixpanelEvents.shareGroup.event,
          this.mixpanelEvents.shareGroup.properties(
            this.groupBasket.ref.restaurant.name ? this.groupBasket.ref.restaurant.name : "N/A",
            this.isGroupAdmin ? "Admin" : "Member"
          ));
        this.groupLoading = true;
        this.modalToggler('start-grouping-modal', 'show');
        this.$store.dispatch("GET_GROUP_LINK", this.basketCompact.uuid).then(() => {
          this.groupURL = window.location.origin + this.$store.state.groupLink;
          this.groupLoading = false;
        });

      },
      addItemToGroup(payload) {

        const addItemRequest = {
          userName: '',
          basketUUID: this.basketCompact.uuid,
          OrderItemRequest: this.getOrderItemRequest(payload)
        }

        switch (this.$store.state.basketState) {
          case "NO_BASKET":

            if (this.profile && this.profile.data.profile) {

              this.$store.dispatch("GET_GROUP_BASKET_SUMMARY", this.groupPageGroupUUID).then(() => {
                const addItemRequest = {
                  userName: '',
                  basketUUID: this.groupBasket.uuid,
                  OrderItemRequest: this.getOrderItemRequest(payload)
                }

                addItemRequest.userName = this.profile.data.profile.name;

                this.$store.dispatch('JOIN_TO_GROUP_BASKET', addItemRequest).then(() => {
                  this.pushMixpanelEvent(
                    this.mixpanelEvents.joinGroup.event,
                    this.mixpanelEvents.joinGroup.properties(
                      "New Login"
                    )
                  );
                  this.modalToggler('create-basket-modal', 'hide');

                  this.changeGroupVisibility(true);
                }).catch((err) => {
                  this.handleGroupError(err.response.data.error, function () {
                    this.handleGenericErrors(genericErrorsEnum.generic, 'join-group', this.joinGuestPayload);
                  })


                })
              });

            }
            else {
              this.$store.dispatch("GET_GROUP_BASKET_SUMMARY", this.groupPageGroupUUID).then(() => {
                this.modalToggler('create-basket-modal', 'show');
                //this.toggleBasket()
              })
              this.joinGuestPayload = payload;

            }

            break;
          case "HAS_BASKET_IN_THIS_RESTAURANT":
            this.isGroupBasket = true;
            this.modalToggler("discard-basket-modal", "show");
            // this.$store.dispatch("CONVERT_USER_BASKET_TO_GROUP").then(() => {
            //   this.groupURL = window.location.origin + (this.$store.state.groupBasket && this.$store.state.groupBasket.data.link);
            //   $("#start-grouping-modal").modal("show");
            // }).catch((err)=>{
            //   this.handleGenericErrors(genericErrorsEnum.generic, 'convert');              
            // });
            break;
          case "HAS_BASKET_IN_ANOTHER_RESTAURANT":

            this.isGroupBasket = true;
            this.modalToggler("discard-basket-modal", "show");
            break;
          case "MEMBER_IN_ANOTHER_GROUP":

            this.modalToggler('leave-another-group-modal', 'show');
            break;
          case "MEMBER_IN_THIS_GROUP":

            if (navigator.onLine) {

              this.$store.commit('addToBasket', payload);
              this.$store.dispatch('ADD_ITEM_TO_GROUP_BASKET', { OrderItemRequest: this.getOrderItemRequest(payload), basketUUID: this.basketCompact.uuid }).then(() => {
                this.changeGroupVisibility(true);
              }).catch((err) => {
                this.handleGroupError(err.response.data.error, function () {
                  vue.handleGenericErrors(genericErrorsEnum.item, 'add', payload.itemModal, null, vue.basketCompact.uuid);
                });
              })
            }
            else {
              vue.handleGenericErrors(genericErrorsEnum.internet, 'add', payload.itemModal, null, vue.basketCompact.uuid);
            }
            break;
        }
      },
      closeBasket() {
        this.basket.visible = false;
      },
      closeGroupBasket() {
        this.groupBasket.visible = false;
      },
      getSizePrice(sizeUUID: string) {
        return this.sizes[sizeUUID].price;
      },
      calcItemSubTotal() {
        let sizePrice = this.getSizePrice(this.itemModal.itemData.selectedSizeUUID);


        this.itemModal.isExCatsValid = true;

        const sizeQuantityPrice = sizePrice * this.itemModal.itemData.quantity;

        let extrasPrice = 0;
        let isExCatsValid = true;

        for (let exCatUUID in this.itemModal.flatExtraCategories) {
          let exCat = this.itemModal.flatExtraCategories[exCatUUID];

          if (exCat.sizeRestricted) {

            let sizes: any[] = [];

            for (let exSizeUUID in exCat.flatSizes) {

              let exSize = exCat.flatSizes[exSizeUUID];
              exSize.sizeUUID == this.sizes[this.itemModal.itemData.selectedSizeUUID].sizeUUID && sizes.push(exSize);
            }

            (sizes.length && !(exCat.minimumAllowedExtra <= exCat.selectedItems.length)) && (isExCatsValid = false);

          } else {
            !(exCat.minimumAllowedExtra <= exCat.selectedItems.length) && (isExCatsValid = false);
          }



          extrasPrice += exCat.selectedItems.reduce((sum, sizeUUID) => sum + exCat.flatSizes[sizeUUID].price, 0);
        }
        this.itemModal = Object.assign({}, this.itemModal, {
          isExCatsValid,
          itemSubTotal: sizeQuantityPrice + (this.itemModal.itemData.quantity * extrasPrice)
        });

      },
      openCheckoutModal() {
        if (window['fcWidget'] && !window['fcWidget'].isInitialized()) {
          try {
            this.initChat()
          } catch (error) {
            console.log(`Error while init FreshChat`, error)
          }
        }
        this.$store.commit('updateCheckoutVisibility', true);
      },

      closeCheckoutModal() {
        this.locationDetailsFoundError = false;
        this.detectLocationPermissionError = false;
        if (this.step2Flag) {
          this.$store.commit('setCheckoutStep', 2);
        }
        this.$store.commit('updateHasErrorProperty', false)
        this.$store.commit('UpdatePlaceOrderErrors', null)
        this.$store.commit("setBasketLoading", null);

        if (this.basket.checkout.showOrderSuccess) {
          clearInterval(this.groupSummaryInterval);
          clearInterval(this.compactBasketInterval);
          this.$store.commit(`emptyBasket`);
          this.$store.commit(`emptyGroup`);
        }
        this.$store.commit('updateCheckoutVisibility', false);
        this.clearCheckoutErrors();
        this.$store.commit('updateOrderSuccessVisibility', false)
        this.basket.disableSubmit = false;
        this.checkoutCycle.step = 0;

        this.user.openAddAddress = false;
        this.modalToggler('checkout-modal', 'hide');
      },
      unlockBasket() {

        this.$store.commit('UpdatePlaceOrderErrors', null)
        this.$store.dispatch('UNLOCK_BASKET', this.groupBasket.uuid).then(() => {
          this.closeCheckoutModal();
        }).catch(() => {

        });

      },
    
      cityAreasChangeHandler(cityUUID) {
        document.querySelector('.user-area-modal #cities-list').scrollTo(0, 0);
        this.cityAreasSelected = cityUUID;
        this.areasList = this.cityAreas[cityUUID];
        this.zonesList = []
        this.areaZonesSelected = ''
      },
 
      areaZonesChangeHandler(areaUUID) {
        document.querySelector('.user-area-modal #areas-list').scrollTo(0, 0)
        this.areaZonesSelected = areaUUID;
        this.zonesList = this.flattenDeliveryAreaZones[areaUUID].zones;

      },
      allAreaZonesChangeHandler(areaUUID) {
        document.querySelector('.user-area-modal #areas-list').scrollTo(0, 0);
        this.areaZonesSelected = areaUUID;
        this.zonesList = this.areaZones[areaUUID];
        this.pushAreaClickingEvent(areaUUID);
      },
      removeSelectedCity() {
        this.cityAreasSelected = '';
        this.clearSearch();
        this.removeSelectedArea();
      },
      removeSelectedArea() {
        this.areaZonesSelected = '';
        this.zonesList = [];
      },
      removeSelectedUserArea(url) {
        this.removeSelectedArea()
        this.restPageFlag = true;
        // this.deliveryStatusChangeHandler();
        this.restURL = url;
      },
      toogleRemoveCityArea() {
        this.areaZonesSelected != '' ? this.removeSelectedArea() : this.removeSelectedCity();
        this.clearSearch();
      },
      addressTouchedHandler() {
        if (!this.checkoutCycle.addressForm.addressTouched) this.checkoutCycle.addressForm.addressTouched = true;
      },
      mapTouchedHandler() {
        pushGoogleAnalyticsEvent(
          this.googleAnalyticsEvents.checkout.events.pin_map.event,
          this.googleAnalyticsEvents.checkout.events.pin_map.label,
          this.googleAnalyticsEvents.checkout.category
        );
        this.checkoutCycle.addressForm.mapTouched = true;
      },
     
      initMap(pos) {
        map = new google.maps.Map(document.getElementById(this.addressMapId), {
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          center: { lat: pos.lat, lng: pos.lng },
          zoom: 15,
          streetViewControl: false
        });

        $('<div/>').addClass('centerMarker').appendTo(map.getDiv().firstElementChild);

        const updateAddress = (lat, long) => {
          this.pinFlag = 'updated';
          if ((lat != this.location.lat || long != this.location.lon)) {
            this.location = {
              lat: lat,
              lon: long
            }
            this.showEditModal = true;
          } else {
            this.showEditModal = false;
          }
          // added to set city, area, zone
          this.newDetectLocation(lat, long).then((res) => {
            this.locationDetailsFoundError = (res.city && res.area && res.zone) ? false : true;
            this.updateUserAddressLocation({ locationInfo: res, position: { coords: { latitude: lat, longitude: long } } });
          })
        
          this.mapUpdated = true;

          this.$store.commit('UpdatePlaceOrderErrors', null);
        }
       

        function gEventCallback(e) {
          vue.checkoutCycle.addressForm.location = {
            lat: this.getCenter().lat(),
            lon: this.getCenter().lng()
          }

          updateAddress(this.getCenter().lat(), this.getCenter().lng());
          vue.$store.commit('UpdatePlaceOrderErrors', null);

        }

        google.maps.event.addListener(map, 'dragend', gEventCallback);
        google.maps.event.addListener(map, 'zoom_changed', gEventCallback);

      },

      addAutoCompleteSearch() {
        // Create the search box and link it to the UI element.
        const input = document.getElementById("pac-input");
        const options = {
          fields: ["formatted_address", "geometry", "name"],
          strictBounds: false,
          types: ["establishment"],
        };
        const autocomplete = new google.maps.places.Autocomplete(input, options);
        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo("bounds", map);
        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          const position = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };
          this.initMap(position);

          vue.checkoutCycle.addressForm.location = {
            lat: position.lat,
            lon: position.lng
          }

          // updateAddress(this.getCenter().lat(), this.getCenter().lng());
          
          if ((position.lat != this.location.lat || position.lng != this.location.lon)) {
            this.location = {
              lat: position.lat,
              lon: position.lng
            }
          }
          this.newDetectLocation(position.lat, position.lng).then((res) => {
            this.locationDetailsFoundError = (res.city && res.area && res.zone) ? false : true;
            res.zone && this.getZonePolygon(res.zone.uuid, false);
            this.updateUserAddressLocation({ locationInfo: res, position: { 
              coords: { latitude: position.lat, longitude: position.lng } 
            } });
          });
          this.mapUpdated = true;
        });

        google.maps.event.addDomListener(input, 'keydown', function(e) { 
          if (e.keyCode == 13) { 
            e.preventDefault();
          }
        }); 
      
      },

      

      getCurrentLocation(id) {
        this.addressMapId = id;
        if (navigator.geolocation && this.isMobile) {
          this.refreshAddressMap();

          navigator.geolocation.getCurrentPosition(
            (position) => {
              var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              this.initMap(pos);
              this.addAutoCompleteSearch();
            },
            () => {

              this.checkoutCycle.addressForm.city = this.flatCities[this.user.cityUUID] ? this.flatCities[this.user.cityUUID].name : '';
              this.checkoutCycle.addressForm.area = this.flatAreas[this.user.areaUUID] ? this.flatAreas[this.user.areaUUID].name : ''
              this.checkoutCycle.addressForm.zone = this.flatZones[this.user.zoneUUID] ? this.flatZones[this.user.zoneUUID].name : ''

              this.checkoutCycle.addressForm.cityUUID = this.user.cityUUID
              this.checkoutCycle.addressForm.areaUUID = this.user.areaUUID
              this.checkoutCycle.addressForm.zoneUUID = this.user.zoneUUID


              if (this.user.zoneUUID && this.flatZones[this.user.zoneUUID].centerLocation) {

                this.initAddAddressMap(this.flatZones[this.user.zoneUUID].centerLocation.lat, this.flatZones[this.user.zoneUUID].centerLocation.lon)


              }
              else if (this.user.areaUUID && this.flatAreas[this.user.areaUUID].centerLocation) {
                this.initAddAddressMap(this.flatAreas[this.user.areaUUID].centerLocation.lat, this.flatAreas[this.user.areaUUID].centerLocation.lon)

              }
              else {
                this.initAddAddressMap(egypt.lat, egypt.lon)

              }

            },
            {
              enableHighAccuracy: true
            }
          );
        }
      },
      initAddAddressMap(lat, long, zoom = 17) {
        if (lat == 0 && long == 0 && this.mapUpdated) {
          lat = egypt.lat;
          long = egypt.lon;
          zoom = 15;
        }

        var pos = {
          lat: lat,
          lng: long
        }
        this.initMap(pos);
        this.addAutoCompleteSearch();
      },
      acceptChangeAddress(uuid) {
        this.modalToggler('update-address-modal', 'hide');
        this.prepareAddressRequest();
      },
      checkAddressUpdate() {
        (this.addressPolygonZone &&
          this.checkoutCycle.addressForm.zoneUUID !== this.addressPolygonZone) ?

          this.modalToggler('update-address-modal', 'show')
          : this.prepareAddressRequest();


      },
      addressCityChangeHandler(cityUUID) {
        this.checkoutCycle.addressForm.cityUUID = cityUUID;
        this.checkoutCycle.addressForm.areaUUID = null;
        this.checkoutCycle.addressForm.zoneUUID = null;
        this.$nextTick(() => {
          this.initAddAddressMap(
            egypt.lat, egypt.lon, 8
          )
        })
      },
      addressAreaChangeHandler(areaUUID) {
        this.checkoutCycle.addressForm.areaUUID = areaUUID;
        this.checkoutCycle.addressForm.zoneUUID = null;
        this.$nextTick(() => {
          this.initAddAddressMap(
            this.flatAreas[this.checkoutCycle.addressForm.areaUUID] && this.flatAreas[this.checkoutCycle.addressForm.areaUUID].centerLocation.lat,
            this.flatAreas[this.checkoutCycle.addressForm.areaUUID] && this.flatAreas[this.checkoutCycle.addressForm.areaUUID].centerLocation.lon
          )
        })
      },
      addressZoneChangeHandler(zoneUUID) {
        this.checkoutCycle.addressForm.zoneUUID = zoneUUID;

      },
      prepareAddressRequest() {
        const addressForm = this.checkoutCycle.addressForm;
        this.$store.commit('UpdatePlaceOrderErrors', null);
        const addressRequestData = {
          fullName: addressForm.fullName,
          phoneNumber: addressForm.phoneNumber,
          cityUUID: addressForm.cityUUID,
          areaUUID: addressForm.areaUUID,
          zoneUUID: addressForm.zoneUUID,
          location: addressForm.location,
          address: addressForm.address,
          deliveryInstructions: addressForm.landmark || null,
          buildingNumber: addressForm.buildingNumber,
          floor: addressForm.floorNumber || null,
          apartmentNumber: addressForm.apartmentNumber || null,
          companyName: addressForm.isCompany ? addressForm.companyName : null,
          company: addressForm.isCompany,
          default: addressForm.default
        };
        const method = (
          (this.user.flatAddresses && this.user.flatAddresses[addressForm.addressUUID])
          || this.checkoutCycle.addressForm.addressUUID) ? 'PUT' : 'POST';
        const endpoint = method == 'PUT'
          ? servicesURL.profile.editAddress(addressForm.addressUUID)
          : servicesURL.profile.addAddress;

        this.submitAddressForm(method, endpoint, addressRequestData)


      },
      showVerifyPhoneModel() {
        $body.scrollTo(0, 0);
        this.modalToggler(this.verifyPhoneModel.selectorID, 'show');
        this.pushMixpanelEvent(
          this.mixpanelEvents.phoneVerification.event,
          this.mixpanelEvents.phoneVerification.properties(
            this.verifyPhoneModel.selectedAddressPhone ? this.verifyPhoneModel.selectedAddressPhone : "N/A"
          )
        )
        pushGoogleAnalyticsEvent(
          this.googleAnalyticsEvents.checkout.events.phone_verification.event,
          this.googleAnalyticsEvents.checkout.events.phone_verification.label,
          this.googleAnalyticsEvents.checkout.category
        );
      },
      hideVerifyPhoneModel() {
        this.modalToggler(this.verifyPhoneModel.selectorID, 'hide');
        this.verifyPhoneModel.showVerifyError = true;
        this.verifyPhoneModel.disableInput = false;
      },
      submitAddressForm(method, endpoint, requestData) {
        axios({
          method,
          url: endpoint,
          headers,
          data: JSON.stringify(requestData)
        })
          .then(res => {
            if (!res.data.data.verified) {
              this.showVerifyPhoneModel();
              this.sendVerificationCode(res.data.uuid);
              this.verifyPhoneModel.selectedAddressUUID = this.checkoutCycle.addressForm.addressUUID = res.data.uuid;
              this.verifyPhoneModel.selectedAddressPhone = res.data.data.phoneNumber;
            } else {
              this.$store.state.basket.checkout.currentStep == 1 ?
                this.$store.dispatch(`GET_USER_BASKET_ADDRESSES`) :
                this.getAllAddresses();
            }
            pushGoogleAnalyticsEvent(
              this.googleAnalyticsEvents.checkout.events.add_address_success.event,
              this.googleAnalyticsEvents.checkout.events.add_address_success.label,
              this.googleAnalyticsEvents.checkout.category
            );
            this.$store.commit('UpdatePlaceOrderErrors', null);
          })
          .catch(error => {
            console.log("error", error)
          });

      },
      setVerificationTimer() {
        this.verifyPhoneModel.timer = 60;
      },
      startVerificationTimer() {

        clearInterval(this.verifyPhoneModel.timerInterval);

        this.verifyPhoneModel.timerEnabled = true;
        this.verifyPhoneModel.timerInterval = setInterval(() => {
          this.verifyPhoneModel.timer--;
          this.verifyPhoneModel.timer == 0 && this.stopVerificationTimer();
        }, 1000);

      },
      stopVerificationTimer() {
        this.verifyPhoneModel.timerEnabled = false;
        clearInterval(this.verifyPhoneModel.timerInterval);
      },
      sendVerificationCode(addressUUID) {
        this.setVerificationTimer();
        this.startVerificationTimer();
        axios({
          method: "POST",
          url: servicesURL.profile.sendVerification(addressUUID),
          headers
        })
          .then(res => console.log("res", res))
          .catch(error => console.log("error", error))
      },
      verificationInputHandler(e) {
        if (e.target.value.length == $(e.target).attr('maxlength')) this.verifyNumber(e, e.target.value);
      },
      verifyNumber(e, verificationCode) {
        this.verifyPhoneModel.disableInput = true;
        axios({
          method: "POST",
          url: servicesURL.profile.verifyNumber(this.verifyPhoneModel.selectedAddressUUID),
          headers,
          data: JSON.stringify({ code: verificationCode })
        })
          .then(res => {
            this.hideVerifyPhoneModel();
            if(this.$store.state.basket.checkout.currentStep != 0) {
              if (this.$store.state.basket.checkout.currentStep == 2) {
                this.$store.dispatch(`GET_USER_BASKET_ADDRESSES`)

              }
              else {
                this.checkoutGoToStep1();
              }
            }
            

            e.target.value = '';
            this.verifyPhoneModel.showVerifyError = false;
            this.verifyPhoneModel.selectedAddressUUID = this.verifyPhoneModel.selectedAddressPhone = null;
            pushGoogleAnalyticsEvent(
              this.googleAnalyticsEvents.checkout.events.phone_verified_success.event,
              this.googleAnalyticsEvents.checkout.events.phone_verified_success.label,
              this.googleAnalyticsEvents.checkout.category
            );
          })
          .catch(error => {
            console.log("error", error);
            e.target.value = '';
            this.verifyPhoneModel.showVerifyError = true;
            this.verifyPhoneModel.disableInput = false;
          });

      },
      emptyAddressForm(isAddFromCheckout = false) {
        let zoneUuid, areaUuid, cityUuid, cityName, areaName, zoneName;
        if (isAddFromCheckout && this.basket.ref.zoneUUID) {
          zoneUuid = this.basket.ref.zoneUUID;
          areaUuid = this.flatZones[this.basket.ref.zoneUUID].areaUUID;
          cityUuid = this.flatAreas[areaUuid].cityUUID;

        }
        else {
          zoneUuid = this.user.zoneUUID;
          areaUuid = this.user.areaUUID;
          cityUuid = this.user.cityUUID;
        }
        zoneName = zoneUuid && this.flatZones[zoneUuid] ? this.flatZones[zoneUuid].name : '';
        areaName = areaUuid && this.flatAreas[areaUuid] ? this.flatAreas[areaUuid].name : '';
        cityName = cityUuid && this.flatCities[cityUuid] ? this.flatCities[cityUuid].name : '';

        this.checkoutCycle.addressForm.fullName = this.profile && this.profile.data.profile ? this.profile.data.profile.name : null;
        this.checkoutCycle.addressForm.phoneNumber = null;
        this.checkoutCycle.addressForm.cityUUID = cityUuid;
        this.checkoutCycle.addressForm.areaUUID = areaUuid;
        this.checkoutCycle.addressForm.zoneUUID = zoneUuid;
        this.checkoutCycle.addressForm.city = cityName;
        this.checkoutCycle.addressForm.area = areaName;
        this.checkoutCycle.addressForm.zone = zoneName;
        this.checkoutCycle.addressForm.address = null;
        this.checkoutCycle.addressForm.landmark = null;
        this.checkoutCycle.addressForm.buildingNumber = null;
        this.checkoutCycle.addressForm.floorNumber = null;
        this.checkoutCycle.addressForm.apartmentNumber = null;
        this.checkoutCycle.addressForm.companyName = null;
        this.checkoutCycle.addressForm.isCompany = false;
        this.checkoutCycle.addressForm.default = false;
        this.checkoutCycle.addressForm.addressUUID = null;
        this.checkoutCycle.addressForm.location = null;
        this.checkoutCycle.addressForm.pin = null;
        this.checkoutCycle.addressForm.addressTouched = false;
        this.checkoutCycle.addressForm.mapTouched = false;
      },
      validateFormData(scope, val) {
        this.pinFlag = (this.pinFlag == 'updated') ? 'updated' : 'notUpdated';
        if (this.pinFlag == 'updated') {
          this.validateBeforeSubmit(scope, val);
        }
      },
      validateBeforeSubmit(scope, val) {
        this.$validator.validateAll(scope).then(result => {
          if (result) { // if valid
            switch (scope) {
              case 'addressForm':
                this.checkAddressUpdate();
                break;
              case 'loginForm':
                // this.submitLoginForm(isNotCheckout);
                break;
              case 'signupForm':
                // this.submitSignupForm(isNotCheckout);
                break;
              case 'guestForm':
                this.joinGuest(val);
                break;
              default:
                break;
            }
          }
          // if not valid
          $($(`#${scope}`).data('ref')).animate({
            scrollTop: 0
          }, 500);

        });
      },
   
      clearForm() {
        this.detectLocationPermissionError = false;
        this.locationDetailsFoundError = false;
        this.errors.items = []
        this.$refs.addAddress.reset();
      },
      getAllAddresses() {
        axios({
          method: "GET",
          url: servicesURL.profile.getAllAddresses,
          headers
        })
          .then(res => {
            if (res.data.length) {
              this.user.addresses = res.data;
              this.user.sortedAddresses = this.sortUserAddresses(res.data);
              this.user.flatAddresses = flatUserAddresses(res.data);
              this.user.focusedAddress == null && this.focusOnAddress(this.user.sortedAddresses[0].uuid);
              this.updateAddressFormVisibility(false, '', this.$store.state.basket.checkout.currentStep == 1 ? 'map2' : 'map1');
              this.emptyAddressForm();
            } else {
              this.updateAddressFormVisibility(true, 'add', this.$store.state.basket.checkout.currentStep == 1 ? 'map2' : 'map1');

            }
          })
          .catch(error => {
            console.log("error", error)
          });
      },
      focusOnAddress(addressUUID) {
        this.user.focusedAddress = this.user.flatAddresses[addressUUID];
        this.storeFocusedAddress()
      },
      storeFocusedAddress(){
        const chosenAddress = this.user.focusedAddress;
        this.setUserLocationCookies(chosenAddress.cityUUID, chosenAddress.areaUUID, chosenAddress.zoneUUID);
        this.setUserLatCookie(chosenAddress.location.lat);
        this.setUserLongCookie(chosenAddress.location.lon);
      },
      sortUserAddresses(userAddresses) {
        const finalSort = [];
        let canDeliverAddresses = [];
        const cannotDeliverAddresses = [];
        userAddresses.forEach(address => {
          if (address.data.default) {
            finalSort.push(address);
          } else if (this.flattenDeliveryAreaZones && this.flattenDeliveryAreaZones[address.ref.areaUUID]) {
            canDeliverAddresses.push(address);
          } else {
            cannotDeliverAddresses.push(address);
          }
        });

        canDeliverAddresses = canDeliverAddresses.concat(cannotDeliverAddresses);
        return finalSort.concat(canDeliverAddresses);

      },
     
      changeMapCenter(pos) {
        map.setCenter(pos);
      },
      updateAddressFormVisibility(isVisible, type, mapId) {

        this.user.openAddAddress = isVisible;
        this.showModal = false;
        this.addressMapId = mapId;

        if (isVisible) {
          this.mapUpdated = true;
          this.formType = type;
          this.$nextTick(() => {
            if (type != 'add') {
              this.initMap(this.checkoutCycle.addressForm.location.lat, this.checkoutCycle.addressForm.location.lon);
              this.addAutoCompleteSearch();
              this.addressPolygonZone = this.checkoutCycle.addressForm.zoneUUID
              this.getZonePolygon(this.addressPolygonZone, true, true);

            }
            else if (type == 'add') {
              let isAddFromCheckout = (mapId == 'map2');
              this.emptyAddressForm(isAddFromCheckout);
              this.clearForm();
              let data;
              this.newGetCurrentLocation().then(res => {
                data = res;
                let pos = { lat: res.position.coords.latitude, lng: res.position.coords.longitude }
                this.initMap(pos);
                this.addAutoCompleteSearch();
                this.updateUserAddressLocation(res);
                if (isAddFromCheckout) {
                  this.addressPolygonZone = this.basket.ref.zoneUUID
                  this.getZonePolygon(this.addressPolygonZone, false, true);
                  this.changeMapCenter(pos)
                }

              }).catch(() => {
                let zoneUUID;
                let areaUUID;
                if (mapId == 'map2' && this.basket.ref.zoneUUID) {
                  zoneUUID = this.basket.ref.zoneUUID;
                  areaUUID = this.flatZones[zoneUUID].areaUUID;
                }
                else {
                  zoneUUID = this.user.zoneUUID;
                  areaUUID = this.user.areaUUID;
                }
                this.noLocationInitMap(zoneUUID, areaUUID);
                this.addressPolygonZone = zoneUUID;
                zoneUUID && this.getZonePolygon(zoneUUID, true, isAddFromCheckout);

              })
            }
          });
          this.pushMixpanelEvent(this.mixpanelEvents.addAddress.event,
            this.mixpanelEvents.addAddress.properties(
              this.$store.state.basket.checkout.currentStep > 1 ? 'Checkout' : 'User Profile'
            ));
          pushGoogleAnalyticsEvent(
            this.googleAnalyticsEvents.checkout.events.add_address.event,
            this.googleAnalyticsEvents.checkout.events.add_address.label,
            this.googleAnalyticsEvents.checkout.category
          );
        }
        else {
          this.emptyAddressForm()
          this.clearForm()
        }

      },
      noLocationInitMap(zoneUUID, areaUUID) {
        this.locationDetailsFoundError = false;
        this.detectLocationPermissionError = false;
        let locationInfo = { zone: { uuid: null, data: { name: null } }, area: { uuid: null, data: { name: null } }, city: { uuid: null, data: { name: null } } }


        if (areaUUID && zoneUUID) { 
          if (this.flatZones[zoneUUID] && !(this.flatZones[zoneUUID].centerLocation.lat == 0 && this.flatZones[zoneUUID].centerLocation.lat == 0)) {
            this.initMap({
              lat: this.flatZones[zoneUUID].centerLocation.lat,
              lng: this.flatZones[zoneUUID].centerLocation.lon
            }
            );
            this.addAutoCompleteSearch();
            //  this.updateUserAddressLocation({ locationInfo, position: { coords: { latitude: this.flatZones[zoneUUID].centerLocation.lat, longitude: this.flatZones[zoneUUID].centerLocation.lon } } });

            this.location = {
              lat: this.flatZones[zoneUUID].centerLocation.lat,
              lng: this.flatZones[zoneUUID].centerLocation.lon
            }
          }
          else if (this.flatAreas[areaUUID] && !(this.flatAreas[areaUUID].centerLocation.lat == 0 && this.flatAreas[areaUUID].centerLocation.lat == 0)) {
            this.initMap({
              lat: this.flatAreas[areaUUID].centerLocation.lat,
              lng: this.flatAreas[areaUUID].centerLocation.lon
            }
            );
            this.location = {
              lat: this.flatAreas[areaUUID].centerLocation.lat,
              lng: this.flatAreas[areaUUID].centerLocation.lon
            }
            this.addAutoCompleteSearch();
            //   this.updateUserAddressLocation({ locationInfo, position: { coords: { latitude: this.flatAreas[areaUUID].centerLocation.lat, longitude: this.flatAreas[areaUUID].centerLocation.lon } } });
          }
          else {
            let cityUUID = areaUUID ? this.flatAreas[areaUUID].cityUUID : null
            locationInfo.zone.uuid = zoneUUID;
            locationInfo.zone.data.name = zoneUUID ? this.flatZones[zoneUUID].name : null;
            locationInfo.area.data.name = areaUUID ? this.flatAreas[areaUUID].name : null;
            locationInfo.area.uuid = areaUUID;
            locationInfo.city.uuid = cityUUID;
            locationInfo.city.data.name = cityUUID ? this.flatCities[cityUUID].name : null;
            this.updateUserAddressLocation({ locationInfo, position: { coords: { latitude: null, longitude: null } } });
            this.initMap({ lat: egypt.lat, lng: egypt.lon });
            this.addAutoCompleteSearch();
          }
        }

        else {
          this.newDetectLocation(egypt.lat, egypt.lon).then((res) => {
            this.locationDetailsFoundError = (res.city && res.area && res.zone) ? false : true;
            this.updateUserAddressLocation({ locationInfo: res, position: { coords: { latitude: egypt.lat, longitude: egypt.lon } } });
          })
          this.initMap({ lat: egypt.lat, lng: egypt.lon })
          this.location = {
            lat: egypt.lat, lng: egypt.lon
          }
          this.addAutoCompleteSearch();
        }
      },
      refreshAddressMap() {

        if (getCookie(cookies.lat) && getCookie(cookies.long)) {

          this.initAddAddressMap(getCookie(cookies.lat), getCookie(cookies.long))

        } else {
          if (this.flatZones[this.user.zoneUUID] && this.flatZones[this.user.zoneUUID].centerLocation) {
            this.initAddAddressMap(
              this.flatZones[this.user.zoneUUID].centerLocation.lat,
              this.flatZones[this.user.zoneUUID].centerLocation.lon
            )
          }
          else if (this.flatAreas[this.user.areaUUID] && this.flatAreas[this.user.areaUUID].centerLocation) {
            this.initAddAddressMap(
              this.flatAreas[this.user.areaUUID].centerLocation.lat,
              this.flatAreas[this.user.areaUUID].centerLocation.lon
            )
          }
          else {
            this.initAddAddressMap(
              egypt.lat,
              egypt.lon,
              8
            )
          }

        }

      },
     
      checkoutGoToStep1WithFlag() {
        this.step2Flag = true;
        this.checkoutGoToStep1();
      },
      checkoutGoToStep1() {
        this.$store.commit('setCheckoutStep', 1);
        this.$store.dispatch(`GET_USER_BASKET_ADDRESSES`)
      },
      checkoutGoToStep2(userAddressUUID) {
        if (navigator.onLine) {
          if (this.isGroupMember && this.basketisGroup) {
            this.$store.dispatch('GET_USER_CREDIT_CARDS');
            this.$store.commit('setCheckoutStep', 2);
            window['gtag']('event', 'checkout_progress');
              pushGoogleAnalyticsEvent(
                this.googleAnalyticsEvents.checkout.events.final_screen.event,
                this.googleAnalyticsEvents.checkout.events.final_screen.label,
                this.googleAnalyticsEvents.checkout.category
              );
          } else {
            this.$store.dispatch(`UPDATE_USER_BASKET_ADDRESS`, userAddressUUID).then(() => {
              this.$store.dispatch('GET_USER_CREDIT_CARDS');
              this.$store.state.basket.checkout.currentStep == 1 && this.focusOnAddress(userAddressUUID);
              this.$store.commit('setCheckoutStep', 2);
              window['gtag']('event', 'checkout_progress');
              pushGoogleAnalyticsEvent(
                this.googleAnalyticsEvents.checkout.events.final_screen.event,
                this.googleAnalyticsEvents.checkout.events.final_screen.label,
                this.googleAnalyticsEvents.checkout.category
              );
            })
              .catch(() => {
                this.handleGenericErrors(genericErrorsEnum.generic);
              })
          }
        }
        else {
          this.handleGenericErrors(genericErrorsEnum.internet);
        }


      },
      setPromoData() {
        if (this.promoForm.currentStep == 1 || this.promoForm.message) {
          this.$store.commit('resetPromoForm');
          this.$store.commit('setShowGiftForm', false);
        } else {
          this.$store.commit('setPromoFormStep', 1);
        }
      },
      submitOrder() {
        if (getRemoteConfigAsBoolean(KEYS.Show_Delivery_Time_Prompt) 
            && !this.basket.didToggleDeliveryTime
            && this.basket.ref.branch.ramadanSettings.orderIftarEnabled) {
          if (
            (this.basket.ref.branch.ramadanSettings &&
              this.basket.ref.branch.ramadanSettings.orderIftarEnabled) ||
            !this.isGroupMember
          ) {
            this.$store.dispatch("UPDATE_DELIVERY_PROMPT_TOGGLE", true);
            this.modalToggler("delivery-time-prompt", "show");
            pushGoogleAnalytics4Event(
              this.profile,
              GA4Events.screen.deliverTimePrompt,
              {
                User_UUID: this.profile.uuid,
                Restaurant_UUID: this.basket.ref.restaurant.uuid,
              }
            );
          } else this.proceedWithOrder();
        } else this.proceedWithOrder();
      },
      async confirmDeliveryTimeAndSubmit() {
        this.modalToggler('delivery-time-prompt', 'hide');
        this.submitOrder();
      },
      proceedWithOrder() {
        this.addressMapId = "map2";
          if (navigator.onLine) {
            if (this.basket.ref.address.data.verified) {
              if (this.$store.state.unavailableItems.length == 0) {
                this.placeOrder();
              } else {
                this.modalToggler("bulk-remove-place-order", "show");
              }
            } else {
              this.showVerifyPhoneModel();
              this.sendVerificationCode(this.basket.ref.address.uuid);
              this.verifyPhoneModel.selectedAddressUUID =
                this.basket.ref.address.uuid;
              this.verifyPhoneModel.selectedAddressPhone =
                this.basket.ref.address.data.phoneNumber;
            }
          } else {
            this.handleGenericErrors(genericErrorsEnum.internet);
          }
      },
      bulkRemoveUnavailableItem() {
        if (navigator.onLine) {
          this.$store
            .dispatch(
              "REMOVE_BULK_FROM_BASKET",
              this.$store.state.unavailableItems
            )
            .then(() => {
              (this.$store.state.groupBasket.data.users ?
                this.$store.dispatch('GET_GROUP_BASKET_SUMMARY', this.groupBasket.uuid) : this.$store.dispatch('GET_USER_BASKET_SUMMARY'))
                .then(() => {
                  this.modalToggler('bulk-remove-place-order', 'hide');
                  this.submitOrder();
                })




            })
            .catch(() => {
              this.handleGenericErrors(genericErrorsEnum.generic);
            });
        } else {
          this.handleGenericErrors(genericErrorsEnum.internet);
        }
      },
      hidePlaceOrderItemUnavailableModal() {
        this.modalToggler('bulk-remove-place-order', 'hide');

      },
      flatOrderItems(orderItems) {
        return flatOrderItems(orderItems, this.items, this.sizes);
      },
    
      getCategoryItemsLength(items) {
        return items.reduce((count, current) => count + current.quantity, 0)
      },

      checkoutItemsCounter(method, catName, itemIndex) {
        this.checkoutCycle.flattenOrderItems[catName][itemIndex].quantity = this.counter(method, this.checkoutCycle.flattenOrderItems[catName][itemIndex].quantity);
        this.$store.commit('updateOrderItems', this.checkoutCycle.flattenOrderItems)
      },
      toggleActive(id, type, orderType, orderUUID) {

        if (type == 'people') {

          if (!document.getElementById(id).classList.contains("active")) {
            this.pushMixpanelEvent(
              this.mixpanelEvents.viewPeopleView.event,
              this.mixpanelEvents.viewPeopleView.properties(
                orderType == "CURRENT" ? "Current Orders" : "Previous Orders",
              ));
            pushAnalyticsEvent(
              analyticsEvents.myOrders.category,
              analyticsEvents.myOrders.events.peopleView,
            );
            orderType == "CURRENT" ? this.getPeopleSplitView(orderUUID) : this.getPeopleSplitView(orderUUID);
          }
        }



      },

      deleteAddressConfirm(addressUUID) {
        this.user.deleteAddressUUID = addressUUID;
      },
      modalToggler(modalId, method) {
        let modalIdIndex = this.bindConditionalClasses.indexOf(modalId);
        if (method == 'show') {
          modalIdIndex <= -1 && this.bindConditionalClasses.push(modalId);
          this.bindConditionalClasses.find(item => item.includes('modal')) && $body.classList.add('modal-open');
        }
        else {
          modalIdIndex != -1 && this.bindConditionalClasses.splice(modalIdIndex, 1);
          !this.bindConditionalClasses.find(item => item.includes('modal')) && $body.classList.remove('modal-open');
        }
      },
    
      deleteAddress(modalId) {
        axios({
          method: "DELETE",
          url: servicesURL.profile.deleteAddress(this.user.deleteAddressUUID),
          headers
        })
          .then(res => {
            this.user.addresses = this.user.addresses.filter(address => address.uuid !== this.user.deleteAddressUUID);
            this.user.sortedAddresses = this.sortUserAddresses(this.user.addresses);
            this.user.deleteAddressUUID = null;
            this.$store.state.basket.checkout.currentStep > 0 && this.$store.dispatch(`GET_USER_BASKET_ADDRESSES`);
            modalId && this.modalToggler(modalId, 'hide')
          })
          .catch(error => {
            console.log("error", error)
          });
      },
      openNotyf(type, message) {

        type == 'error' ? notyf.error(message) : notyf.success(message)
      },
      editAddressData(addressUUID, mapId) {
        this.errors.items = [];
        this.addressMapId = mapId;
        this.formType = 'edit';
        const address = this.user.flatAddresses[addressUUID];
        if (!address.location) {
          this.noLocationInitMap(address.zoneUUID, address.areaUUID);
          this.pinFlag = '';
        } else {
          this.location = address.location
          this.pinFlag = 'updated';
          this.user.openAddAddress = true;
          this.$nextTick(() => {
            this.initMap({ lat: address.location.lat, lng: address.location.lon })
            this.addAutoCompleteSearch();
          });
        }

        this.user.openAddAddress = true;
        this.checkoutCycle.addressForm.addressUUID = addressUUID;
        this.checkoutCycle.addressForm.fullName = address.fullName;
        this.checkoutCycle.addressForm.phoneNumber = address.phoneNumber;
        this.checkoutCycle.addressForm.cityUUID = address.cityUUID;
        this.checkoutCycle.addressForm.areaUUID = address.areaUUID;
        this.checkoutCycle.addressForm.zoneUUID = address.zoneUUID;
        this.checkoutCycle.addressForm.city = this.flatCities[address.cityUUID].name
        this.checkoutCycle.addressForm.area = this.flatAreas[address.areaUUID].name
        this.checkoutCycle.addressForm.zone = this.flatZones[address.zoneUUID].name
        this.checkoutCycle.addressForm.location = address.location;
        this.checkoutCycle.addressForm.address = address.address;
        this.checkoutCycle.addressForm.pin = address.pin;
        this.checkoutCycle.addressForm.landmark = address.deliveryInstructions;
        this.checkoutCycle.addressForm.buildingNumber = address.buildingNumber;
        this.checkoutCycle.addressForm.floorNumber = address.floor;
        this.checkoutCycle.addressForm.apartmentNumber = address.apartmentNumber;
        this.checkoutCycle.addressForm.isCompany = address.company;
        this.checkoutCycle.addressForm.companyName = address.companyName;
        this.checkoutCycle.addressForm.default = address.default;

        this.user.openAddAddress = true;
        this.addressPolygonZone = this.checkoutCycle.addressForm.zoneUUID;
        this.getZonePolygon(this.addressPolygonZone, address.location ? false : true)
        if (address.address) {
          this.addressTouchedHandler();
          this.mapTouchedHandler();
        }
      },
      setDefaultAddress(addressUUID) {
        axios({
          method: "PUT",
          url: servicesURL.profile.setDefaultAddress(addressUUID),
          headers
        })
          .then(res => {
            this.getAllAddresses();
            this.$store.state.basket.checkout.currentStep > 0 && this.$store.dispatch(`GET_USER_BASKET_ADDRESSES`);
          })
          .catch(error => {
            console.log("error", error)
          });
      },

      getPeopleSplitView(orderUUID: string) {
        this.getSelectedOrderPeopleView(orderUUID)
      },
      stopTracking() {
        clearInterval(this.user.orderTracking);
      },

      expectOrderDelivered(outForDeliveryTime, edt) {
        let returnValue = moment(new Date(outForDeliveryTime)).isSameOrBefore(moment().subtract(edt, 'minute'));
        // returnValue && this.stopTracking();
        return returnValue;
      },
      setOrderDelivered(orderUUID: string) {
        axios({
          method: "PUT",
          url: servicesURL.order.orderDelivered(orderUUID),
          headers
        })
          .then(res => {
            this.myordersPage.selectedCurrentOrder
              ? window.location.href = window.location.origin + window.location.pathname
              : this.user.currentOrders.count > 1 && this.getCurrentOrdersState();
          })
          .catch(error => {
            console.log("error", error)
          });
      },
      getCurrentOrdersState() {
        axios({
          method: "POST",
          url: servicesURL.order.allOrdersState,
          headers,
          data: JSON.stringify({
            page: 1,
            pageSize: 20
          })
        })
          .then(res => {
            this.user.currentOrdersFlat = flatTrackingOrders(res.data);
            this.user.currentOrders = res.data;
            // if (res.data.count) {
            //   this.getSelectedOrderStateDetails(
            //     this.myordersPage.selectedCurrentOrder
            //       ? this.myordersPage.selectedCurrentOrder.uuid
            //       : res.data.data[0].orderUUID
            //   );
            //   this.startTracking(
            //     this.myordersPage.selectedCurrentOrder
            //       ? this.myordersPage.selectedCurrentOrder.uuid
            //       : res.data.data[0].orderUUID
            //   );
            // }
          })
          .catch(error => {
            console.log("error", error)
          });
      },
     
   
      getSelectedOrderPeopleView(orderUUID: string) {
        this.setMyOrdersLoadingData(BasketLoadersEnum.myOrdersLoadingData);
        this.setMyOrdersLoadingDataError(false);
        axios({
          method: "GET",
          url: servicesURL.order.getMyOrderPeopleSplit(orderUUID),
          headers
        })
          .then(res => {
            this.myOrdersGroupUsers = res.data;
            this.setMyOrdersLoadingData(null);
            this.setMyOrdersLoadingDataError(false);
          })
          .catch(error => {
            console.log("error", error);
            this.setMyOrdersLoadingData(null);
            this.setMyOrdersLoadingDataError(true);
          });
      },
      deliveryStatusChangeHandler() {
        this.deliveryStatus.isDeliver = null;
      },
 
      deliveryStatusDetectLocationHandler(areaUUID, restURL) {
        this.deliveryStatus.isDeliver = null;
        const tabName = data.restaurantTabs.indexOf(window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1)) > -1 ? '/' + window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1) : '';
        const restaurantURL = `${window.location.origin + restURL + tabName}?area=${areaUUID}`;
        !this.isGroupOrderPage && (window.location.href = restaurantURL);
      },
     
    
      clearCheckoutErrors() {
        this.basket.checkout.confirmation && (this.basket.checkout.confirmation.error = null);
        if (this.promoRequest.errors) {
          this.promoRequest.errors = null;
          this.promoRequest.code = null;
        };
      },
      isFrom24Hours(date) {
        const from24 = moment().subtract(24, 'hours');
        return moment(new Date(date)).isSameOrAfter(from24);
      },
      isFrom6Hours(date) {
        const from6 = moment().subtract(6, 'hours');
        return moment(new Date(date)).isSameOrAfter(from6);
      },
      placeOrder() {
        this.basket.disableSubmit = true;
        if (navigator.onLine) {
          this.$store.dispatch(`PLACE_ORDER`, [this.user.company ? this.user.company.place_id : null, this.user.company ? this.user.company.name : null])
        }
        else {
          this.handleGenericErrors(genericErrorsEnum.internet);
        };
      },
      restaurantURL(rName, rId, city, tail, language) {
        return URLBuilder.restaurantURL(rName, rId, city, tail, language)
      },
      profileURL(userShortCode, userName, language, tail) {
        return URLBuilder.userProfile(userShortCode, userName, language, tail)
      },
      basketErrors() {
        this.basketisGroup ?
          data.basketError.basketErrorMsg = Object.assign(data.basketError.basketErrorMsg, data.basketError.basketErrorEnum[this.$store.state.groupBasket.data.error])
          :
          data.basketError.basketErrorMsg = Object.assign(data.basketError.basketErrorMsg, data.basketError.basketErrorEnum[this.$store.state.basket.data.error]);
        data.basketHasError = true;
        if (data.basketError.basketErrorMsg.showModal) {
          this.modalToggler('basket-errors-modal', 'show');
        }
      },
      emptyBasketErrors() {
        data.basketHasError = false;

      },
      handleGenericErrors(errorType, errorMethod, itemModal = {}, zoneUUID = null, basketUUID = null, basketItemUUID = null) {
        data.addItemIndex++;
        data.itemsErrors.push({
          addItemIndex: data.addItemIndex,
          payload: {
            zoneUUID,
            itemModal,
            basketUUID,
            basketItemUUID
          },
          method: errorMethod,
          state: 'fail'
        });

        switch (errorType) {
          case genericErrorsEnum.internet:
            errorMethod == undefined ? this.modalToggler("internet-error-without-retry", "show") :
              this.modalToggler("internet-error-modal", "show");
            pushAnalyticsEvent(
              analyticsEvents.ordering.category,
              analyticsEvents.ordering.events.genericError,
              analyticsEvents.ordering.labels.errorType('internet')
            );

            break;
          case genericErrorsEnum.generic:
            errorMethod == undefined ? this.modalToggler("generic-errors-without-retry", "show") :
              this.modalToggler("generic-errors-modal", "show");
            pushAnalyticsEvent(
              analyticsEvents.ordering.category,
              analyticsEvents.ordering.events.genericError,
              analyticsEvents.ordering.labels.errorType('other')
            );

            break;
          case genericErrorsEnum.item:
            this.modalToggler("retry-basket-modal", "show");
            pushAnalyticsEvent(
              analyticsEvents.ordering.category,
              analyticsEvents.ordering.events.genericError,
              analyticsEvents.ordering.labels.errorType('Server Error')
            );
            break;
        }

      },
      handleGroupNoLongerActive(placed) {
        clearInterval(this.groupSummaryInterval);
        clearInterval(this.compactBasketInterval);
        if (window.location.href.indexOf('/group') > 0 && window.location.href.indexOf('?groupUUID') > 0) {
          this.alertClosed.redirect = true;
          this.alertClosed.URL = this.groupBasket.ref.restaurant.shortCode ?
            URLBuilder.restaurantURL(
              this.groupBasket.ref.restaurant ? this.groupBasket.ref.restaurant.name : '',
              this.groupBasket.ref.restaurant ? this.groupBasket.ref.restaurant.shortCode : '',
              this.userCityName ? this.userCityName : 'cairo', '',
              lang ? lang : 'EN',
              this.groupBasket.ref.branch ? ('-' + this.groupBasket.ref.branch.shortCode) : '') :
            window.location.href.replace('/group/', '/cairo/').split('?')[0]
        }
        this.$store.commit('emptyGroup');

        this.showAlert(
          placed ? staticContent.restaurant.basket.thankYou : staticContent.restaurant.basket.errors['SORRY'],
          placed ? staticContent.restaurant.basket.orderPlaced : staticContent.restaurant.basket.errors['NO_LONGER_ACTIVE'],
          placed ? "/public/img/check-mark.svg" : "/public/img/min-order-val.svg"
        );
      },
      handleLogOut() {
        $body.classList.remove('nav-opened');
        clearInterval(this.groupSummaryInterval);
        clearInterval(this.compactBasketInterval);
        this.$store.commit("setShowGiftForm", false);
        this.$store.commit('updateUserCreditCards', []);
        this.$store.commit("setPromoFormStep", 1);
        if (this.isGroupBasket)
          this.$store.commit('emptyGroup');
        else
          this.$store.commit('emptyBasket');
      },
      handleGroupLocked() {
        this.showAlert(staticContent.restaurant.basket.errors.SORRY, staticContent.restaurant.basket.errors.LOCKED, "/public/img/discard-basket.svg");
        this.$store.dispatch('GET_GROUP_BASKET_SUMMARY', this.basketCompact.uuid);
      },
      handleGroupError(err, fallback = null) {
        switch (err) {
          case "BASKET_IS_LOCKED":
            this.handleGroupLocked();
            break;
          case "BASKET_NOT_FOUND":
            this.handleGroupNoLongerActive(false);
            break;
          case "BASKET_PLACED":
            this.handleGroupNoLongerActive(true);
            break;
          case "USER_HAS_OLD_BASKET":
            this.discardBasket();
            break;
          case "BRANCH_UNAVAILABLE":
            this.basketErrors();
            clearInterval(this.groupSummaryInterval);
            clearInterval(this.compactBasketInterval);
            break;
          case "RESTAURANT_UNAVAILABLE":
            this.basketErrors();
            clearInterval(this.groupSummaryInterval);
            clearInterval(this.compactBasketInterval);
            break;
          case "ITEM_UNAVAILABLE":
            this.handleGenericErrors(genericErrorsEnum.generic);
            break;


          default:
            fallback && fallback();
            break
        }


      },
      noErrersOnBasket() {
        data.basketHasError = false;
      },
      updateScroll(id) {
        (document.querySelectorAll('.user-area-modal #' + id).length) &&
          console.log('update scroll')

        document.querySelector('.user-area-modal #' + id).scrollTo(0, 0);


      },
      copyText() {
        var copyText = document.getElementById("order-link") as HTMLInputElement;
        //copyText.select();
        copyText.focus();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");

        var tooltip = document.getElementById("copy-btn");
        tooltip.innerHTML = staticContent.restaurant.basket.copied
      },
      outFunc() {
        var tooltip = document.getElementById("copy-btn");
        tooltip.innerHTML = staticContent.restaurant.basket.copyToClipBoard;
      },
      onInfoIconHover(type) {
        switch(type) {
          case 'delivery': this.pushMixpanelEvent(this.mixpanelEvents.clickOnDeliveryInfo.event); break;
          case 'service': this.pushMixpanelEvent(this.mixpanelEvents.clickOnServiceInfo.event); break;
        }
      },
      copyPromoCode() {
        var promoCode = document.getElementById("promo-code").textContent;
        const elem = document.createElement('textarea');
        elem.value = promoCode;
        document.body.appendChild(elem);
        elem.select();
        document.execCommand('copy');
        document.body.removeChild(elem);
        
        var tooltip = document.getElementById("copy-promo");
        tooltip.innerHTML = staticContent.restaurant.basket.promoCopied
      },
    }
  });









  //#region: facebook scripts {{Start}}
  const fbGraphAPI = 'graph.facebook.com/v2.12/';

  // This is called with the results from from FB.getLoginStatus().
  function statusChangeCallback(response) {
    // The response object is returned with a status field that lets the
    // app know the current login status of the person.
    // Full docs on the response object can be found in the documentation
    // for FB.getLoginStatus().
    if (response.status === 'connected') {
      // Logged into your app and Facebook.
      userDataAPI(response);
    }
  }

  // This function is called when someone finishes with the Login
  // Button.  See the onlogin handler attached to it in the sample
  // code below.
  function checkLoginState() {
    FB.getLoginStatus(response => {
      statusChangeCallback(response);
    });
  }


  window['fbAsyncInit'] = () => {
    FB.init({
      appId: '130949746951756',
      cookie: false,  // enable cookies to allow the server to access 
      // the session
      xfbml: true,  // parse social plugins on this page
      version: 'v2.12' // use graph api version 2.12
    });

    // Now that we've initialized the JavaScript SDK, we call 
    // FB.getLoginStatus().  This function gets the state of the
    // person visiting this page and can return one of three states to
    // the callback you provide.  They can be:
    //
    // 1. Logged into your app ('connected')
    // 2. Logged into Facebook, but not your app ('not_authorized')
    // 3. Not logged into Facebook and can't tell if they are logged into
    //    your app or not.
    //
    // These three cases are handled in the callback function.


    $(document).on('click', '.facebook-login', () => {
      vue.pushMixpanelEvent(
        vue.mixpanelEvents.loginFacebook.event,
        vue.mixpanelEvents.loginFacebook.properties(
          vue.flatAreas[vue.user.areaUUID] ? vue.flatAreas[vue.user.areaUUID].name : 'N/A'
        )
      );
      FB.login(checkLoginState, { scope: 'email,user_birthday' });

    });
  };

  // Load the SDK asynchronously
  (((d, s, id) => {
    let js;
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk'));



  // Here we run a very simple test of the Graph API after login is
  // successful.  See statusChangeCallback() for when this call is made.
  function userDataAPI(response) {
    FB.api('/me?fields=id,name,email,birthday', userData => {
      !vue.profile.data.profile && vue.fbLogin(userData, response);
    });
  }

  //#endregion: facebook scripts {{End}}

  $(document).on('click', '.menus-tabs-header .tab-btn a', (e) => {
    e.preventDefault();
    $('.sticky-sizer').removeAttr('style');
    $(".menu-cats-sticky").css({ top: "0px", width: "100%" })
  });



  $(document).on('click', '.scroll-to-div', function (e) {

    e.preventDefault();

    $(this).parent().addClass('active').siblings().removeClass('active');

    $(window).scrollTop($($(this).attr('href')).offset().top - (windowWidth > 1024 ? 85 : 200));

  });

  $(".menus-tabs-header .nav.nav-tabs .tab-btn").click(function () {
    $('.restaurant-menu-tab .menu-tab .menu-cats-sticky').offset().top = 0
  });

  function menuCatsScrollHandler() {
    var catSection;
    var windowHeight = $(window).outerHeight();
    var timeout;
    var prevId = '';
    $(window).on('scroll', function () {
      if ($('.cat.active').offset()
        && document.documentElement.clientWidth >= 1024
        && ($('.cat.active').offset().top - $('#menu-cats-sticky').offset().top) > (window.innerHeight - 100)
        && document.documentElement.scrollTop + window.innerHeight < $('footer').offset().top) {
        vueScriptThis.shouldIstickToBottom = true;
      }
      else {
        vueScriptThis.shouldIstickToBottom = false;
      }
      var scroll = this.scrollY;
      if (scroll >= 0 && scroll <= 301) {
        vueScriptThis.shouldIStick = false

      }
      else {
        vueScriptThis.shouldIStick = true

      }

      clearTimeout(timeout);
      var activeMenuTab = $('.restaurant-menu-tab.active .menu-tab.active');

      timeout = setTimeout(function () {
        catSection = activeMenuTab.find('.cat-section');
        catSection.each(function (e) {
          var $this = $(this);
          if ($this.offset().top <= document.documentElement.scrollTop + (windowHeight * 0.5)) {
            prevId = $this.attr('id');
            var anchor = 'a[href="#' + prevId + '"]';
            var catBtn = $this.closest('.menu-tab').find(anchor).parent();

            catBtn.addClass('active').siblings().removeClass('active');
            if ($('.cat.active').offset()
              && document.documentElement.clientWidth >= 1024
              && ($('.cat.active').offset().top - $('#menu-cats-sticky').offset().top) > (window.innerHeight - 100)
              && document.documentElement.scrollTop + window.innerHeight < $('footer').offset().top) {
              vueScriptThis.shouldIstickToBottom = true;
            }
            else {
              vueScriptThis.shouldIstickToBottom = false;
            }
            var thisOffset = catBtn.offset();
            if (thisOffset && (thisOffset.left < 10 || thisOffset.left + catBtn.outerWidth() > windowWidth)) {
              var menuCatsDiv = $('#menu-cats-sticky');
              menuCatsDiv && menuCatsDiv.scrollLeft((menuCatsDiv.scrollLeft() + thisOffset.left) - menuCatsDiv.outerWidth() / 2);
            }
          }
        })
      }, 50);
    });

    window.addEventListener("resize", function () {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        windowHeight = window.outerHeight
      }, 100);
    });
  }
  $('.menu-tab .cat-section').length && menuCatsScrollHandler();


  function setCookie(cname, cvalue, path, expires = `${30 * 86400}`) {
    document.cookie = cname + "=" + cvalue + ";" + ";path=" + path + ";max-age=" + expires;
  }

  function getCookie(name) {
    name = name + "=";
    var arr = document.cookie.split(';');
    for (var i = 0; i < arr.length; i++) {
      var c = arr[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  var $branches = $('.area-section .area-branch-section');

  $('#branches-search input').keyup(function () {
    var pattern = new RegExp(($(this).val() + '').toLowerCase());

    $branches.each(function () {
      var $this = $(this);
      if (!$this.data('search').toLowerCase().match(pattern)) {
        $this.addClass('hide');
        var siblingsLength = $this.siblings().length;
        if (
          !siblingsLength
          || siblingsLength && siblingsLength == $this.siblings('.hide').length
        ) {
          $this.closest('.area-section').addClass('hide')
        }
      } else {
        $this.removeClass('hide').closest('.area-section').removeClass('hide')
      }
    });

  });


  $('#nav-btn').click(navBtnHandler);

  // document.getElementById('nav-btn').addEventListener('click', navBtnHandler)
  document.getElementById('dimmer') && document.getElementById('dimmer').addEventListener('click', function () {
    if ($body.classList.contains('nav-opened')) {
      $body.classList.remove('nav-opened');
      $body.classList.remove('filter-opened');
      removeClassFromElements('close-outside', 'active');
    }
    document.getElementsByClassName('menu-item-tooltip')[0] && vue.hideMenuItemTooltip();

  })

  function userBtnHandler() {
    if (windowWidth > 1024) {
      $body.classList.toggle('nav-opened');
    
    }
  }

  $(document).on('click', '#header .user-btn', userBtnHandler);

  function closeMobileNavInDesktop() {
    if (windowWidth > 1024) {
      $body.classList.remove('nav-opened');
    }
  }
  function closeMobileFilterInDesktop() {
    if (windowWidth > 1024) {
      $body.classList.remove('filter-opened');
    }
  }



  var horizontalScrollEnabled = false;
  function horizontalScroll(selector, bindEvent) {


    if (bindEvent) {

      selector.bind("mousewheel", MouseWheelHandler);
      selector.bind("DOMMouseScroll", MouseWheelHandler, false);

    } else {

      selector.unbind("mousewheel");
      selector.unbind("DOMMouseScroll");

    }

    function MouseWheelHandler(e) {

      // cross-browser wheel delta
      var e = window.event || e;
      if ($(e.target).closest('.no-h-scroll').length == 0) {

        e.preventDefault();
        var delta = - 20 * (Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail))));

        var scrollPX = selector.scrollLeft() + delta;

        selector.scrollLeft(scrollPX);

        return false;

      }
    }

  }

  function bindHorizontalScroll() {
    if (!horizontalScrollEnabled) {
      horizontalScrollEnabled = true;
      $('#restaurant-tabs-nav').length && horizontalScroll($('#restaurant-tabs-nav'), true);
      $('#menu-cats-sticky').length && horizontalScroll($('#menu-cats-sticky'), true);
      $('#filter-col .filter-col-inner').length && horizontalScroll($('#filter-col .filter-col-inner'), true);
    }
  }

  function unbindHorizontalScroll() {
    if (horizontalScrollEnabled) {
      horizontalScrollEnabled = false;
      $('#restaurant-tabs-nav').length && horizontalScroll($('#restaurant-tabs-nav'), false);
      $('#menu-cats-sticky').length && horizontalScroll($('#menu-cats-sticky'), false);
      $('#filter-col .filter-col-inner').length && horizontalScroll($('#filter-col .filter-col-inner'), false);
    }
  }

  function checkWindowForHorizontalScroll() {
    if (windowWidth > 1024) {
      unbindHorizontalScroll();
    } else {
      bindHorizontalScroll();
    }
  } checkWindowForHorizontalScroll();



  function restaurantTabsShownHandler() {

    $('.restaurant-tabs-section [data-toggle="tab"]').on('shown.bs.tab', function (e) {
      var activatedTabID = $(this).attr("href"); // activated tab id

      if (activatedTabID.indexOf('#menu') != -1) { // if contains '#menu-'
        vueScriptThis.bindConditionalClasses.push('menu-tab-activated')
        vueScriptThis.bindConditionalClasses.push('restaurant-tabs-section')


      } else {
        let modalIdIndex = vueScriptThis.bindConditionalClasses.indexOf('menu-tab-activated');
        modalIdIndex != -1 && vueScriptThis.bindConditionalClasses.splice(modalIdIndex, 1);
        modalIdIndex = vueScriptThis.bindConditionalClasses.indexOf('restaurant-tabs-section');
        modalIdIndex != -1 && vueScriptThis.bindConditionalClasses.splice(modalIdIndex, 1);
      }

    });
  } $('#restaurant-tabs-nav').length && restaurantTabsShownHandler();


  var resizingTimeout;

  function tagsSlider() {
    var $tagsSlider = Array.from(document.querySelectorAll('.tags-slider .tags'));
    var $tags = Array.from(document.querySelectorAll('.tags-slider'));

    $tagsSlider.forEach((item, i) => {
      var isBig = $tags[i].classList.contains('big-tags');

      let tagsGlider = new Glider(item, {
        slidesToShow: 'auto',
        slidesToScroll: 'auto',
        scrollLock: true,
        autoplay: false,
        infinite: false,
        duration: 1.5,
        arrows: {
          prev: isRTL ? (isBig ? '#next-btn' + i : '.next-btn') : (isBig ? '#prev-btn' + i : '.prev-btn'),
          next: isRTL ? (isBig ? '#prev-btn' + i : '.prev-btn') : (isBig ? '#next-btn' + i : '.next-btn')
        },
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 'auto',
              slidesToScroll: 'auto',
              exactWidth: true,
              itemWidth: 160
            }
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 'auto',
              slidesToScroll: 'auto',
              exactWidth: true,
              itemWidth: 160
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 'auto',
              slidesToScroll: 'auto',
              exactWidth: true,
              itemWidth: 150
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 'auto',
              slidesToScroll: 'auto',
              arrows: false,
              exactWidth: true,
              itemWidth: 140
            }
          },
          {
            breakpoint: 300,
            settings: {
              slidesToShow: 'auto',
              slidesToScroll: 'auto',
              arrows: false
            }
          }
        ]
      })
      isRTL && tagsGlider.scrollItem(item.children[0].childElementCount, false)
      if (window.location.href.indexOf('/delivery') != -1) {
        vueScriptThis.handleGliderScroll(tagsGlider)
      }
    })
  }
  document.querySelectorAll('.tags-slider .tags').length && tagsSlider();


  function offersSlider() {

    var $offersSlider = document.querySelector('.offers-slider .slides');
    if ($offersSlider) {
      offersGlider = new Glider($offersSlider, {
        slidesToShow: 4,
        slidesToScroll: 3,
        scrollLock: true,
        autoplay: true,
        infinite: true,
        duration: 1.5,
        arrows: {
          prev: isRTL ? '#offers-nxt' : '#offers-prv',
          next: isRTL ? '#offers-prv' : '#offers-nxt'
        },
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              autoplay: false,
              dots: false,
              infinite: false,
              variableWidth: true,
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 900,
            settings: {
              autoplay: false,
              dots: false,
              infinite: false,
              variableWidth: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              autoplay: false,
              dots: false,
              infinite: false,
              variableWidth: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false
            }
          },
          {
            breakpoint: 300,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              arrows: false
            }
          }
        ]
      })
      isRTL && offersGlider.scrollItem($offersSlider.children[0].childElementCount, false);

    }
  }

  function relatedRestaurantsSlider() {
    var $relatedSlider = Array.from(document.querySelectorAll('.related-restaurants-slider .slides'));
    if ($relatedSlider) {
      $relatedSlider.forEach((item, i) => {
        let relatedGlider = new Glider(item, {
          slidesToShow: 3,
          slidesToScroll: 3,
          scrollLock: false,
          autoplay: true,
          infinite: true,
          duration: 1.5,
          //  arrows: {
          //    prev: isRTL ? '#related-nxt' : '#related-prv',
          //    next: isRTL ? '#related-prv' : '#related-nxt'
          //  },
        });
        isRTL && relatedGlider.scrollItem(item.children[0].childElementCount, false)

      }
      );
    }

  }
  document.querySelectorAll('.related-restaurants-slider .slides').length && relatedRestaurantsSlider();

  function featuredPhotosSlider() {
    var $slider = Array.from(document.querySelectorAll('.photos-slider .featured-slider'));
    $slider.forEach(featuredSliderFn);

    function featuredSliderFn(item, i) {
      let featuredGlider = new Glider(item, {
        slidesToShow: 4,
        slidesToScroll: 4,
        scrollLock: true,
        autoplay: false,
        infinite: false,
        duration: 1.5,
        arrows: {
          prev: isRTL ? '#next' + i : '#prev' + i,
          next: isRTL ? '#prev' + i : '#next' + i
        }
        ,
        responsive: [
          {
            breakpoint: 300,
            settings: {
              slidesToScroll: "auto",
              slidesToShow: "auto",
              itemWidth: 150
            }
          }]
        //   {
        //     breakpoint: 1280,
        //     settings: {
        //       slidesToScroll: 2,
        //       slidesToShow: 2
        //     }
        //   },
        //   {
        //     breakpoint: 1024,
        //     settings: {
        //       slidesToShow: 3,
        //       slidesToScroll: 3,
        //     }
        //   },
        //   {
        //     breakpoint: 767,
        //     settings: {
        //       slidesToShow: 3,
        //       slidesToScroll: 3,
        //       variableWidth: false,
        //     }
        //   },
        //   {
        //     breakpoint: 550,
        //     settings: {
        //       slidesToShow: 2,
        //       slidesToScroll: 2,
        //       variableWidth: false,
        //     }
        //   },
        //   {
        //     breakpoint: 420,
        //     settings: {
        //       slidesToShow: 2,
        //       slidesToScroll: 2,
        //       variableWidth: false,
        //     }
        //   }
        // ]
      });
      isRTL && featuredGlider.scrollItem(item.children[0].childElementCount, false)

    }

  } document.querySelectorAll('.photos-slider .featured-slider').length && featuredPhotosSlider();

  function autoWidthSlider() {
    var $slider = Array.from(document.querySelectorAll('.restaurants-slider .rests'));
    $slider.forEach(RestSliderFun);

    function RestSliderFun(item, i) {
      let restGlider = new Glider(item, {
        slidesToShow: 4,
        slidesToScroll: 4,
        scrollLock: true,
        autoplay: false,
        infinite: false,
        duration: 1.5,
        arrows: {
          prev: isRTL ? '#next' + i : '#prev' + i,
          next: isRTL ? '#prev' + i : '#next' + i
        }
      });
      isRTL && restGlider.scrollItem(item.children[0].childElementCount, false)

    }
  }
  function destroyOffersSlider() {
    offersGlider && offersGlider.destroy();
    offersGlider = null;
  }

  function destroyRestaurantCardImagesSlider() {
    gliderArr.forEach(
      item => item.destroy()
    );
    gliderArr = [];
  }

  function restaurantCardImagesSlider() {
    // window.addEventListener('load', function () {
    var cardSliders = Array.from(document.querySelectorAll('.restaurant-card .card-inner .card-images-slider .slider-images'));
    cardSliders.forEach(function (item, i) {
      gliderArr[i] = new Glider(item, {
        slidesToShow: 1,
        slidesToScroll: 1,
        scrollLock: true,
        autoplay: false,
        infinite: false,
        duration: 1.5,
        dots: '#dots' + i,
        arrows: {
          prev: '#prev' + i,
          next: '#next' + i
        }
      });
      isRTL && gliderArr[i].scrollItem(item.children[0].childElementCount, false)


    })
    // })
  }




  var sliderArrowBtn = function (classes, svgIcon) {
    return (
      '<button type="button" class="slider-arrows ' + classes + '">' +
      '<svg viewBox="0 0 14 25">' +
      '<use xlink:href="#' + svgIcon + '"></use>' +
      '</svg>' +
      '</button>'
    );
  };

  function filterColMobile() {

    if (windowWidth > 1024) {
      $('#filter-col .filter-section .section-title').unbind('click').parent().removeClass('active');
      $('#filter-col .filter-section .apply-filters').unbind('click');
    } else {

      $('#filter-col .filter-section .apply-filters').bind('click', function () {
        $(this).parents('.filter-section').removeClass('active');
        document.getElementById('mobile-filters') && document.getElementById('mobile-filters').classList.remove('active');
        $body.classList && $body.classList.remove('filter-opened');
       
      });
      $('#filter-col .filter-section .section-title').bind('click', function () {
        $(this).parent().addClass('active');
        $body.classList.add('filter-opened')
       

      });
      document.getElementById('mobile-filters') && document.getElementById('mobile-filters').addEventListener('click', function () {
        document.getElementById('mobile-filters').classList.add('active');
        $body.classList.add('filter-opened')
      })
    }
  }
  filterColMobile();


  function loginSignupTabs() {
    var $modal = $('#login-signup-modal');
    console.log('modal', $modal.find('.login-signup-tabs [data-toggle="tab"]'))
    $modal.find('.login-signup-tabs [data-toggle="tab"]').on('shown.bs.tab', function (e) {
      var activatedTabID = $(this).attr("href");
      console.log('activatedTabID', activatedTabID);
      activatedTabID == '#signup-tab' ? $modal.find('.illustration-col').addClass('signup-active') : $modal.find('.illustration-col').removeClass('signup-active');
    });
  } $('#login-signup-modal').length && loginSignupTabs();


  window.addEventListener('resize', function () {
    clearTimeout(resizingTimeout);
    resizingTimeout = setTimeout(function () {

      windowWidth = document.documentElement.clientWidth;

      checkWindowForHorizontalScroll();

      if ($('.restaurant-tabs-section').length) {
        // checkWindowForMenuCats();
        closeMobileNavInDesktop();
        closeMobileFilterInDesktop();
        filterColMobile();
      }

    }, 100);
  })
  /*************Dismissing mixpanel notification *************/
  $(document).on('click', "#mixpanel-notification-mainbox *", function () {
    event.stopPropagation();
    return false
  });
  document.getElementById('mixpanel-notification-mainbox') && document.getElementById('mixpanel-notification-mainbox').addEventListener('click', function (event) {
    event.stopPropagation();
    return false
  })
  document.getElementById('mixpanel-notification-takeover') && document.getElementById('mixpanel-notification-takeover').addEventListener('click', function (event) {
    event.stopPropagation();
    document.getElementById('mixpanel-notification-wrapper').remove();
  })

}
//$(document).ready(scripts);
function ready(callbackFunc) {
  if (document.readyState !== 'loading') {
    // Document is already ready, call the callback directly
    callbackFunc();
  } else if (document.addEventListener) {
    // All modern browsers to register DOMContentLoaded
    document.addEventListener('DOMContentLoaded', callbackFunc);
  } else {
    // Old IE browsers
    (<any>document).attachEvent('onreadystatechange', function () {
      if (document.readyState === 'complete') {
        callbackFunc();
      }
    });
  }
}

ready(function () {
  scripts();
});